import { Component, ElementRef, HostListener, Injector, OnInit, ViewChild } from '@angular/core';
import { AbstractControl, FormArray, FormBuilder, FormGroup, ValidationErrors, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { DecisionRolePageService } from './decision-role-page.service';
import { forkJoin, Subject } from 'rxjs';
import { HttpService } from '@app/@core/services/http.service';
import { debounceTime, filter, map, switchMap, take, takeUntil } from 'rxjs/operators';
import moment from 'moment';
import { LocalService } from '@app/@core/services/local.service';
import { AlertService } from '@app/@core/services/alert.service';
import { DataStoreService } from '@pics-core/dynamic';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { MyApplicationsService } from '@app/pages/my-application/my-app-service.service';
import { DomSanitizer } from '@angular/platform-browser';
import { StripHtmlPipe } from '@app/@core/pipes/strip-html.pipe';


@Component({
  standalone: false,
  selector: 'app-decision-role-page',
  templateUrl: './decision-role-page.component.html',
  styleUrls: ['./decision-role-page.component.scss'],
  providers: [StripHtmlPipe]
})
export class DecisionRolePageComponent implements OnInit {
  @ViewChild('editor') editor!: any;
  licenseForm!: FormGroup;
  prolickindForm!: FormGroup;
  prolicendoForm!: FormGroup;
  editprolickindForm!: FormGroup;
  editprolicendoForm!: FormGroup;
  editprolicreqForm!: FormGroup;
  prolicreqForm!: FormGroup;
  adddecisionForm!: FormGroup;
  licenseKindData: any = [];
  endorsementData: any = [];
  addedLicenseKindData: any = [];
  applicationStatusData: any = [];
  licenseTypesData: any = [];
  endoPathwayData: any = [];
  today: Date = new Date();
  responsevalue: any = [];
  licenseRows: any = [];
  endorsementRows: any = [];
  licrequirementsData: any = [];
  licenseProvisionsData: any = [];
  licenseDurationData: any = [];
  decisionStatusHistoryData: any = [];
  showDnqCommunication = false;
  private dnqPathwayKey: string | number | null = null;
  additionalEndorsementsRequired = false;
  lickindProvTypedata: any = [];
  licendoProvTypedata: any = [];
  lickindProvTypedataCopy: any = [];
  licendoProvTypedataCopy: any = [];
  deficiencyCommentSubmitted: boolean = false;
  errorMessages: any = {};
  showDeficiencyTab: boolean = true;
  isNoCommentsAvailable: boolean = false;
  application_type: any;
  originalEditRequirementSourceIds: string[] = [];
  originalEditRequirementDueDate: string = '';
  provisionOptions = [
    { id: 1, name: 'Annual renewal required' },
    { id: 2, name: 'Additional documentation required' },
    { id: 3, name: 'Compliance verification required' }
  ];
  showModal: boolean = false;
  warningDateFieldLabel: 'Expiration Date' | 'Due Date' = 'Expiration Date';
  warningTitleLabel: 'Expiration Date Notice' | 'Due Date Notice' = 'Expiration Date Notice';
  showStatusModal: boolean = false;
  showIntakePendingModal: boolean = false;
  // licenseList: any[] = [
  //   {
  //     licenseKind: 'Business and Industry',
  //     licenseType: '',
  //     effectiveDate: '',
  //     expirationDate: '',
  //     endorsements: [
  //       {
  //         endorsement: '117',
  //         grade: '',
  //         pathway: '',
  //         originalEffectiveDate: '',
  //         effectiveDate: '',
  //         expirationDate: ''
  //       },
  //       {
  //         endorsement: '118',
  //         grade: '',
  //         pathway: '',
  //         originalEffectiveDate: '',
  //         effectiveDate: '',
  //         expirationDate: ''
  //       }
  //     ]
  //   },
  //   {
  //     licenseKind: 'Secondary - CTE',
  //     licenseType: '',
  //     effectiveDate: '',
  //     expirationDate: '',
  //     endorsements: [
  //       {
  //         endorsement: '122',
  //         grade: '',
  //         pathway: '',
  //         originalEffectiveDate: '',
  //         effectiveDate: '',
  //         expirationDate: ''
  //       }
  //     ]
  //   }
  // ];
  provisionRows = [
    {
      licenseKind: 'License/Endorsement',
      provision: 'License/Endorsement',
      dueDate: '15/01/2026',
      kindAdditionalText: ''
    },
    {
      licenseKind: 'License',
      provision: 'License',
      dueDate: '14/01/2026',
      kindAdditionalText: ''
    }
  ];

  requirementsList = [
    {
      endorsement: 'Music Therapist',
      provision: 'Certification',
      dueDate: '14/01/2026',
      additionalText: 'Must show proof of current licensure as a music therapist by the Nevada State Board of Health pursuant to NRS 640D.110.'
    }
  ];

  sourceOptions: any[] = [];
  editSourceOptions: any[] = [];

  typeOptions = [
    { key: 'License Kind', value: 'License Kind' },
    { key: 'Endorsement', value: 'Endorsement' }
  ];

  @ViewChild('licenseContent') licenseContent!: ElementRef;

  showLicensePopup: boolean = false;
  showDNQPopup: boolean = false;
  licenseData = {
    "licenseNumber": "LIC-123456",
    "userName": "test user",
    "licenseDetails": [
      {
        "license": "Business and Industry",
        "gradeLevel": "7-Adult",
        "originalIssueDate": "14/01/2026",
        "endorsements": "Accounting and Finance",
        "issueDate": "13/01/2026",
        "expirationDate": "13/01/2031"
      }
    ],
    "provisions": [
      { "type": "License/Endorsement", "description": "License/Endorsement", "dueDate": "15/01/2026" },
      { "type": "License", "description": "License", "dueDate": "14/01/2026" }
    ],
    "requirements": [
      {
        "type": "Music Therapist",
        "description": "Must show proof of current licensure as a music therapist by the Nevada State Board of Health pursuant to NRS 640D.110.",
        "dueDate": "14/01/2026"
      }
    ]
  }

  licenseRequirementRows: any = [];
  licensereq_descriptiondata: any = [];
  licKindProvisionRows: any = [];
  licEndoProvisionRows: any = [];
  showDialog1 = false;

  dnqText = '';
  statusval: any = '';
  displayMode: string = 'compact';
  isVisible = true;
  isActionVisible = true;
  isShowEdit: boolean = true;
  isShowDelete: boolean = true;
  provlickindeditbtn: boolean = false;
  provlicendoeditbtn: boolean = false;
  provlicreqeditbtn: boolean = false;
  editId: any = '';
  type: any = '';
  license_number: any;
  intakerole: boolean = true;
  deficiencyCommentsData: any = [];
  internalCommentsData: any = [];
  documentDeficiencyCommentsData: any = [];
  showdefcmntsEditPopup: boolean = false;
  showintcmtsEditPopup: boolean = false;
  rowdnqcomments: string = '<p></p>';
  showdefNotesPreview: boolean = false;
  defcmntpopupdata: string = '';
  roleId: any = '';
  analystrole: boolean = true;
  injector: Injector;
  dataStore: DataStoreService;
  private route: ActivatedRoute;
  licensekindendopop_descriptiondata: any = [];
  flattenedArray: any = [];
  endorsementOptionsPerLicense: any[] = [];
  lickindProvisionData: any = [];
  endorsementProvisionData: any = [];
  provisionSourceOptions: any[] = [];
  endorsementMinExpiryDate: any = null;

  form!: FormGroup;
  lickindgridConfig = [
    {
      columnDef: 'provision',
      header: 'Provision',
      filter: true,
      width: 200
    },
    {
      columnDef: 'provlicenseKind',
      header: 'License Kind',
      filter: true,
      width: 260
    },
    {
      columnDef: 'dueDate',
      header: 'Due Date',
      filter: true,
      dateFormat: 'date',
      width: 140
    },
    {
      columnDef: 'additionalText',
      header: 'Additional Text',
      filter: true,
      width: 260,
      truncate: true
    }
  ];
  licendogridConfig = [
    {
      columnDef: 'provision',
      header: 'Provision',
      filter: true,
      width: 200
    },
    {
      columnDef: 'provendorsement',
      header: 'Endorsement',
      filter: true,
      width: 260
    },
    {
      columnDef: 'dueDate',
      header: 'Due Date',
      filter: true,
      dateFormat: 'date',
      width: 140
    },
    {
      columnDef: 'additionalText',
      header: 'Additional Text',
      filter: true,
      width: 260,
      truncate: true

    }
  ];

  combinedProvisionGridConfig: any[] = [
    {
      columnDef: 'category',
      header: 'Category',
      filter: true,
      width: 140
    },
    {
      columnDef: 'source',
      header: 'Source',
      filter: true,
      width: 260,
      truncate: true
    },
    {
      columnDef: 'provision',
      header: 'Provision',
      filter: true,
      width: 200,
      truncate: true
    },
    {
      columnDef: 'dueDate',
      header: 'Due Date',
      filter: true,
      dateFormat: 'date',
      width: 140
    },
    {
      columnDef: 'additionalText',
      header: 'Additional Text',
      filter: true,
      width: 260,
      truncate: true
    },
    {
      columnDef: 'resolutionNotes',
      header: 'Resolution Notes',
      filter: true,
      width: 260,
      hide: true
    },
    {
      columnDef: 'resolvedDate',
      header: 'Resolved Date',
      filter: true,
      dateFormat: 'date',
      width: 150
    },
      { columnDef: 'updatedBy', header: 'Updated By', filter: true, width: 250 }
  ];

  combinedProvisionRows: any[] = [];

  // Resolution approve/deny
  resolutionProvisionValue: string = '';
  resolutionRowData: any = null;
  resolutionEditId: any = null;
  viewResolutionNotesText: string = '';

  updateCombinedProvisionRows(): void {
    const licRows = (this.licKindProvisionRows || []).map((item: any) => ({
      ...item,
      category: 'License Kind',
      source: item.provlicenseKind
    }));
    const endoRows = (this.licEndoProvisionRows || []).map((item: any) => ({
      ...item,
      category: 'Endorsement',
      source: item.provendorsement
    }));
    this.combinedProvisionRows = [...licRows, ...endoRows];
    this.updateResolutionNotesColumnVisibility();
  }

  updateResolutionNotesColumnVisibility(): void {
    const hasProvNotes = this.combinedProvisionRows.some(r => r?.resolutionNotes && String(r.resolutionNotes).trim().length > 0);
    this.combinedProvisionGridConfig = this.combinedProvisionGridConfig.map(col =>
      col.columnDef === 'resolutionNotes' ? { ...col, hide: !hasProvNotes } : col
    );

    const hasReqNotes = (this.licenseRequirementRows || []).some(r => r?.resolutionNotes && String(r.resolutionNotes).trim().length > 0);
    this.licreqgridConfig = this.licreqgridConfig.map(col =>
      col.columnDef === 'resolutionNotes' ? { ...col, hide: !hasReqNotes } : col
    );
  }

  licreqgridConfig: any[] = [
    {
      columnDef: 'type',
      header: 'Category',
      filter: true,
      width: 260
    },
    {
      columnDef: 'source',
      header: 'Source',
      filter: true,
      width: 260
    },
    {
      columnDef: 'requirement',
      header: 'License Requirement',
      filter: true,
      width: 260
    },
    {
      columnDef: 'reqdueDate',
      header: 'Due Date',
      filter: true,
      dateFormat: 'date',
      width: 140
    },
    {
      columnDef: 'resolutionNotes',
      header: 'Resolution Notes',
      filter: true,
      width: 260,
      hide: true
    },
    {
      columnDef: 'resolvedDate',
      header: 'Resolved Date',
      filter: true,
      dateFormat: 'date',
      width: 140
    },
      { columnDef: 'updatedBy', header: 'Updated By', filter: true, width: 200 }
  ];

  statushistorygridConfig = [
    {
      columnDef: 'applicationStatus',
      header: 'Application Status',
      filter: true,
      width: 260
    },
    {
      columnDef: 'updatedby',
      header: 'Updated By',
      filter: true,
      width: 260
    },
    {
      columnDef: 'updateddate',
      header: 'Updated Date',
      filter: true,
      dateFormat: 'date',
      width: 140
    }
  ];

  defcmntsgridConfig = [
    {
      columnDef: 'deficiency_type',
      header: 'Section',
      filter: true,
      width: 260,
      isHtml: false,
    },
    {
      columnDef: 'note_text',
      header: 'Notes',
      filter: true,
      width: 260,
      isHtml: true,
    },
    {
      columnDef: 'review_status',
      header: 'Status',
      filter: true,
      width: 260,
      isHtml: false,
    },
    {
      columnDef: 'created_date',
      header: 'Updated Date',
      filter: true,
      dateFormat: 'date',
      width: 140,
      isHtml: false,
    },
    {
      columnDef: 'created_by',
      header: 'Updated By',
      filter: true,
      width: 260,
      isHtml: false,
    }
  ];

  intcmntsgridConfig = [
    {
      columnDef: 'deficiency_type',
      header: 'Section',
      filter: true,
      width: 260,
      isHtml: false,
    },
    {
      columnDef: 'note_text',
      header: 'Notes',
      filter: true,
      width: 260,
      isHtml: true,
    },
    {
      columnDef: 'created_date',
      header: 'Updated Date',
      filter: true,
      dateFormat: 'date',
      width: 140,
      isHtml: false,
    },
    {
      columnDef: 'created_by',
      header: 'Updated By',
      filter: true,
      width: 260,
      isHtml: false,
    }
  ];
  showGenerateButton: boolean = false;
  userSessionData: any;
  activeIndex: number = 0;
  applicationNumber: any;
  dnqduedate: any;
  showdeleteModal: boolean = false;
  modalref: NgbModalRef;
  groupedPreviewData: any = {};
  firstName: string;
  lastName: string;
  defHeaderContent: any;
  defFooterContent: any;
  resolvingGuideUrl: string = "";
  transcriptInfoUrl: string = "https://doe.nv.gov/educator-licensure/information-about-official-transcripts/";
  currentDate: any;
  educatorName: any;
  showAppstatuserrmsg: boolean;
  dialogHeader: string;
  deleteId: any;
  expirationDate: string;
  showdnqerror: boolean = false;
  patchFromApi: boolean = false;
  hidePreviousNextButtons: boolean = false;

  tabNamesOrder: string[] = [
    "License Details",
    "Personal Information",
    "Education Information",
    "Work Experience",
    "Background Check",
    "Professional Development",
  ];
  licensePathName: any;
  isViewMode: boolean = false;
  destroy$ = new Subject<void>();
  analystName: string = '';
  isWordWrapEnabled = window.innerWidth >= 945;
  lastSystemReqDueDate: string | null = null;
  lastSystemProvDueDate: string | null = null;
  lastSystemEndoDueDate: string | null = null;
  unarchiveFromStatus: any = null;

  constructor(
    private fb: FormBuilder,
    private decisionService: DecisionRolePageService,
    private readonly httpService: HttpService,
    private sessionStorage: LocalService,
    private readonly alertService: AlertService,
    private readonly router: Router,
    private readonly modalService: NgbModal,
    private myAppService: MyApplicationsService,
    private sanitized: DomSanitizer,
    injector: Injector
  ) {
    this.rowdnqcomments = "<p>this is a text</p>";
    this.injector = injector;
    this.dataStore = injector.get<DataStoreService>(DataStoreService);
    this.route = injector.get<ActivatedRoute>(ActivatedRoute);
    this.ShowDeficiencyBuilderTab();
    this.checkReadOnlyModeToHidePreviousNextButton();
    this.licensePathName = JSON.parse(this.sessionStorage.getItem('navigationData')).bannerheader['License Path'];
  }

  private strictUsDateValidator(control: AbstractControl): ValidationErrors | null {
    const minYear = 1900;
    const maxYear = 2100;
    const value = control.value;
    if (value === null || value === undefined || value === '') {
      return null;
    }
    const today = moment().startOf('day');

    if (value instanceof Date) {
      if (isNaN(value.getTime())) {
        return { invalidDate: true };
      }
      const year = value.getFullYear();
      if (year < minYear || year > maxYear) {
        return { invalidYear: true };
      }
      if (moment(value).startOf('day').isBefore(today)) {
        return { pastDateNotAllowed: true };
      }
      return null;
    }

    const rawValue = String(value).trim();
    const dateRegex = /^(0[1-9]|1[0-2])\/(0[1-9]|[12]\d|3[01])\/(\d{4})$/;
    const match = rawValue.match(dateRegex);
    if (!match) {
      return { invalidDateFormat: true };
    }

    const parsed = moment(rawValue, 'MM/DD/YYYY', true);
    if (!parsed.isValid()) {
      return { invalidDate: true };
    }

    const year = Number(match[3]);
    if (year < minYear || year > maxYear) {
      return { invalidYear: true };
    }

    if (parsed.isBefore(today)) {
      return { pastDateNotAllowed: true };
    }

    return null;
  }

  async moveToPrevious(): Promise<void> {
    if (this.analystrole && this.hasUnresolvedRequests()) {
      this.alertService.error(this.errorMessages['M0211'] || 'Please approve or deny all pending resolution requests before proceeding.');
      return;
    }
    await this.saveResolutionDecisions();

    const tabList = JSON.parse(this.dataStore.getData('TABCONFIGLIST') || '[]');
    const currentTabIndex = tabList?.findIndex(tab => tab.id == 3720);
    const parentGridPageInfo = this.sessionStorage.getObj('backToGridPage')
      ? this.sessionStorage.getObj('backToGridPage')
      : this.sessionStorage.getObj('parentGridPage')
        ? this.sessionStorage.getObj('parentGridPage')
        : {};
    let previousTab = null;
    let isFirstTab = null;
    if (currentTabIndex === 0) {
      isFirstTab = true;
    }
    currentTabIndex > 0 ? (previousTab = tabList[currentTabIndex - 1]) : null;
    const previousTabIndex = currentTabIndex - 1;
    if (isFirstTab) {
      if (parentGridPageInfo.id) {
        this.router.navigate([`/pages/dynamic-search/search/${parentGridPageInfo?.id}`], { relativeTo: this.route });
      } else {
        this.router.navigate([`/pages/${parentGridPageInfo.name}`], { relativeTo: this.route });
      }
    } else if (previousTab && previousTab.id) {
      this.dataStore.setData('FORM_SUBMISSION_SUCCESS', {
        isRoute: true,
        nextPage: previousTabIndex,
        submissionId: null
      });
      return;
    } else {
      return;
    }
  }

  async moveToNext(): Promise<void> {
    if (this.analystrole && this.hasUnresolvedRequests()) {
      this.alertService.error( this.errorMessages['M0211'] || 'Please approve or deny all pending resolution requests before proceeding.');
      return;
    }
    await this.saveResolutionDecisions();

    const isNameChangeApplication =
      String(this.application_type ?? '').trim().toLowerCase() === 'name change';

    if (this.analystrole && !isNameChangeApplication && !this.hasValidEndorsementDetails()) {
      this.markEndorsementSectionAsTouched();
      this.alertService.error('Please fill all mandatory Endorsement fields.');
      return;
    }

    const tabList = JSON.parse(this.dataStore.getData('TABCONFIGLIST') || '[]');
    const currentTabIndex = tabList?.findIndex(tab => tab.id == 3720);
    const parentGridPageInfo = this.sessionStorage.getObj('backToGridPage')
      ? this.sessionStorage.getObj('backToGridPage')
      : this.sessionStorage.getObj('parentGridPage')
        ? this.sessionStorage.getObj('parentGridPage')
        : {};
    let nextTab = null;
    let islastTab = null;
    if (currentTabIndex !== -1 && currentTabIndex == tabList.length - 1) {
      islastTab = tabList[currentTabIndex + 1] ? false : true;
    }
    currentTabIndex !== -1 ? (nextTab = tabList[currentTabIndex + 1]) : null;
    let lastTabId = null;
    if (islastTab) {
      lastTabId = tabList[currentTabIndex]?.id;
    }
    const nextTabIndex = currentTabIndex + 1;
    if (islastTab) {
      if (parentGridPageInfo.id) {
        this.router.navigate([`/pages/dynamic-search/search/${parentGridPageInfo?.id}`], { relativeTo: this.route });
      } else {
        this.router.navigate([`/pages/${parentGridPageInfo.name}`], { relativeTo: this.route });
      }
    } else if (nextTab && nextTab.id) {
      this.dataStore.setData('FORM_SUBMISSION_SUCCESS', { isRoute: true, nextPage: nextTabIndex, submissionId: null });
      return;
    } else {
      return;
    }
  }

  ngOnInit(): void {
    this.userSessionData = JSON.parse(this.sessionStorage.getItem('user'));
    this.application_type = JSON.parse(this.sessionStorage.getItem('applicationType'));
    this.initForms();
    // this.today = moment().format('MM/DD/YYYY');
    this.today.setHours(0, 0, 0, 0);
    this.licenseForm = this.fb.group({
      licenses: this.fb.array([]),
      dnqdescription: ['']
    });
    this.roleId = JSON.parse(this.sessionStorage.getItem("role_id"));
    if (this.roleId == 454 || this.roleId == 455) {
      this.intakerole = true;
      this.analystrole = false;
      const appType = JSON.parse(this.sessionStorage.getItem('currApplicationType'));
      this.checkValidationStatusForDeficiency(appType);

    }
    else if (this.roleId == 452 || this.roleId == 453) {
      this.analystrole = true;
      this.intakerole = false;
    }
    else {
      this.analystrole = true;
      this.intakerole = true;
    }

    this.setGenerateLicenseButtonFromNavigationStatus();

    this.licenseForm.valueChanges.subscribe(() => {
      this.updateDnqCommunicationVisibility();
    });
    this.loadRequiredLookupData();
    this.loadLicenseData();
    this.loadDecisionStatusHistory();
    // this.loadLastSequenceNumber();
    this.loadDeficicencyComments();
    this.loadDropdownData();
    this.bindAddTypeChange();
    this.bindEditTypeChange();
    this.bindProvisionCategoryChange();

    this.isViewMode = JSON.parse(this.sessionStorage.getItem('userapplicationmode')) === 'viewmode';
    if (this.isViewMode) {
      this.disableAllForms();
    }
    this.analystName = `${this.userSessionData?.firstname || ''} ${this.userSessionData?.lastname || ''}`.trim();
    this.loadAdditionalEndorsementsFlag();

  }


  private initForms(): void {

    this.prolickindForm = this.fb.group({
      category: ['', Validators.required],
      provlickind: ['', Validators.required],
      lickindprovisiontype: [''],
      lickindprovision: ['', Validators.required],
      provdueDate: ['', [Validators.required, this.strictUsDateValidator.bind(this)]],
      provlickindaddText: ['']
    });

    this.editprolickindForm = this.fb.group({
      provlickind: ['', Validators.required],
      lickindprovisiontype: [''],
      lickindprovision: ['', Validators.required],
      provdueDate: ['', [Validators.required, this.strictUsDateValidator.bind(this)]],
      provlickindaddText: ['']
    });

    this.prolicendoForm = this.fb.group({
      provendorsement: ['', Validators.required],
      lickindprovisiontype: [''],
      endoprovision: ['', Validators.required],
      endodueDate: ['', [Validators.required, this.strictUsDateValidator.bind(this)]],
      endoadditionalText: ['']
    });

    this.editprolicendoForm = this.fb.group({
      provendorsement: ['', Validators.required],
      lickindprovisiontype: [''],
      endoprovision: ['', Validators.required],
      endodueDate: ['', [Validators.required, this.strictUsDateValidator.bind(this)]],
      endoadditionalText: ['']
    });

    this.prolicreqForm = this.fb.group({
      type: ['', Validators.required],
      source: ['', Validators.required],
      licrequirement: ['', Validators.required],
      reqdueDate: ['', [Validators.required, this.strictUsDateValidator.bind(this)]]
    });

    this.editprolicreqForm = this.fb.group({
      type: [null, Validators.required],
      source: [null, Validators.required],
      licrequirement: ['', Validators.required],
      reqdueDate: ['', [Validators.required, this.strictUsDateValidator.bind(this)]]
    });

    this.adddecisionForm = this.fb.group({
      applicationStatus: ['', Validators.required],
      rowdnqcomments: ['']
    });
    this.form = this.fb.group({
      rowdnqcomments: ['<p></p>']
    });
  }

  get licenses(): FormArray {
    return this.licenseForm.get('licenses') as FormArray;
  }

  endorsements(i: number): FormArray {
    return this.licenses.at(i).get('endorsements') as FormArray;
  }

  createLicenseGroup(data: any): FormGroup {
    return this.fb.group({
      licenseKind: [data.licenseKind],
      licenseType: [data.licenseType, Validators.required],
      // effectiveDate: [
      //   data.effectiveDate ? new Date(data.effectiveDate) : this.today
      // ],
      effectiveDate: [
        data.effectiveDate ? moment(data.effectiveDate).format('MM/DD/YYYY') : moment(this.today).format('MM/DD/YYYY'),
        [this.strictUsDateValidator.bind(this), Validators.required]
      ],
      expirationDate: [
        data.expirationDate ? moment(data.expirationDate).format('MM/DD/YYYY') : '',
        [this.strictUsDateValidator.bind(this), Validators.required]
      ],
      endorsements: this.fb.array(
        data.endorsements.map((e: any) => this.createEndorsementGroup(e))
      )
    });
  }

  createEndorsementGroup(e: any): FormGroup {
    return this.fb.group({
      endorsement: [e.endorsement, Validators.required],
      grade: [e.grade],
      pathway: [e.pathway, Validators.required],
      is_new: [this.resolveIsNewFlag(e)],
      originalEffectiveDate: [
        e.originalEffectiveDate ? moment(e.originalEffectiveDate).format('MM/DD/YYYY') : moment(this.today).format('MM/DD/YYYY'),
        [Validators.required, this.strictUsDateValidator.bind(this)]
      ],
      effectiveDate: [
        e.effectiveDate ? moment(e.effectiveDate).format('MM/DD/YYYY') : moment(this.today).format('MM/DD/YYYY'),
        [Validators.required, this.strictUsDateValidator.bind(this)]
      ],
      expirationDate: [
        e.expirationDate ? moment(e.expirationDate).format('MM/DD/YYYY') : '',
        [Validators.required, this.strictUsDateValidator.bind(this)]
      ]
    });
  }

  private markEndorsementSectionAsTouched(): void {
    this.licenses.controls.forEach((licenseControl: AbstractControl) => {
      const endorsements = licenseControl.get('endorsements') as FormArray | null;
      if (!endorsements) {
        return;
      }

      endorsements.controls.forEach((endorsementControl: AbstractControl) => {
        endorsementControl.get('endorsement')?.markAsTouched();
        endorsementControl.get('grade')?.markAsTouched();
        endorsementControl.get('pathway')?.markAsTouched();
        endorsementControl.get('originalEffectiveDate')?.markAsTouched();
        endorsementControl.get('effectiveDate')?.markAsTouched();
        endorsementControl.get('expirationDate')?.markAsTouched();
      });
    });
  }

  private hasValidEndorsementDetails(): boolean {
    if (!this.licenses || this.licenses.length === 0) {
      return false;
    }

    return this.licenses.controls.every((licenseControl: AbstractControl) => {
      const endorsements = licenseControl.get('endorsements') as FormArray | null;
      if (!endorsements || endorsements.length === 0) {
        return false;
      }

      return endorsements.controls.every((endorsementControl: AbstractControl) => {
        const endorsement = endorsementControl.get('endorsement');
        const grade = endorsementControl.get('grade');
        const pathway = endorsementControl.get('pathway');
        const originalEffectiveDate = endorsementControl.get('originalEffectiveDate');
        const effectiveDate = endorsementControl.get('effectiveDate');
        const expirationDate = endorsementControl.get('expirationDate');

        endorsement?.updateValueAndValidity({ emitEvent: false });
        grade?.updateValueAndValidity({ emitEvent: false });
        pathway?.updateValueAndValidity({ emitEvent: false });
        originalEffectiveDate?.updateValueAndValidity({ emitEvent: false });
        effectiveDate?.updateValueAndValidity({ emitEvent: false });
        expirationDate?.updateValueAndValidity({ emitEvent: false });

        const appTypeval = JSON.parse(this.sessionStorage.getItem('currApplicationType'));

        if (appTypeval == 'Add Endorsement') {
          return (!endorsement || endorsement.disabled || endorsement.valid) &&
            (!pathway || pathway.disabled || pathway.valid) &&
            (!originalEffectiveDate || originalEffectiveDate.disabled || originalEffectiveDate.valid) &&
            (!effectiveDate || effectiveDate.disabled || effectiveDate.valid) &&
            (!expirationDate || expirationDate.disabled || expirationDate.valid);
        } else {
          return !!endorsement && endorsement.valid &&
            !!pathway && pathway.valid &&
            !!grade && grade.valid &&
            !!originalEffectiveDate && originalEffectiveDate.valid &&
            !!effectiveDate && effectiveDate.valid &&
            !!expirationDate && expirationDate.valid;
        }
      });
    });
  }

  populateLicenses(data: any): void {
    if (!data?.license?.length) {
      return;
    }

    // Group by cd_license_kind
    const groupedByLicenseKind = data.license.reduce(
      (acc: any, item: any) => {
        const key = item.cd_license_kind;

        if (!acc[key]) {
          acc[key] = [];
        }

        acc[key].push(item);
        return acc;
      },
      {}
    );

    Object.entries(groupedByLicenseKind).forEach(
      ([licenseKindKey, group]: [string, any[]], index: number) => {

        const first = group[0];

        const licenseObj = {
          licenseKind: this.licensekindName(
            first.cd_license_kind.toString()
          ),
          licenseType: '',
          effectiveDate: this.today,
          expirationDate: null,
          endorsements: group.map(e => ({
            endorsement: e.cd_endorsement,
            grade: '',
            pathway: '',
            is_new: e.is_new,
            originalEffectiveDate: this.today,
            effectiveDate: this.today,
            expirationDate: null
          }))
        };

        // ✅ Push into FormArray first
        this.licenses.push(this.createLicenseGroup(licenseObj));
        const apptype = JSON.parse(this.sessionStorage.getItem('applicationType'));
        // ✅ Call API based on licenseKind
        // if (!apptype.includes('Substitute')) {
        this.loadEndorsementsForRow(index, first.cd_license_kind);
        // }
        // else {
        //   let obj = {
        //     "key": first.cd_endorsement,
        //     "value": first.endorsement
        //   }
        //   this.endorsementOptionsPerLicense[index] = [obj];
        // }

      }
    );

    //this.loadLicenseDatesByPersonId();
    if (this.isViewMode) {
      this.disableAllForms();
    }
    this.applyAdditionalPaymentPathwayLocks();
  }

  loadEndorsementsForRow(index: number, licenseKind: string) {

    this.decisionService
      .getEndorsementsByLicenseKind(licenseKind)
      .subscribe({
        next: (res: any) => {
          const appType = JSON.parse(sessionStorage.getItem('currApplicationType'));
          if (appType == "Apprentice") {
            this.endorsementOptionsPerLicense[index] = [res.data[0]];
          }
          else {
            this.endorsementOptionsPerLicense[index] = res.data; this.endorsementOptionsPerLicense[index] = this.removeRegisteredApprenticeEndorsement(res.data);
          }
        },
        error: () => {
          this.endorsementOptionsPerLicense[index] = [];
        }
      });
  }


  loadLicenseData() {

    let res = [
      {
        licenseKind: 'Business and Industry',
        licenseType: '',
        effectiveDate: '',
        expirationDate: '',
        endorsements: [
          {
            endorsement: '117',
            grade: '',
            pathway: '',
            originalEffectiveDate: '',
            effectiveDate: '',
            expirationDate: '',
            licenseKind: 'Business and Industry'
          },
          {
            endorsement: '118',
            grade: '',
            pathway: '',
            originalEffectiveDate: '',
            effectiveDate: '',
            expirationDate: '',
            licenseKind: 'Business and Industry'
          }
        ]
      },
      {
        licenseKind: 'Secondary - CTE',
        licenseType: '',
        effectiveDate: '',
        expirationDate: '',
        endorsements: [
          {
            endorsement: '122',
            grade: '',
            pathway: '',
            originalEffectiveDate: '',
            effectiveDate: '',
            expirationDate: '',
            licenseKind: 'Secondary - CTE'
          }
        ]
      }
    ];
    // // Sample input data
    // let endo_data = {
    //   license: [
    //     {
    //       application_id: 2957,
    //       primary_id: 1321,
    //       primary_object: 'license_kind_endorsement_id',
    //       person_id: 578,
    //       cd_endorsement: '117',
    //       value: 'Business and Industry',
    //       endorsement: 'Accounting and Finance',
    //       cd_license_kind: 1,
    //       grad_val: ''
    //     },
    //     {
    //       application_id: 2957,
    //       primary_id: 1308,
    //       primary_object: 'license_kind_endorsement_id',
    //       person_id: 578,
    //       cd_endorsement: '118',
    //       value: 'Business and Industry',
    //       endorsement: 'Advanced Computer Science',
    //       cd_license_kind: 1,
    //       grad_val: ''
    //     }
    //   ],
    //   license_isVisible: true
    // };
    let endo_data = {
      license: JSON.parse(this.sessionStorage.getItem('license_details'))
    }
    console.log(endo_data);
    this.responsevalue = endo_data;
    console.log(this.responsevalue);

  }

  loadGradeValues(value: any) {
    const webhookUrl = `/application-flow/getEndorsemenGrade`;

    return this.httpService.post(webhookUrl, { parent_id: value }).pipe(
      take(1),
      map((res: any) => res?.data?.data?.value ?? '')
    );
  }


  loadAllGrades(): void {
    const requests: any[] = [];
    const controlMap: FormGroup[] = [];

    this.licenses.controls.forEach((licenseGroup: FormGroup) => {
      const endorsements = licenseGroup.get('endorsements') as FormArray;

      endorsements.controls.forEach((endorsementGroup: FormGroup) => {
        const endorsementId = endorsementGroup.get('endorsement')?.value;

        requests.push(this.loadGradeValues(endorsementId));
        controlMap.push(endorsementGroup);
      });
    });

    if (!requests.length) {
      return;
    }

    forkJoin(requests).subscribe((grades: string[]) => {
      grades.forEach((grade, index) => {
        controlMap[index].patchValue({ grade });
      });
    });
  }



  private async loadRequiredLookupData() {
    // Load only the lookup data needed for application creation
    // (used when applicationTypes is already provided by parent)
    forkJoin([
      this.httpService.get('/domain/lookup?requestType=LICENSE KIND'),
      this.httpService.get('/domain/lookup?requestType=ENDORSEMENT'),
      this.httpService.get('/domain/lookup?requestType=DECISION_TAB_STATUS'),
      this.httpService.get('/domain/lookup?requestType=LICENSE-TYPES'),
      this.httpService.get('/domain/lookup?requestType=ENDO-PATHWAY'),
      this.httpService.get('/domain/lookup?requestType=LICENSE-REQUIREMENT-CATEGORY'),
      this.httpService.get('/domain/lookup?requestType=PROVISIONS'),
      this.httpService.get('/application-flow/getLicenseDuration'),


    ]).subscribe({
      next: (item: any) => {
        const appType = JSON.parse(sessionStorage.getItem('currApplicationType'));
        this.licenseKindData = item[0].data;
        this.endorsementData = item[1].data;
        this.applicationStatusData = item[2].data;
        const applicationStatus = this.sessionStorage.getItem('applicationStatus')?.replace(/"/g, '').replace(/\s+/g, ' ').trim();
        const allowedStatuses = ['Analyst Pending + BG Pending', 'Analyst Pending + BG Denied', 'Analyst Pending + BG Approved', 'Partially Approved + BG Pending',
          'Partially Approved + BG Approved', 'Partially Approved + BG Denied',
          'Analyst Denied + BG Pending', 'Analyst Denied + BG Approved',
          'Analyst Denied + BG Denied',  'Analyst Approved + BG Pending', 'Analyst Approved + BG Approved',
            'Analyst Approved + BG Denied', 'Deficiency Pending + BG Approved', 'Deficiency Pending + BG Denied' ,
            'Deficiency Pending + BG Pending'];
        const isAnalystOrAdmin = this.roleId == 452 || this.roleId == 453 || this.roleId == 2 || this.roleId == 457;
        const isAllowedStatus = allowedStatuses.includes(applicationStatus);

        if (!(isAnalystOrAdmin && isAllowedStatus)) {
          this.applicationStatusData = this.applicationStatusData.filter((obj: any) => obj.value !== 'Intake');
        }
        if (appType === 'Name Change') {
          this.applicationStatusData = item[2].data.filter(
            (obj: any) =>
              obj.value === 'Approved' ||
              obj.value === 'Deficiency'
          );
        }
        this.licenseTypesData = item[3].data.sort((a, b) =>
          a.value.localeCompare(b.value)
        );
        this.endoPathwayData = item[4].data.sort((a, b) =>
          a.value.localeCompare(b.value)
        );
        this.setDnqPathwayKey();
        this.updateDnqCommunicationVisibility();
        this.licrequirementsData = item[5].data.sort((a, b) =>
          a.value.localeCompare(b.value)
        );
        this.licenseProvisionsData = item[6].data;
        this.licenseDurationData = item[7].data.data;
        console.log('Required lookup data loaded for license flow');
        this.provtypeOnChange("1");
        this.loadAllGrades();
        this.LicenseKindEndoDetails();
        this.getFilteredLicenseKindProvision();

        const LicensePathName = JSON.parse(this.sessionStorage.getItem('navigationData')).bannerheader['License Path'];
        const appTypeval = JSON.parse(this.sessionStorage.getItem('currApplicationType'));

        if (appTypeval == 'Add Endorsement') {
          this.endroseflowgetlicenseFormValues();
        } else if (this.application_type === 'Resolve') {
          this.resolveFlowGetLicenseFormValues();
        } else if (LicensePathName != 'Initial') {
          this.getlicenseFormValues();
        } else {
          this.populateLicenses(this.responsevalue);
        }

        this.applicationNumber = JSON.parse(this.sessionStorage.getItem('navigationData')).bannerheader['Application ID'];
        this.educatorName = JSON.parse(this.sessionStorage.getItem('navigationData')).bannerheader['Educator Name'];
      },
      error: error => {
        console.error('Error loading required lookup data:', error);
      }
    });
  }

  getFilteredLicenseKindProvision() {
    const matchedArray = this.licenseKindData.filter(a1 =>
      this.responsevalue?.license?.some(a2 => a2.cd_license_kind == a1.key)
    );
    this.lickindProvisionData = matchedArray;

    forkJoin(
      this.lickindProvisionData.map((item: any) =>
        this.decisionService.getEndorsementsByLicenseKind(item.key)
      )
    ).subscribe({
      next: (responses: any[]) => {

        let endorsements = Array.from(
          new Map(
            responses
              .flatMap(res => res?.data || [])
              .map(item => [item.key, { key: item.key.toString(), value: item.value }])
          ).values()
        );

        const matchedArray = endorsements.filter(a1 =>
          this.responsevalue?.license?.some(a2 => a2.cd_endorsement == a1.key)
        );
        endorsements = matchedArray;

        const appType = JSON.parse(sessionStorage.getItem('currApplicationType'));

        if (appType !== 'Apprentice') {
          endorsements = this.removeRegisteredApprenticeEndorsement(endorsements);
          endorsements.sort((a, b) => a.value.localeCompare(b.value));
        }

        console.log('sortedEndorsements', endorsements);

        this.endorsementProvisionData =
          appType === 'Apprentice' && endorsements.length > 0
            ? [endorsements[0]]
            : endorsements;
      },

      error: (err) => console.error('Error loading endorsements:', err)
    });
  }

  getFilteredLicenseKindProvision1(data: any) {
    const matchedArray = this.licenseKindData.filter(a1 =>
      data?.some(a2 => a2.cd_license_kind == a1.key)
    );
    this.lickindProvisionData = matchedArray;

    forkJoin(
      this.lickindProvisionData.map((item: any) =>
        this.decisionService.getEndorsementsByLicenseKind(item.key)
      )
    ).subscribe({
      next: (responses: any[]) => {

        let sortedEndorsements = Array.from(
          new Map(
            responses
              .flatMap(res => res?.data || [])
              .map(item => [item.key, { key: item.key.toString(), value: item.value }])
          ).values()
        )
          .sort((a, b) => a.value.localeCompare(b.value));

        const matchedArray = sortedEndorsements.filter(a1 =>
          data?.some(a2 => a2.cd_endorsement == a1.key)
        );
        sortedEndorsements = matchedArray;

        const appType = JSON.parse(sessionStorage.getItem('currApplicationType'));
        this.endorsementProvisionData =
          appType == 'Apprentice' && sortedEndorsements.length > 0
            ? [sortedEndorsements[0]]
            : sortedEndorsements;

      },

      error: (err) => console.error('Error loading endorsements:', err)
    });
  }

  resetLicense(): void {
    this.prolickindForm.reset();
    this.provlickindeditbtn = false;
  }

  onCategoryChange(): void {
    this.prolickindForm.controls['lickindprovision'].reset();
    this.prolickindForm.controls['provlickind'].reset();
    this.prolickindForm.controls['provdueDate'].reset();
    this.lastSystemProvDueDate = null;
    this.endorsementMinExpiryDate = null;
    this.prolickindForm.controls['provdueDate'].setValidators([
      Validators.required,
      this.strictUsDateValidator.bind(this)
    ]);
    this.prolickindForm.controls['provdueDate'].updateValueAndValidity();
  }

onProvisionSourceChange(event: any): void {
  const category = this.prolickindForm.controls['category'].value;
  if (category !== 'Endorsement') return;

  const selectedEndorsements = Array.isArray(event?.value) ? event.value : [event?.value];
  const matchedRecords = this.licenseForm
    .getRawValue()
    .licenses
    ?.flatMap((l: any) => l.endorsements || [])
    ?.filter((e: any) => selectedEndorsements.includes(e.endorsement))
    ?.filter((e: any) => e.expirationDate && moment(e.expirationDate, 'MM/DD/YYYY', true).isValid());

  if (matchedRecords && matchedRecords.length) {
    const minExpiry = matchedRecords.reduce((min: any, cur: any) =>
        new Date(cur.expirationDate) < new Date(min.expirationDate) ? cur : min
    );
      const minExpiryFormatted = moment(minExpiry.expirationDate).format('MM/DD/YYYY');
    this.lastSystemProvDueDate = minExpiryFormatted;
    this.prolickindForm.controls['provdueDate'].patchValue(minExpiryFormatted);
  } else {
    this.lastSystemProvDueDate = null;
    this.prolickindForm.controls['provdueDate'].reset();
  }
}

  addProvision(): Promise<void> {
    const category = this.prolickindForm.controls['category'].value;
    if (this.prolickindForm.invalid) {
      this.prolickindForm.markAllAsTouched();
      return Promise.resolve();
    }
    const userFromSession = JSON.parse(this.sessionStorage.getItem('user'));
    const application_id = JSON.parse(this.sessionStorage.getItem('applicationID'));
    const persondata = JSON.parse(this.sessionStorage.getItem('personData'));

    if (category === 'Endorsement') {
      const obj = {
        "person_id": persondata.person_id,
        "application_id": application_id,
        "cd_license_kind": null,
        "cd_license_provision": null,
        "license_additional_text": null,
        "license_due_date": null,
        "created_by": userFromSession?.id,
        "cd_endorsement": this.prolickindForm.controls['provlickind'].value,
        "cd_endor_provision": this.prolickindForm.controls['lickindprovision'].value,
        "endorsement_additional_text": this.prolickindForm.controls['provlickindaddText'].value,
        "endorsement_due_date": this.prolickindForm.controls['provdueDate'].value,
      };
      return new Promise((resolve, reject) => {
        this.decisionService.createLicEndoProvisions(obj).subscribe({
          next: () => { resolve(); this.alertService.success('Added successfully.'); this.getLicEndoProvisions(); this.prolickindForm.reset(); },
          error: (err) => { console.error(err); reject(err); }
        });
      });
    } else {
      const obj = {
        "person_id": persondata.person_id,
        "application_id": application_id,
        "cd_license_kind": this.prolickindForm.controls['provlickind'].value,
        "cd_license_provision": this.prolickindForm.controls['lickindprovision'].value,
        "license_additional_text": this.prolickindForm.controls['provlickindaddText'].value,
        "license_due_date": this.prolickindForm.controls['provdueDate'].value,
        "created_by": userFromSession.id,
        "cd_endorsement": null,
        "cd_endor_provision": null,
        "endorsement_additional_text": null,
        "endorsement_due_date": null,
      };
      return new Promise((resolve, reject) => {
        this.decisionService.createLicKindProvisions(obj).subscribe({
          next: () => { resolve(); this.alertService.success('Added successfully.'); this.getLicKindProvisions(); this.prolickindForm.reset(); },
          error: (err) => { console.error(err); reject(err); }
        });
      });
    }
  }

  addLicenseProvision(): Promise<void> {
    if (this.prolickindForm.invalid) {
      this.prolickindForm.markAllAsTouched();
      return Promise.resolve();
    }


    return new Promise((resolve, reject) => {
      const userFromSession = JSON.parse(this.sessionStorage.getItem('user'));
      const application_id = JSON.parse(this.sessionStorage.getItem('applicationID'));
      const persondata = JSON.parse(this.sessionStorage.getItem('personData'));
      let obj = {
        "person_id": persondata.person_id,
        "application_id": application_id,
        "cd_license_kind": this.prolickindForm.controls['provlickind'].value,
        "cd_license_provision": this.prolickindForm.controls['lickindprovision'].value,
        "license_additional_text": this.prolickindForm.controls['provlickindaddText'].value,
        "license_due_date": this.prolickindForm.controls['provdueDate'].value,
        "created_by": userFromSession.id,
        "cd_endorsement": null,
        "cd_endor_provision": null,
        "endorsement_additional_text": null,
        "endorsement_due_date": null,

      };

      this.decisionService.createLicKindProvisions(obj).subscribe({
        next: (data) => {
          resolve();
          this.alertService.success("Added successfully.");
          this.getLicKindProvisions();
          this.prolickindForm.reset();
        },
        error: (error) => {
          console.error('Error getting person data:', error);
          reject(error);
        }
      });
    });

  }

  updateLicenseProvision(): Promise<void> {
    // const provisionCtrl = this.editprolickindForm.controls['lickindprovision'];
    // provisionCtrl.enable();
    if (this.editprolickindForm.invalid) {
      this.editprolickindForm.markAllAsTouched();
      // provisionCtrl.disable();
      return Promise.resolve();
    }

    return new Promise((resolve, reject) => {
      const userFromSession = JSON.parse(this.sessionStorage.getItem('user'));
      const application_id = JSON.parse(this.sessionStorage.getItem('applicationID'));
      let obj = {
        "license_end_provision_id": this.editId,
        "person_id": userFromSession?.id,
        "application_id": application_id,
        "cd_license_kind": this.editprolickindForm.controls['provlickind'].value,
        "cd_license_provision": this.editprolickindForm.controls['lickindprovision'].value,
        "license_additional_text": this.editprolickindForm.controls['provlickindaddText'].value,
        "license_due_date": this.editprolickindForm.controls['provdueDate'].value,
        "updated_by": userFromSession?.id,
        "cd_endorsement": null,
        "cd_endor_provision": null,
        "endorsement_additional_text": null,
        "endorsement_due_date": null,

      };

      this.decisionService.updateLicKindProvisions(obj).subscribe({
        next: (data) => {
          resolve();
          this.alertService.success("Updated successfully.");
          this.getLicKindProvisions();
          this.editprolickindForm.reset();
          this.editId = '';
          this.modalStatusClose();
        },
        error: (error) => {
          console.error('Error getting person data:', error);
          reject(error);
        }
      });
    });

  }

  getLicKindProvisions(): Promise<void> {
    return new Promise((resolve, reject) => {
      const application_id = JSON.parse(this.sessionStorage.getItem('applicationID'));
      this.decisionService.getLicKindProvisions(application_id).subscribe({
        next: (data) => {
          resolve();
          console.log(data.data);
          this.licKindProvisionRows = data?.data?.data
            ?.filter((item: any) => item.cd_license_kind != null)
            .map((item: any) => ({
              provlicenseKindId: item.cd_license_kind,
              provlicenseKind: item.cd_license_kind
                ?.map((id: number) => this.licensekindName(id.toString()))
                .join(', '),
              provision: this.licenseKindProvName(item.cd_license_provision.toString()),
              dueDate: item?.license_due_date ? new Date(item.license_due_date) : null,
              additionalText: item.license_additional_text,
              lickind_id: item.license_end_provision_id,
              resolvedDate: item?.resolved_date ? new Date(item.resolved_date) : null,
              resolutionNotes: item?.resolution_notes || '',
              cd_satus: item?.cd_satus || '',
              provision_status: item?.provision_status || '',
              resolution_requested: !!item?.resolution_requested,
              mark_resolved_flag: item?.mark_resolved_flag ?? null,
              _original_mark_resolved_flag: item?.mark_resolved_flag ?? null,
              updatedBy: item?.name || ''
            }))
          if (this.licKindProvisionRows?.length > 0) {
            const provisionSet = new Set(
              this.licKindProvisionRows.map(a2 => a2.provision)
            );

            this.lickindProvTypedata = this.lickindProvTypedata.filter(a1 =>
              !provisionSet.has(a1.value)
            );
            // const matchedArray = this.lickindProvTypedata.filter(a1 =>
            //   this.licKindProvisionRows?.some(a2 => this.licenseKindProvKey(a2.provision) != a1.key)
            // );
            // this.lickindProvTypedata = matchedArray;
          }
          else {
            this.lickindProvTypedata = this.lickindProvTypedataCopy;
          }
          this.updateCombinedProvisionRows();
        },
        error: (error) => {
          console.error('Error getting person data:', error);
          reject(error);
        }
      });
    });
  }

  getLicEndoProvisions(): Promise<void> {
    return new Promise((resolve, reject) => {
      const application_id = JSON.parse(this.sessionStorage.getItem('applicationID'));
      this.decisionService.getLicEndoProvisions(application_id).subscribe({
        next: (data) => {
          resolve();
          console.log(data.data);
          this.licEndoProvisionRows = data?.data?.data
            ?.filter((item: any) => item.cd_endoresement != null)
            .map((item: any) => ({
              provendoId: item.cd_endoresement,
              provendorsement: item.cd_endoresement
                ?.map((id: number) => this.licenseEndoName(id.toString()))
                .join(', '),
              provision: this.licenseEndoProvName(item?.cd_endor_provision.toString()),
              dueDate: item?.endorsement_due_date ? new Date(item.endorsement_due_date) : null,
              additionalText: item.endorsement_additional_text,
              lickind_id: item.license_end_provision_id,
              resolvedDate: item?.resolved_date ? new Date(item.resolved_date) : null,
              resolutionNotes: item?.resolution_notes || '',
              cd_satus: item?.cd_satus || '',
              provision_status: item?.provision_status || '',
              resolution_requested: !!item?.resolution_requested,
              mark_resolved_flag: item?.mark_resolved_flag ?? null,
              _original_mark_resolved_flag: item?.mark_resolved_flag ?? null,
                 updatedBy: item?.name || ''
            }))


          if (this.licEndoProvisionRows?.length > 0) {
            const provisionSet = new Set(
              this.licEndoProvisionRows.map(a2 => a2.provision)
            );

            this.licendoProvTypedata = this.licendoProvTypedata.filter(a1 =>
              !provisionSet.has(a1.value)
            );
          }
          else {
            this.licendoProvTypedata = this.licendoProvTypedataCopy;
          }
          this.updateCombinedProvisionRows();

        },
        error: (error) => {
          console.error('Error getting person data:', error);
          reject(error);
        }
      });
    });
  }

  addEndorsementProvision(): Promise<void> {
    if (this.prolicendoForm.invalid) {
      this.prolicendoForm.markAllAsTouched();
      return Promise.resolve();
    }

    return new Promise((resolve, reject) => {
      const userFromSession = JSON.parse(this.sessionStorage.getItem('user'));
      const application_id = JSON.parse(this.sessionStorage.getItem('applicationID'));
      const persondata = JSON.parse(this.sessionStorage.getItem('personData'));
      let obj = {
        "person_id": persondata.person_id,
        "application_id": application_id,
        "cd_license_kind": null,
        "cd_license_provision": null,
        "license_additional_text": null,
        "license_due_date": null,
        "created_by": userFromSession?.id,
        "cd_endorsement": this.prolicendoForm.controls['provendorsement'].value,
        "cd_endor_provision": this.prolicendoForm.controls['endoprovision'].value,
        "endorsement_additional_text": this.prolicendoForm.controls['endoadditionalText'].value,
        "endorsement_due_date": this.prolicendoForm.controls['endodueDate'].value,

      };

      this.decisionService.createLicEndoProvisions(obj).subscribe({
        next: (data) => {
          resolve();
          this.alertService.success("Added successfully.");
          this.getLicEndoProvisions();
          this.prolicendoForm.reset();
        },
        error: (error) => {
          console.error('Error getting person data:', error);
          reject(error);
        }
      });
    });
  }

  updateEndorsementProvision(): Promise<void> {
    // const provisionCtrl = this.editprolicendoForm.controls['endoprovision'];
    // provisionCtrl.enable();
    if (this.editprolicendoForm.invalid) {
      this.editprolicendoForm.markAllAsTouched();
      // provisionCtrl.disable();
      return Promise.resolve();
    }

    return new Promise((resolve, reject) => {
      const userFromSession = JSON.parse(this.sessionStorage.getItem('user'));
      const application_id = JSON.parse(this.sessionStorage.getItem('applicationID'));
      let obj = {
        "license_end_provision_id": this.editId,
        "person_id": userFromSession?.id,
        "application_id": application_id,
        "cd_license_kind": null,
        "cd_license_provision": null,
        "license_additional_text": null,
        "license_due_date": null,
        "created_by": userFromSession?.id,
        "updated_by": userFromSession?.id,
        "cd_endorsement": this.editprolicendoForm.controls['provendorsement'].value,
        "cd_endor_provision": this.editprolicendoForm.controls['endoprovision'].value,
        "endorsement_additional_text": this.editprolicendoForm.controls['endoadditionalText'].value,
        "endorsement_due_date": this.editprolicendoForm.controls['endodueDate'].value,

      };

      this.decisionService.updateLicKindProvisions(obj).subscribe({
        next: (data) => {
          resolve();
          this.alertService.success("Updated successfully.");
          this.getLicEndoProvisions();
          this.prolicendoForm.reset();
          this.editId = '';
          this.modalStatusClose();
        },
        error: (error) => {
          console.error('Error getting person data:', error);
          reject(error);
        }
      });
    });
  }

  resetEndorsement(): void {
    this.prolicendoForm.reset();
    this.provlicendoeditbtn = false;
  }

  addLicenseRequirements(): Promise<void> {
    console.log(this.prolicreqForm.value);
    console.log(this.prolicreqForm);
    if (this.prolicreqForm.invalid) {
      this.prolicreqForm.markAllAsTouched();
      return Promise.resolve();
    }

    return new Promise((resolve, reject) => {
      const application_id = JSON.parse(this.sessionStorage.getItem('applicationID'));
      const userFromSession = JSON.parse(this.sessionStorage.getItem('user'));
      const persondata = JSON.parse(this.sessionStorage.getItem('personData'));
      let obj = {
        person_id: persondata?.person_id,
        application_id: application_id,
        cd_requirement: this.prolicreqForm.controls['licrequirement'].value,
        due_date: this.prolicreqForm.controls['reqdueDate'].value,
        type: this.prolicreqForm.controls['type'].value,
        source: this.prolicreqForm.controls['source'].value,
        created_by: userFromSession.id
      }
      this.decisionService.createLicenseRequirements(obj).subscribe({
        next: (data) => {
          resolve();
          this.alertService.success("Added successfully.");
          this.getLicenseRequirements();
          this.prolicreqForm.reset();
        },
        error: (error) => {
          console.error('Error getting person data:', error);
          reject(error);
        }
      });
    });
  }


  updateLicenseRequirements(): Promise<void> {
    if (this.editprolicreqForm.invalid) {
      this.editprolicreqForm.markAllAsTouched();
      return Promise.resolve();
    }

    return new Promise((resolve, reject) => {
      const application_id = JSON.parse(this.sessionStorage.getItem('applicationID'));
      const userFromSession = JSON.parse(this.sessionStorage.getItem('user'));
      let obj = {
        application_license_requirement_id: this.editId,
        person_id: userFromSession.id,
        application_id: application_id,
        cd_requirement: this.editprolicreqForm.controls['licrequirement'].value,
        due_date: this.editprolicreqForm.controls['reqdueDate'].value,
        type: this.editprolicreqForm.controls['type'].value,
        source: this.editprolicreqForm.controls['source'].value,
        created_by: userFromSession.id,
        updated_by: userFromSession.id

      }
      this.decisionService.updateLicenseRequirements(obj).subscribe({
        next: (data) => {
          resolve();
          this.alertService.success("Added successfully.");
          this.getLicenseRequirements();
          this.prolicreqForm.reset();
          this.modalStatusClose();
        },
        error: (error) => {
          console.error('Error getting person data:', error);
          reject(error);
        }
      });
    });
  }

  getLicenseRequirements(): Promise<void> {
    return new Promise((resolve, reject) => {
      const application_id = JSON.parse(this.sessionStorage.getItem('applicationID'));
      this.decisionService.getLicenseRequirements(application_id).subscribe({
        next: (data) => {
          resolve();
          if (data?.data?.data?.length > 0) {
            this.licenseRequirementRows = data?.data?.data
              .map((item: any) => {
                // const normalizedType = item.le_type
                //   ? (item.le_type.toLowerCase() === 'license' ? 'License Kind'
                //     : item.le_type.charAt(0).toUpperCase() + item.le_type.slice(1).toLowerCase())
                //   : item.le_type;
                const normalizedType = item.le_type
                  ? (item.le_type.toLowerCase() === 'license' || item.le_type.toLowerCase() === 'license kind' ? 'License Kind'
                    : item.le_type.charAt(0).toUpperCase() + item.le_type.slice(1).toLowerCase())
                  : item.le_type;
                return {
                  reqsourceId: item.le_source, // keep array
                  requirement: this.RequirementsName(item?.cd_requirement),
                  reqdueDate: item?.due_date ? new Date(item.due_date) : null,
                  lickind_id: item.application_license_requirement_id,
                  type: normalizedType,
                  source: normalizedType == 'License Kind' ?
                    item.le_source
                      ?.map((id: any) => this.licensekindName(id.toString())).join(', ') : item.le_source
                        ?.map((id: any) => this.licenseEndoName(id.toString())).join(', '),
                  resolvedDate: item?.resolved_date ? new Date(item.resolved_date) : null,
                  resolutionNotes: item?.resolution_notes || '',
                  cd_status: item?.cd_status || '',
                  provision_status: item?.provision_status || '',
                  resolution_requested: !!item?.resolution_requested,
                  mark_resolved_flag: item?.mark_resolved_flag ?? null,
                  _original_mark_resolved_flag: item?.mark_resolved_flag ?? null,
                   updatedBy: item?.name || ''
                };
              })
            this.updateResolutionNotesColumnVisibility();
          }
          else {
            this.licenseRequirementRows = [];
          }

        },
        error: (error) => {
          console.error('Error getting person data:', error);
          reject(error);
        }
      });
    });
  }

  resetLicenseRequirements(): void {
    this.prolicreqForm.reset();
    this.provlicreqeditbtn = false;
  }

  async modalStatusConfirm(action: string) {
    if (!this.canProceedWithStatusUpdate()) {
      this.showStatusModal = false;
      return;
    }

    const applicationStatus = JSON.parse(this.sessionStorage.getItem('applicationStatus'));
    const isBgPending = typeof applicationStatus === 'string' && applicationStatus.toLowerCase().includes('bg pending');
    const selectedStatus = this.adddecisionForm.controls['applicationStatus'].value;
    if (!isBgPending && applicationStatus && (selectedStatus == 9 || selectedStatus == 40)) {
      await this.updateIsPublishedLicense();
    }

    const application_id = JSON.parse(this.sessionStorage.getItem('applicationID'));
    const persondata = JSON.parse(this.sessionStorage.getItem('personData'));
    const applicationTimelineData = {
      cd_application_status: this.adddecisionForm.controls['applicationStatus'].value,
      application_id: application_id,
      updated_by: this.userSessionData?.id,
    };
    const removeHighlightData = {
      section_name: 'ALL',
      user_id: this.userSessionData?.id,
      application_id: application_id,
    };
    const resolveLicenseProvisionData = {
      applicationid: application_id,
      ssn: persondata?.ssn_number,
      date_of_birth: persondata?.date_of_birth
    };

    forkJoin([
      this.decisionService.updateApplicationStatus(applicationTimelineData),
      this.decisionService.removeApplicationHighlight(removeHighlightData),
      this.decisionService.resolveLicenseProvision(resolveLicenseProvisionData)
    ]).subscribe({
      next: ([statusResponse, highlightResponse, resolveLicenseProvisionResponse]) => {
        const licenseNumber = statusResponse?.data?.data?.license_number;
        if (licenseNumber) {
          this.license_number = licenseNumber;
          this.sendLicenseUpdateNotification();
        }
        if (resolveLicenseProvisionResponse?.data?.success) {
          const result = resolveLicenseProvisionResponse.data.result || [];
          if (result.length > 0) {
            const userId = resolveLicenseProvisionResponse.data.user_id;
            const provisions = `{${result
              .map((item: any) => item.cd_license_provision ?? item.cd_endor_provision)
              .filter(Boolean)
              .join(',')}}`;
            this.sendInAppNotification(userId, provisions);
          }

        }
        if (this.adddecisionForm.controls['applicationStatus'].value != '21')
          this.alertService.success("Status updated successfully.");

        this.showAppstatuserrmsg = false;
        //  this.notification();
        this.showStatusModal = false;
        this.showGenerateButton = true;
        this.showLicensePopup = false;
        //  this.isGenerateLicenseStatus(
        //   this.adddecisionForm.controls['applicationStatus'].value
        // );
        this.loadDecisionStatusHistory();
        const appType = JSON.parse(this.sessionStorage.getItem('currApplicationType'));
        if ((this.adddecisionForm.controls['applicationStatus'].value == 9 || this.adddecisionForm.controls['applicationStatus'].value == 40) && action.toLocaleLowerCase() !== 'confirm' && appType !== 'Name Change') {
          this.downloadLicense();
        }

        this.updateProvisionStatusOnApproval(application_id);
      },
      error: error => {
        console.error('Error updating application status or removing highlights:', error);
      }
    });
  }
  notification() {
    const token = sessionStorage.getItem('jwt-token');
    const cd_application_status = this.adddecisionForm.controls['applicationStatus'].value;
    const selectedStatus = this.applicationStatusData.find(
      (item: any) => String(item?.key) === String(cd_application_status)
    );
    this.applicationNumber = JSON.parse(this.sessionStorage.getItem('navigationData')).bannerheader['Application ID']
    const appId = this.applicationNumber;
    let currQueue = 'invalid Selection';

    switch (Number(cd_application_status)) {
      case 19:
        currQueue = 'Deficiency';
        break;
      case 20:
        currQueue = 'Analyst';
        break;
      case 21:
      case 40:
        currQueue = 'Does Not Qualify';
        break;
      default:
        currQueue = 'invalid Selection';
    }
    this.userSessionData = JSON.parse(this.sessionStorage.getItem('personData'));
    const roleid = JSON.parse(this.sessionStorage.getItem('role_id'));
    const userid = this.userSessionData?.user_id;
    const notificationPayload = {
      priority: 'High',
      message: `The status of application ${appId} has been updated to ${selectedStatus?.value} and is now listed in the ${currQueue} queue.`,
      actionurl: 'example action',
      userid: this.userSessionData?.user_id,
      customformid: 1,
      isnew: true,
      isactive: true
    };
    this.decisionService.notifiction(notificationPayload)
      .pipe(take(1)).subscribe({
        next: (res: any) => {
          if (!res.data.success) {
          }
        },
        error: err => {
          // console.error(`Error sending notification for user ${userid}, role ${roleid}:`, err);
        }
      });
  };
  async updateApplicationStatus() {
    if (this.adddecisionForm.invalid) {
      this.showAppstatuserrmsg = true;
      return;
    }

    if (this.isAnalystStatusSelected()) {
      await this.ShowDeficiencyBuilderTab();
    }

    if (this.isDeficiencyStatusSelected()) {
      const isAnalyst = this.roleId == 452 || this.roleId == 453;
      if (isAnalyst) {
        this.alertService.error('You do not have permission to select Deficiency status.');
        return;
      } else {
        this.previewDefComments();
        return;
      }
      // const appType = JSON.parse(this.sessionStorage.getItem('currApplicationType'));
      // if (appType === 'Name Change') {
      //   await this.checkValidationStatusForDeficiency(appType);
      //   return;
      // } else {
      //   try {
      //     await this.loadDeficicencyComments();
      //   } catch (error) {
      //     console.error('Error loading external deficiency comments before status update:', error);
      //   }
      // }

    }

    if (!this.canProceedWithStatusUpdate()) {
      return;
    }
    // if (this.isApprovedOrPartiallyApprovedSelected()) {
    //   await this.showDialog();
    //   return;
    // }

    if (this.isApprovedOrPartiallyApprovedSelected()) {
      const applicationStatus = JSON.parse(this.sessionStorage.getItem('applicationStatus'));
      const isBgPending = typeof applicationStatus === 'string' && applicationStatus.toLowerCase().includes('bg pending');
      // if (isBgPending) {
      //   this.alertService.error('Your Background is not approved');
      //   return;
      // }
      const appType = JSON.parse(this.sessionStorage.getItem('currApplicationType'));
      if (appType === 'Name Change') {
        this.showStatusModal = true;
        return;
      }

      await this.showDialog();
      return;
    }

    const currentStatusKey = JSON.parse(this.sessionStorage.getItem('applicationStatus'));
    const selectedStatusKey = this.adddecisionForm.get('applicationStatus')?.value;

    const approvedStatuses = [
      'partially approved + bg approved',
      'partially approved + bg pending',
      'partially approved + bg denied',
      'analyst approved + bg approved',
      'analyst approved + bg pending',
      'analyst approved + bg denied',
      'analyst denied + bg approved',
      'analyst denied + bg denied',
      'analyst denied + bg pending',
      'analyst pending + bg approved',
      'analyst pending + bg denied',
      'analyst pending + bg pending',
      'deficiency pending + bg approved',
      'deficiency pending + bg denied',
      'deficiency pending + bg pending',
    ];
    const intakePendingStatus = '18';     // Replace with your actual key
    const normalizedCurrentStatus = String(currentStatusKey ?? '').trim().toLowerCase();

    if (
      approvedStatuses.includes(normalizedCurrentStatus) &&
      selectedStatusKey === intakePendingStatus &&
        this.unarchiveFromStatus !== null &&
  this.unarchiveFromStatus !== ''

    ){
      // return await this.alertService.success(
      //   'Changing the application status to Intake Pending will make the educator\'s current licenses/endorsements inactive pending. Do you want to continue?'
      // );
      this.showIntakePendingModal = true;
      return;
    }

    this.showStatusModal = true;
  }

  private canProceedWithStatusUpdate(): boolean {
    const licenses = this.licenseForm?.get('licenses') as FormArray | null;
    if (this.application_type === 'Name Change') {
      if (this.isPartiallyApprovedOrApprovedStatusSelected() && !this.showDeficiencyTab) {
        this.alertService.error(
          'Status cannot be updated to Approved. All deficiencies must be resolved.'
        );
        return false;
      }
      return true;
    } else {
      if (this.isPartiallyApprovedOrApprovedStatusSelected() && this.intakerole) {
        this.alertService.error(
          'Status can be updated to either Analyst or Deficiency.'
        );
        return false;
      }

      // Block "Approved" status if any resolution request is denied
      if (this.isApprovedStatusSelected() && this.hasDeniedResolutionRequests()) {
        this.alertService.error(
          'Status cannot be updated to Approved. One or more resolution requests were denied. Please select Partially Approved or another status.'
        );
        return false;
      }

      if (this.isAnalystStatusSelected() && !this.showDeficiencyTab) {
        this.alertService.error(
          this.errorMessages['M0174'] || 'Status cannot be updated to Analyst. All deficiencies must be resolved.'
        );
        return false;
      }

      if (this.isPartiallyApprovedOrAnalystDeniedStatusSelected()) {
        let val = !this.hasDnqPathwayInLicenseForm();
        if (!this.hasDnqPathwayInLicenseForm()) {
          this.alertService.error(
            this.errorMessages['M0176'] || 'Status cannot be updated to {Partially Approved / Analyst Denied}. No endorsement pathway is marked as DNQ.'
          );
          return false;
        }
        // if (licenses.value.length == 1 && this.hasDnqPathwayInLicenseForm()) {
        //   this.alertService.error(
        //     this.errorMessages['M0178'] || 'Status cannot be updated to Partially Approved. All endorsement pathways are marked as DNQ.'
        //   );
        //   return false;
        // }
        const allDNQ = this.licenseForm.getRawValue().licenses
          .flatMap((l: any) => l.endorsements || [])
          .every((e: any) => String(e.pathway) === '7');

        if (allDNQ && this.licenseForm.getRawValue().licenses.length && !this.isAnalystDeniedStatusSelected()) {
          this.alertService.error(
            this.errorMessages['M0178'] ||
            'Status cannot be updated to Partially Approved. All endorsement pathways are marked as DNQ.'
          );
          return false;
        }

        if (!this.hasDnqContent()) {
          this.showdnqerror = true;
          this.alertService.error(
            this.errorMessages['M0177'] || 'Status cannot be updated to {Partially Approved / Analyst Denied}. DNQ communication comments are required.'
          );
          return false;
        }

        this.showdnqerror = false;
      }

      if (this.isApprovedStatusRestrictedForDnq() && this.hasDnqPathwayInLicenseForm()) {
        this.alertService.error(
          this.errorMessages['M0175'] || 'Status cannot be updated to Approved. One or more endorsement pathways are marked as DNQ.'
        );
        return false;
      }

      if (this.isDeficiencyStatusSelected() && !this.hasDeficiencyComments()) {
        this.alertService.error(
          this.errorMessages['M0173'] || 'Status cannot be updated to Deficiency. External Deficiency comments are required.'
        );
        return false;
      }
      return true;
    }
  }

  private isDeficiencyStatusSelected(): boolean {
    return this.getSelectedStatusLabelLowerCase() === 'deficiency';
  }

  private isAnalystStatusSelected(): boolean {
    return this.getSelectedStatusLabelLowerCase() === 'analyst';
  }

  private isApprovedStatusRestrictedForDnq(): boolean {
    const selectedStatusLabel = this.getSelectedStatusLabelLowerCase();
    return selectedStatusLabel === 'approved' || selectedStatusLabel === 'analyst approved';
  }

  private isPartiallyApprovedOrAnalystDeniedStatusSelected(): boolean {
    const selectedStatusLabel = this.getSelectedStatusLabelLowerCase();
    return selectedStatusLabel === 'partially approved' || selectedStatusLabel === 'analyst denied';
  }

  private isAnalystDeniedStatusSelected(): boolean {
    const selectedStatusLabel = this.getSelectedStatusLabelLowerCase();
    return selectedStatusLabel === 'analyst denied';
  }

  private isPartiallyApprovedOrApprovedStatusSelected(): boolean {
    const selectedStatusLabel = this.getSelectedStatusLabelLowerCase();
    return true ? (selectedStatusLabel === 'partially approved' || selectedStatusLabel === 'approved') : false;
  }

  private isApprovedStatusSelected(): boolean {
    const selectedStatusLabel = this.getSelectedStatusLabelLowerCase();
    return selectedStatusLabel === 'approved' || selectedStatusLabel === 'analyst approved';
  }

  private hasDeniedResolutionRequests(): boolean {
    const provDenied = this.combinedProvisionRows?.some(item =>
      item?.resolution_requested === true && item?.mark_resolved_flag === false
    ) || false;
    const reqDenied = this.licenseRequirementRows?.some(item =>
      item?.resolution_requested === true && item?.mark_resolved_flag === false
    ) || false;
    return provDenied || reqDenied;
  }

  private getSelectedStatusLabelLowerCase(): string {
    const selectedStatusKey = this.adddecisionForm?.controls['applicationStatus']?.value;
    if (selectedStatusKey === null || selectedStatusKey === undefined || selectedStatusKey === '') {
      return '';
    }

    const selectedStatus = this.applicationStatusData.find(
      (item: any) => String(item?.key) === String(selectedStatusKey)
    );

    return String(selectedStatus?.value ?? this.statusval ?? '')
      .trim()
      .toLowerCase();
  }

  private hasDnqPathwayInLicenseForm(): boolean {
    const licenses = this.licenseForm?.get('licenses') as FormArray | null;
    if (!licenses || !Array.isArray(licenses.controls) || licenses.controls.length === 0) {
      return false;
    }


    return licenses.controls.some((licenseControl: AbstractControl) => {
      const endorsements = licenseControl.get('endorsements') as FormArray | null;
      if (!endorsements || !Array.isArray(endorsements.controls)) {
        return false;
      }

      return endorsements.controls.some((endorsementControl: AbstractControl) => {
        const pathway = endorsementControl.get('pathway')?.value;
        return this.isDnqPathwayValue(pathway);
      });
    });
  }

  private hasDeficiencyComments(): boolean {
    if (!Array.isArray(this.deficiencyCommentsData) || this.deficiencyCommentsData.length === 0) {
      return false;
    }

    return this.deficiencyCommentsData.some((item: any) => {
      const plainText = this.sanitizeHtmlToText(String(item?.note_text ?? ''))
        .replace(/&nbsp;/g, ' ')
        .trim();
      return plainText.length > 0;
    });
  }

  modalStatusConfirmClose() {
    this.showStatusModal = false;
  }


  licensetypeOnChange(value: string | number, licenseIndex: number): void {
    const licenseGroup = this.licenses.at(licenseIndex) as FormGroup;
    if (!licenseGroup) return;

    const endorsementsArray = licenseGroup.get('endorsements') as FormArray | null;

    const resetDates = () => {
      licenseGroup.get('expirationDate')?.setValue(null);
      endorsementsArray?.controls.forEach(e =>
        e.get('expirationDate')?.setValue(null)
      );
    };

    if (!value) {
      resetDates();
      return;
    }

    const durationEntry = this.licenseDurationData.find(
      (item: any) => String(item?.key) === String(value)
    );

    const years = parseInt(durationEntry?.Duration_values, 10);
    if (isNaN(years)) {
      resetDates();
      return;
    }

    const licenseBaseDate =
      licenseGroup.get('effectiveDate')?.value || this.today;

    const licenseExpiry = moment(licenseBaseDate).add(years, 'y').format('MM/DD/YYYY');
    licenseGroup.get('expirationDate')?.setValue(licenseExpiry);
    this.expirationDate = licenseExpiry;


    endorsementsArray?.controls.forEach(e => {
      const endorsementBaseDate =
        e.get('effectiveDate')?.value || licenseBaseDate || this.today;

      const endorsementExpiry = moment(endorsementBaseDate)
        .add(years, 'y')
        .format('MM/DD/YYYY');

      this.expirationDate = endorsementExpiry;

      e.get('expirationDate')?.setValue(endorsementExpiry);
    });
  }

  hasLicenseType(licenseGroup?: AbstractControl | null): boolean {
    const value = licenseGroup?.get('licenseType')?.value;
    return value !== null && value !== undefined && String(value).trim() !== '';
  }

  onDateChange(value: any, licenseIndex?: number): void {
    const selectedDate = this.normalizeDateToUsFormat(value);
    if (!selectedDate) {
      return;
    }

    if (licenseIndex !== undefined && licenseIndex !== null) {
      const licenseGroup = this.licenses.at(licenseIndex) as FormGroup | undefined;
      const licenseTypeControl = licenseGroup?.get('licenseType');
      if (!licenseTypeControl) {
        return;
      }

      if (!this.hasLicenseType(licenseGroup)) {
        licenseTypeControl.setErrors({ ...(licenseTypeControl.errors || {}), requiredForExpiration: true });
        return;
      }
    }

    this.warningDateFieldLabel = 'Expiration Date';
    this.warningTitleLabel = 'Expiration Date Notice';
    this.showModal = true;
  }

  onExpirationDateSelect(
    value: any,
    control?: AbstractControl | null,
    licenseIndex?: number
  ): void {
    const resolved = value?.value ?? value;
    if (control) {
      if (resolved instanceof Date && !isNaN(resolved.getTime())) {
        control.setValue(resolved);
      } else {
        const normalized = this.normalizeDateToUsFormat(resolved);
        if (normalized) {
          const parsed = moment(normalized, 'MM/DD/YYYY', true);
          if (parsed.isValid()) {
            control.setValue(parsed.toDate());
          }
        }
      }
      control.markAsTouched();
      control.updateValueAndValidity();
    }

    this.onDateChange(resolved, licenseIndex);
  }

  private toDateValue(value: any): Date | null {
    if (value === null || value === undefined || value === '') {
      return null;
    }

    if (value instanceof Date && !isNaN(value.getTime())) {
      return value;
    }

    const raw = String(value).trim();
    if (!raw) {
      return null;
    }

    const usDate = moment(raw, 'MM/DD/YYYY', true);
    if (usDate.isValid()) {
      return usDate.toDate();
    }

    const parsed = moment(raw, ['YYYY-MM-DD', moment.ISO_8601], true);
    return parsed.isValid() ? parsed.toDate() : null;
  }

  private toNullableValue(value: any): any {
    if (value === null || value === undefined) {
      return null;
    }

    if (typeof value === 'string') {
      const trimmed = value.trim();
      return trimmed === '' ? null : trimmed;
    }

    return value;
  }

  private toNullableUsDateString(value: any): string | null {
    if (value === null || value === undefined || value === '') {
      return null;
    }

    if (value instanceof Date && !isNaN(value.getTime())) {
      return moment(value).format('MM/DD/YYYY');
    }

    const raw = String(value).trim();
    if (!raw) {
      return null;
    }

    const strictUs = moment(raw, 'MM/DD/YYYY', true);
    if (strictUs.isValid()) {
      return strictUs.format('MM/DD/YYYY');
    }

    const parsed = moment(raw, ['YYYY-MM-DD', moment.ISO_8601], true);
    if (parsed.isValid()) {
      return parsed.format('MM/DD/YYYY');
    }

    return raw;
  }

  onManualDateBlur(index: number): void {
    const licenseGroup = this.licenses.at(index) as FormGroup;
    const control = licenseGroup.get('expirationDate');

    if (!control) return;


    const result = this.licenseForm.value.licenses
      .flatMap(l => l?.endorsements)
      .filter(e => e?.pathway === '7');

    if (result.length > 0) {
      const errors = { ...control.errors };
      delete errors['required'];
      control.setErrors(Object.keys(errors).length ? errors : null);
      return;
    }
    else {
      const value = String(control.value ?? '').trim();
      const errors = { ...(control.errors || {}) };
      if (value.length === 0) {
        errors['required'] = true;
      } else {
        delete errors['required'];
      }
      control.setErrors(Object.keys(errors).length ? errors : null);
    }

    // If user manually typed (dirty = true)
    if (control.dirty && String(control.value ?? '').trim().length > 0) {
      this.onProvDueDateChange(
        control.value,
        index,
        'lickind'
      );
    }
  }


  onManualEndorsementDateBlur(licenseIndex: number, endorsementIndex: number): void {

    const licenseGroup = this.licenses.at(licenseIndex) as FormGroup;
    const endorsementsArray = licenseGroup.get('endorsements') as FormArray;

    const endorsementGroup = endorsementsArray.at(endorsementIndex) as FormGroup;
    const control = endorsementGroup.get('expirationDate');

    if (!control) return;

    const result = this.licenseForm.value.licenses
      .flatMap(l => l?.endorsements)
      .filter(e => this.isDnqPathwayValue(e?.pathway));

    if (result.length > 0) {
      const errors = { ...(control.errors || {}) };
      delete errors['required'];
      control.setErrors(Object.keys(errors).length ? errors : null);
    }
    else {
      const value = String(control.value ?? '').trim();
      const errors = { ...(control.errors || {}) };
      if (value.length === 0) {
        errors['required'] = true;
      } else {
        delete errors['required'];
      }
      control.setErrors(Object.keys(errors).length ? errors : null);
    }

    // Trigger only if manually typed
    if (control.dirty && String(control.value ?? '').trim().length > 0) {

      this.onProvDueDateChange(
        control.value,
        licenseIndex,
        'lickind'   // same context you're using
      );
    }
  }


  onProvDueDateChange(
    value: any,
    licenseIndex?: number | null,
    context?: 'prolickind' | 'editprolickind' | 'prolicendo' | 'editprolicendo' | 'prolicreq' | 'lickind' | null
  ): void {
    void licenseIndex;
    const selectedDueDate = this.normalizeDateToUsFormat(value);
    const systemDueDate = this.getSystemCalculatedDueDate(context);

    if (context === 'prolicendo') {
      return;
    }

    if (context === 'prolicreq') {
      if (selectedDueDate && selectedDueDate !== this.lastSystemReqDueDate) {
        this.warningDateFieldLabel = 'Due Date';
        this.warningTitleLabel = 'Due Date Notice';
        this.showModal = true;
      }
      return;
    }
    if (context === 'prolickind') {
      if (selectedDueDate && this.lastSystemProvDueDate && selectedDueDate !== this.lastSystemProvDueDate) {
        this.warningDateFieldLabel = 'Due Date';
        this.warningTitleLabel = 'Due Date Notice';
        this.showModal = true;
      }
      return;
    }
    if (context === 'editprolicendo') {
      if (selectedDueDate && this.lastSystemEndoDueDate && selectedDueDate !== this.lastSystemEndoDueDate) {
        this.warningDateFieldLabel = 'Due Date';
        this.warningTitleLabel = 'Due Date Notice';
        this.showModal = true;
      }
      return;
    }
    if (context == 'lickind') {

      if (licenseIndex !== undefined && licenseIndex !== null) {
        const licenseGroup = this.licenses.at(licenseIndex) as FormGroup | undefined;
        const licenseTypeControl = licenseGroup?.get('licenseType');
        if (!licenseTypeControl) {
          return;
        }

        if (!this.hasLicenseType(licenseGroup)) {
          licenseTypeControl.setErrors({ ...(licenseTypeControl.errors || {}), requiredForExpiration: true });
          return;
        }
      }

      if (this.expirationDate == selectedDueDate) {
        return;
      }

      this.warningDateFieldLabel = 'Expiration Date';
      this.warningTitleLabel = 'Expiration Date Notice';
      this.showModal = true;
    }
    else {
      if (!selectedDueDate || !systemDueDate) {
        return;
      }

      if (selectedDueDate !== systemDueDate) {
        this.warningDateFieldLabel = 'Due Date';
        this.warningTitleLabel = 'Due Date Notice';
        this.showModal = true;
      }
    }


  }
  private normalizeDateToUsFormat(value: any): string | null {
    const resolved = value?.target?.value ?? value?.value ?? value;
    if (!resolved) {
      return null;
    }

    if (resolved instanceof Date && !isNaN(resolved.getTime())) {
      return moment(resolved).format('MM/DD/YYYY');
    }

    const raw = String(resolved).trim();
    if (!raw) {
      return null;
    }

    const strictUs = moment(raw, 'MM/DD/YYYY', true);
    if (strictUs.isValid()) {
      return strictUs.format('MM/DD/YYYY');
    }

    const parsedDate = moment(raw, ['YYYY-MM-DD', moment.ISO_8601], true);
    if (parsedDate.isValid()) {
      return parsedDate.format('MM/DD/YYYY');
    }

    return null;
  }

  private calculateProvisionBasedDueDate(provisionValue: any): string | null {
    const normalizedValue = String(provisionValue ?? '').trim();
    if (!normalizedValue) {
      return null;
    }

    if (normalizedValue === '2') {
      return moment().add(120, 'd').format('MM/DD/YYYY');
    }

    if (normalizedValue === '3' || normalizedValue === '4' || normalizedValue === '5') {
      return moment().add(3, 'y').format('MM/DD/YYYY');
    }

    return null;
  }

  private getSystemCalculatedDueDate(
    context?: 'prolickind' | 'editprolickind' | 'prolicendo' | 'editprolicendo' | 'prolicreq' | 'lickind' | null
  ): string | null {
    switch (context) {
      case 'prolickind':
        return this.calculateProvisionBasedDueDate(this.prolickindForm?.get('lickindprovision')?.value);
      case 'editprolickind':
        return this.calculateProvisionBasedDueDate(this.editprolickindForm?.get('lickindprovision')?.value);
      case 'prolicendo':
        return this.calculateProvisionBasedDueDate(this.prolicendoForm?.get('endoprovision')?.value);
      case 'editprolicendo':
        return this.calculateProvisionBasedDueDate(this.editprolicendoForm?.get('endoprovision')?.value);
      default:
        return null;
    }
  }



  modalClose() {
    this.showModal = false;
  }

  private setDnqPathwayKey(): void {
    this.dnqPathwayKey =
      this.endoPathwayData.find(
        (i: any) => String(i?.value || '').trim().toLowerCase() === 'dnq'
      )?.key ?? null;
  }

  private loadAdditionalEndorsementsFlag(): void {
    const applicationId = this.sessionStorage.getItem('applicationID');
    const personData = JSON.parse(this.sessionStorage.getItem('personData') || 'null');
    const userId =
      personData?.user_id ||
      this.sessionStorage.getItem('userIdForFetch') ||
      this.sessionStorage.getItem('id');

    if (!applicationId || !userId) {
      return;
    }

    this.httpService
      .post('/registration/applications', { userId })
      .pipe(take(1), takeUntil(this.destroy$))
      .subscribe({
        next: (response: any) => {
          const apps = response?.data?.data;
          if (!Array.isArray(apps)) {
            return;
          }
          const currentApplication = apps.find(
            (app: any) =>
              String(app.id) === String(JSON.parse(applicationId)) ||
              String(app.application_id) === String(JSON.parse(applicationId))
          );
          this.additionalEndorsementsRequired =
            currentApplication?.additional_endorsements === true;
          this.applyAdditionalPaymentPathwayLocks();
        },
        error: (error) => {
          console.error('Error loading additional_endorsements flag:', error);
        }
      });
  }

  private shouldDisablePathway(pathway: any, isNew: boolean): boolean {
    return this.additionalEndorsementsRequired
      && this.isDnqPathwayValue(pathway)
      && isNew === true;
  }

  /**
   * Disable Endorsement Pathway when additional_endorsements is required, pathway is DNQ,
   * and the endorsement is_new. Re-enables only is_new rows when conditions no longer apply
   * so Add Endorsement merge locks on non-new rows stay intact.
   */
  private applyAdditionalPaymentPathwayLocks(): void {
    if (this.isViewMode || !this.licenses?.controls?.length) {
      return;
    }

    this.licenses.controls.forEach((license: AbstractControl) => {
      const endorsements = license.get('endorsements') as FormArray | null;
      if (!endorsements) {
        return;
      }
      endorsements.controls.forEach((endorsement: AbstractControl) => {
        const pathwayControl = endorsement.get('pathway');
        const isNew = endorsement.get('is_new')?.value === true;
        if (!pathwayControl) {
          return;
        }
        if (this.shouldDisablePathway(pathwayControl.value, isNew)) {
          if (pathwayControl.enabled) {
            pathwayControl.disable({ emitEvent: false });
          }
        } else if (isNew && pathwayControl.disabled) {
          pathwayControl.enable({ emitEvent: false });
        }
      });
    });
  }

  /**
   * Resolve is_new as a strict boolean. Logs raw value/type so we can confirm DB bool shape in UI.
   * Prefer data.is_new; for Add Endorsement merge, !_fromApi means new.
   */
  private resolveIsNewFlag(data?: any): boolean {
    console.log('[LicenseBuilder] raw is_new:', data?.is_new, 'typeof:', typeof data?.is_new, '_fromApi:', data?._fromApi);
    if (data?.is_new === true) {
      return true;
    }
    if (data?.is_new === false) {
      return false;
    }
    if (data && Object.prototype.hasOwnProperty.call(data, '_fromApi')) {
      return data._fromApi !== true;
    }
    return false;
  }

  private updateDnqCommunicationVisibility(): void {
    const dnqKey = this.dnqPathwayKey;

    this.showDnqCommunication = this.licenses?.controls?.some(license => {
      const endorsements = license.get('endorsements') as FormArray | null;
      if (!endorsements) return false;

      return endorsements.controls.some(e => {
        const pathway = e.get('pathway')?.value;
        if (!pathway) return false;

        return dnqKey != null
          ? String(pathway) === String(dnqKey)
          : String(pathway).trim().toLowerCase() === 'dnq';
      });
    }) ?? false;
  }

  validateDnqLicenseType(): boolean {
    let isValid = true;
    const appType = JSON.parse(sessionStorage.getItem('currApplicationType'));
    if (appType == 'Name Change') {
      return isValid;
    }
    else {
      const result = this.licenseForm.value.licenses
        .filter(e => e.licenseType !== undefined && e.licenseType !== null);

      if (result.length == 0) {
        this.alertService.success("Please choose license type");
        isValid = false;
      }
    }

    return isValid;
  }

  private isGenerateLicenseStatus(status: any): boolean {
    const applicationStatus = JSON.parse(this.sessionStorage.getItem('applicationStatus'));
    const isBgPending = typeof applicationStatus === 'string' && applicationStatus.toLowerCase().includes('bg pending');

    if (status === null || status === undefined) {
      return false;
    }

    const normalized = String(status).trim().toLowerCase();
    if (!normalized) {
      return false;
    }

    if (normalized === '9' || normalized === '40') {
      if (!isBgPending) {
        return true;
      }
      else
        return false;
    }

    return normalized === 'approved'
      || normalized === 'partially approved'
      || normalized.startsWith('analyst approved')
      || normalized.startsWith('partially approved');
  }

  private setGenerateLicenseButtonFromNavigationStatus(): void {
    try {
      const navigationDataRaw = this.sessionStorage.getItem('navigationData');
      if (!navigationDataRaw) {
        return;
      }

      const navigationData = JSON.parse(navigationDataRaw);
      const status = navigationData?.bannerheader?.['Application Status'];
      this.showGenerateButton = this.isGenerateLicenseStatus(status);
    } catch (error) {
      console.warn('Unable to parse navigation data for application status.', error);
    }
  }

  loadDecisionStatusHistory(): Promise<void> {
    return new Promise((resolve, reject) => {
      const application_id = JSON.parse(this.sessionStorage.getItem('applicationID'));
      this.decisionService.getDecisionStatusHistory(application_id).subscribe({
        next: (data) => {
          const rows = Array.isArray(data?.data) ? data.data : [];
          console.log("rows......", rows);
          this.decisionStatusHistoryData = rows
            .map((item: any) => ({
              applicationStatus: item?.application_type || '',
              statusKey: item?.application_status ?? item?.application_status ?? null,
              updatedby: item?.person_name || '',
              updateddate: item?.occurred_date ? new Date(item.occurred_date) : null,
              applicationId: item?.application_id,
              personId: item?.person_id
            }))
            .sort((a: any, b: any) => {
              const ta = a.updateddate ? new Date(a.updateddate).getTime() : 0;
              const tb = b.updateddate ? new Date(b.updateddate).getTime() : 0;
              return tb - ta;
            });

          const latestStatus = this.decisionStatusHistoryData[0];
          console.log("this.decisionStatusHistoryData....", this.decisionStatusHistoryData);
          this.showGenerateButton = this.isGenerateLicenseStatus(
            latestStatus?.statusKey ?? latestStatus?.applicationStatus
          );

          resolve();
        },
        error: (error) => {
          console.error('Error getting person data:', error);
          reject(error);
        }
      });
    });
  }

  LicenseKindEndoDetails(): Promise<void> {
    return new Promise((resolve, reject) => {
      const application_id = JSON.parse(this.sessionStorage.getItem('applicationID'));
      this.decisionService.getLicenseKindEndoDetails(application_id).subscribe({
        next: (res) => {

          const licenseDetails = res?.data?.data || [];

          if (licenseDetails.length > 0) {
            this.patchLicenseDetails(licenseDetails);
            if (licenseDetails && licenseDetails[0]?.dnq_communication) {
              this.licenseForm.get('dnqdescription')?.patchValue(licenseDetails[0]?.dnq_communication, { emitEvent: false });
            }
          }
          resolve();
        },
        error: (err) => {
          console.error('Error loading license details', err);
          reject(err);
        }
      });
    });
  }

  patchLicenseDetails(licenseDetails: any[]) {
    this.patchFromApi = true;
    if (!licenseDetails?.length) return;

    // Create fast lookup by cd_endorsement (coerce to string so numeric vs string
    // mismatches between the two license APIs do not break the lookup).
    const lookup = new Map(
      licenseDetails.map(item => [String(item.cd_endorsement ?? ''), item])
    );

    this.licenses.controls.forEach((licenseGroup: FormGroup, index: number) => {

      const endorsementsArray = licenseGroup.get('endorsements') as FormArray;

      endorsementsArray.controls.forEach((endorsementGroup: FormGroup) => {

        const endorsementCodeRaw = endorsementGroup.get('endorsement')?.value;
        const endorsementCode = endorsementCodeRaw != null ? String(endorsementCodeRaw) : '';
        const matched = lookup.get(endorsementCode);

        if (!matched) {
          this.patchFromApi = false;
          return;
        }

        // 🔥 Patch endorsement-level fields
        endorsementGroup.patchValue({
          grade: matched.cd_grade || '',
          pathway: matched.endorsement_pathway || '',
          ...(matched.is_new !== undefined ? { is_new: matched.is_new === true } : {}),
          originalEffectiveDate: matched.end_original_issue_date
            ? moment(matched.end_original_issue_date).format('MM/DD/YYYY')
            : moment(this.today).format('MM/DD/YYYY'),
          effectiveDate: matched.end_issue_date
            ? moment(matched.end_issue_date).format('MM/DD/YYYY')
            : moment(this.today).format('MM/DD/YYYY'),
          expirationDate: matched.end_expiry_date
            ? moment(matched.end_expiry_date).format('MM/DD/YYYY')
            : ''
        }, { emitEvent: false });
        if (matched.is_new !== undefined) {
          console.log('[LicenseBuilder] patchLicenseDetails is_new:', matched.is_new, 'typeof:', typeof matched.is_new);
        }

        // 🔥 Patch license-level fields ONCE per group
        licenseGroup.patchValue({
          licenseType: matched.cd_license_type || '',
          effectiveDate: matched.issue_date
            ? moment(matched.issue_date).format('MM/DD/YYYY')
            : moment(this.today).format('MM/DD/YYYY'),
          expirationDate: matched.expiry_date
            ? moment(matched.expiry_date).format('MM/DD/YYYY')
            : ''
        }, { emitEvent: false });
        if (!this.patchFromApi)
          this.licensetypeOnChange(matched.cd_license_type, index)

      });

    });

    this.OnendPathwayChange(null);
    this.updateDnqCommunicationVisibility();
    this.applyAdditionalPaymentPathwayLocks();
  }
  containsHtml(value: any): boolean {
    if (!value || typeof value !== 'string') {
      return false;
    }
    return /<\/?[a-z][\s\S]*>/i.test(value);
  }
  loadDeficicencyComments(): Promise<void> {
    return new Promise((resolve, reject) => {
      const application_id = JSON.parse(this.sessionStorage.getItem('applicationID'));
      this.decisionService.getDeficicencyComments(application_id).subscribe({
        next: (data) => {
          const rows = Array.isArray(data?.data) ? data.data : [];
          const deficiencyCommentsData = rows
            ?.filter((item: any) => item.notes_type == 'deficiency')
            .map((item: any) => ({
              deficiency_type: item?.deficiency_type || '',
              created_by: item?.createdby || '',
              created_date: item?.created_date ? new Date(item.created_date) : null,
              note_text: item.note_text,
              review_status: item.review_status || '-',
              applicationId: item?.application_id,
              note_id: item.note_id,
              tab_name: item.tab_name,
              type: 'Non Document Deficiency',
              isHtml: item.note_text ? true : false,
            }));
          this.deficiencyCommentsData.push(...deficiencyCommentsData);
          this.internalCommentsData = rows
            ?.filter((item: any) => item.notes_type == 'internal')
            .map((item: any) => ({
              deficiency_type: item?.deficiency_type || '',
              created_by: item?.createdby || '',
              created_date: item?.created_date ? new Date(item.created_date) : null,
              note_text: item.note_text,
              review_status: item.review_status || '-',
              applicationId: item?.application_id,
              note_id: item.note_id,
              tab_name: item.tab_name
            }));
          this.isNoCommentsAvailable = this.deficiencyCommentsData.length === 0 && this.internalCommentsData.length === 0;
          resolve();
          this.loadDeficicencyDocuments();
        },
        error: (error) => {
          console.error('Error getting person data:', error);
          reject(error);
        }
      });
    });
  }


  //Harsha changes

  async showDialog(): Promise<void> {
    // Auto-save any pending resolution decisions before loading fresh data
    await this.saveResolutionDecisions();

    return new Promise((resolve, reject) => {
      const application_id = JSON.parse(this.sessionStorage.getItem('applicationID'));
      this.decisionService.getRequirementDescription(application_id).subscribe({
        next: (data) => {
          // Filter out resolved records (mark_resolved_flag === true)
          this.licensereq_descriptiondata = (data.data?.requirements || [])
            .filter((req: any) => req.mark_resolved_flag !== true);
          console.log('RAW requirements:', JSON.stringify(this.licensereq_descriptiondata, null, 2))
          this.license_number = data.data?.licensenumber?.[0]?.license_number;
          // this.licensekindpop_descriptiondata =  data.data?.licenseProvisions;
          // this.licenseendopop_descriptiondata =  data.data?.endoProvisions;
          // this.licensekindendopop_descriptiondata = [
          //   ...data.data?.licenseProvisions,
          //   ...data.data?.endoProvisions
          // ];
          const maparray = this.licenseForm.getRawValue().licenses;

          this.flattenedArray = maparray?.flatMap((license: any) =>
            license.endorsements?.map((endo: any) => ({
              licensekind: license?.licenseKind,
              grade: endo?.grade,
              originalEffectiveDate: endo.originalEffectiveDate,
              endorsement: this.licenseEndoName(endo?.endorsement?.toString()),
              licenseType: this.licenseTypeName(license?.licenseType?.toString()),
              effectiveDate: endo.effectiveDate,
              expirationDate: license.expirationDate,
              pathway: endo.pathway
            }))
          );

          // this.flattenedArray.map((item: any, index: number) => {
          //   const isDnqPathway = this.isDnqPathwayValue(item?.pathway);
          //   if (isDnqPathway) {
          //     this.flattenedArray.splice(index, 1);
          //   }
          // })

          const licenseProvisions = (data.data?.licenseProvisions || [])
            .filter((p: any) => p.mark_resolved_flag !== true);
          const endoProvisions = (data.data?.endoProvisions || [])
            .filter((p: any) => p.mark_resolved_flag !== true);

          // ✅ Step 1: Remove DNQ pathways safely
          this.flattenedArray = this.flattenedArray.filter(item =>
            !this.isDnqPathwayValue(item?.pathway)
          );

          // ✅ Step 2: Create lookup set
          const licenseKindSet = new Set(
            this.flattenedArray
              .map(item => item.licensekind)
              .filter(Boolean)
          );
          console.log('licenseKindSet:', Array.from(licenseKindSet));

          // ✅ Step 2: Create lookup set
          const endoSet = new Set(
            this.flattenedArray
              .map(item => item.endorsement)
              .filter(Boolean)
          );
          console.log('endoSet:', Array.from(endoSet));
          console.log('RAW licensereq_descriptiondata:', this.licensereq_descriptiondata);

          // ✅ Step 3: Filter license provisions
          // const filteredLicenseProvisions = licenseProvisions.filter(provision =>
          //   licenseKindSet.has(provision.license_kind_name)
          // );

          const filteredLicenseProvisions = licenseProvisions
            .map(provision => {
              if (!provision.license_kind_name) return null;

              // Split and clean
              const matchedKinds = provision.license_kind_name
                .split(',')
                .map(k => k.trim())
                .filter(k => licenseKindSet.has(k));

              if (matchedKinds.length === 0) return null;

              // Return updated object with only matched values
              return {
                ...provision,
                license_kind_name: matchedKinds.join(', ')
              };
            })
            .filter(Boolean);

          const filteredEndoProvisions = endoProvisions
            .map(provision => {
              if (!provision.endorsement_name) return null;

              // Split and clean
              const matchedKinds = provision.endorsement_name
                .split(',')
                .map(k => k.trim())
                .filter(k => endoSet.has(k));

              if (matchedKinds.length === 0) return null;

              // Return updated object with only matched values
              return {
                ...provision,
                endorsement_name: matchedKinds.join(', ')
              };
            })
            .filter(Boolean);



          // ✅ Step 3: Filter license provisions
          // const filteredLicenseReqProvisions = this.licensereq_descriptiondata.filter(provision =>
          //   licenseKindSet.has(provision.req_source)
          // );

          // ✅ Step 3: Filter Endorsement provisions
          // const filteredEndoReqProvisions = this.licensereq_descriptiondata.filter(provision =>
          //   endoSet.has(provision.req_source)
          // );

          // Split requirements by category first (mirrors provisions coming from two
          // separate APIs: licenseProvisions vs endoProvisions). This guarantees a
          // single record cannot appear in both filtered subsets.
          const licenseCategoryReqs = this.licensereq_descriptiondata.filter((req: any) =>
            req?.req_category === 'License Kind' || req?.req_category === 'License'
          );
          const endoCategoryReqs = this.licensereq_descriptiondata.filter((req: any) =>
            req?.req_category === 'Endorsement'
          );

          const filteredLicenseReqProvisions = licenseCategoryReqs
            .map((provision: any) => {
              if (!provision.req_source) return null;

              const matchedKinds = String(provision.req_source)
                .split(',')
                .map(k => k.trim())
                .filter(k => licenseKindSet.has(k));

              if (matchedKinds.length === 0) return null;

              return {
                ...provision,
                req_source: matchedKinds.join(', ')
              };
            })
            .filter(Boolean);
          console.log('filteredLicenseReqProvisions:', filteredLicenseReqProvisions);

          const filteredEndoReqProvisions = endoCategoryReqs
            .map((provision: any) => {
              if (!provision.req_source) return null;

              const matchedKinds = String(provision.req_source)
                .split(',')
                .map(k => k.trim())
                .filter(k => endoSet.has(k));

              if (matchedKinds.length === 0) return null;

              return {
                ...provision,
                req_source: matchedKinds.join(', ')
              };
            })
            .filter(Boolean);
          console.log('filteredEndoReqProvisions:', filteredEndoReqProvisions);



          this.licensekindendopop_descriptiondata = [
            ...filteredLicenseProvisions.map(item => ({
              type: 'LICENSE',
              provisionCode: item.cd_license_provision,
              provisionName: item.license_provision,
              kindOrEndoName: item.license_kind_name,
              additionalText: item.license_additional_text,
              dueDate: item.license_due_date
            })),

            ...filteredEndoProvisions.map(item => ({
              type: 'ENDORSEMENT',
              provisionCode: item.cd_endor_provision,
              provisionName: item.endor_provision,
              kindOrEndoName: item.endorsement_name,
              additionalText: item.endorsement_additional_text,
              dueDate: item.endorsement_due_date
            }))
          ];

          this.licensereq_descriptiondata = [
            ...filteredLicenseReqProvisions,
            ...filteredEndoReqProvisions
          ];

          this.showLicensePopup = true;
          resolve();
        },
        error: (error) => {
          console.error('Error getting person data:', error);
          reject(error);
        }
      });
    });

  }

  showDnqDialog() {
    this.dnqText = this.licenseForm.controls['dnqdescription'].value;
    this.currentDate = moment().format('MM/DD/YYYY');
    console.log("Editor Content:", this.dnqText);
    if (!this.hasDnqContent()) {
      this.showdnqerror = true;
    }
    else {
      this.showdnqerror = false;
      this.showDNQPopup = true;
      this.dnqduedate = this.resolveDnqDueDate();
      //document.getElementById('dnqDescription').innerHTML = this.dnqText;
    }

  }

  generateLicense() {
    console.log('License Generated!');
    this.showLicensePopup = false;
  }

  downloadLicense() {
    const data = this.licenseData;

    const licenseRows = this.flattenedArray.map(row => `
    <tr>
      <td>${row.licenseType} - ${row.licensekind}</td>
      <td>${row.effectiveDate ? moment(row.effectiveDate).format('MMM DD, YYYY') : '-'}</td>
      <td>${row.endorsement}</td>
      <td>${row.originalEffectiveDate ? moment(row.originalEffectiveDate).format('MMM DD, YYYY') : '-'}</td>
      <td>${row.expirationDate ? moment(row.expirationDate).format('MMM DD, YYYY') : '-'}</td>
    </tr>
  `).join('');

    const genericRows = (items: any[]) => items.map(item => `
    <tr>
      <td>${item.provisionName}</td>
      <td>${item.kindOrEndoName ? item.kindOrEndoName : ''}</td>
      <td style="text-align: left;">${item.additionalText ? item.additionalText : ''}</td>
      <td>${item.dueDate ? moment(item.dueDate).format('MMM DD, YYYY') : '-'}</td>
    </tr>
  `).join('');
    const genericRequirementRows = (items: any[]) => items.map(item => `
    <tr>
      <td>${item.req_category ? item.req_category : ''}</td>
      <td>${item.req_source ? item.req_source : ''}</td>
      <td>${item.req_name}</td>
      <td style="text-align: left;">${item.req_description}</td>
      <td >${item.due_date ? moment(item.due_date).format('MMM DD, YYYY') : '-'}</td>
    </tr>
  `).join('');

    const fullHtml = `
    <html>
      <head>
        <style>
         @import url('https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,400;0,500;0,600;0,700;1,400&display=swap');
        body {
    margin: 0;
    padding: 20px 40px 30px;
    background: #FFFFFF;
    font-family: 'Montserrat', sans-serif;
    color: #101010;
}

          .header { text-align: center; }
table {
    width: 100%;
    margin: 0 auto 25px;
    border-collapse: collapse;
    table-layout: fixed;
    background: transparent;
}

thead tr {
    background: #f8f9fa !important;
}

th {
    background: #f8f9fa !important;
    border: 0.5px solid #e9ecef;
    padding: 10px 10px;
    text-align: center;
    font-size: 12px;
    font-weight: 700;
    color: #495057;
    vertical-align: middle;
    line-height: 16px;
}

td {
    border: 0.5px solid #e9ecef;
    padding: 16px 16px;
    text-align: center;
    font-size: 12px;
    line-height: 20px;
    color: #495057;
    vertical-align: middle;
    word-break: break-word;
    overflow-wrap: break-word;
    background: transparent;
    font-weight:500 !important;
}
          .section-title {
          text-align: center;
    font-size: 16px;
    font-weight: 700;
    color: #4a7ba7;
    margin: 0px 0 20px;}

    @media print {
    @page {
        margin-top: 10mm;
        margin-bottom: 14mm;
        margin-left: 3mm;
        margin-right: 3mm;
    }

    @page :first {
        margin-top: 5mm;
    }

    body {
        background: #ffffff;
        padding: 0 15px;
    }

    .container {
        width: 100%;
        padding: 15px 40px 20px;
        background: #ffffff;
    }

    table {
        page-break-inside: auto;
         border-top: 1px solid #d7d7d7;
         border-bottom: 1px solid #d7d7d7;

    }

      thead {
        display: table-header-group;
    }


    tr {
        page-break-inside: avoid;
        page-break-after: auto;
    }

    td,
    th {
        page-break-inside: avoid;
    }

        .section-block {
        page-break-inside: avoid;  /* tries to keep whole block together */
    }

    .section-heading {
        page-break-after: avoid;
    }

    tbody tr:first-child td {
        page-break-before: avoid;
    }
}
        </style>
      </head>
      <body>
        <div class="header">
                          <div class="doc-logo-container">
       <img src="https://nevadadocs.blob.core.windows.net/customuserflow/edu-logo.svg" alt="Company Logo"  class="logo" />
        </div>
          <div>
            <p style="font-size: 13px; color: #000000; margin-bottom: 2px !important;">${this.license_number}</p>
            <p style="font-size: 15px; font-style: italic; color: #000000; margin-bottom: 5px;">This License Certifies that</p>
            <h2 style="font-size: 13px; color: #000000; margin: 0 0 5px 0; font-weight:500;">${this.educatorName}</h2>
          </div>

          <p style="margin: 18px auto 18px; text-align: center; font-size: 13px; line-height: 22px; color: #333333;">
            Has complied with the prescribed rules and regulations of the Commission on Professional Standards in Education and that the Superintendent of Public Instruction has granted this license which authorizes the holder to provide service in the schools of the State of Nevada in the following areas:
          </p>
        </div>

        <table>
          <thead>
            <tr>
              <th>License</th><th>Original Issue Date</th>
              <th>Endorsements</th><th>Issue Date</th><th>Expiration Date</th>
            </tr>
          </thead>
          <tbody>${licenseRows}</tbody>
        </table>

        ${this.licensekindendopop_descriptiondata.length > 0 ? `
        <div class="section-block">
        <div class="section-title">Provisions to be satisfied</div>
        <table>
          <thead>
            <tr><th>Provisions</th>
            <th> License Kind/Endorsement</th>
            <th>Additional Text</th>
            <th>Required Due Date</th></tr>
          </thead>
          <tbody>${genericRows(this.licensekindendopop_descriptiondata)}</tbody>
        </table>
        </div>
        ` : ''}
        ${this.licensereq_descriptiondata.length > 0 ? `
        <div class="section-block">
        <div class="section-title">License Requirements</div>
        <table>
          <thead>
            <tr>
            <th> Category</th>
            <th> Source </th>
            <th colspan="2">License Requirement</th>
            <th>Required Due Date</th></tr>
          </thead>
          <tbody>${genericRequirementRows(this.licensereq_descriptiondata)}</tbody>
        </table>
        </div>
        ` : ''}
      </body>
    </html>
  `;

    this.decisionService.generatePdf(fullHtml).subscribe({
      next: (blob) => {
        this.triggerFileDownload(blob, `License_${data.userName}.pdf`);
        this.showLicensePopup = false;
        const applicationStatus = JSON.parse(this.sessionStorage.getItem('applicationStatus'));
        const isBgPending = typeof applicationStatus === 'string' && applicationStatus.toLowerCase().includes('bg pending');
        if (!isBgPending) {
          this.updateIsPublishedLicense();
        }
      },
      error: (err) => console.error(err)
    });
  }

  private triggerFileDownload(blob: Blob, fileName: string) {
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = fileName;

    document.body.appendChild(link);
    link.click();

    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
  }

  transforData() {
    //this
    // this.licenseData.licenseDetails = this.licenseList.flatMap(license =>
    //   license.endorsements.map(endo => ({
    //     license: license.licenseKind,
    //     gradeLevel: endo.grade || 'N/A',
    //     originalIssueDate: endo.originalEffectiveDate || '---',
    //     endorsements: endo.endorsement,
    //     issueDate: endo.effectiveDate || license.effectiveDate || '---',
    //     expirationDate: endo.expirationDate || license.expirationDate || '---'
    //   }))
    // );

    this.licenseData.provisions = this.mapGenericList(this.licKindProvisionRows, 'provision');
    this.licenseData.requirements = this.mapGenericList(this.requirementsList, 'additionalText');

    console.log('Transformed License Data:', this.licenseData);
  }

  private mapGenericList(items: any[], descField: string) {
    return items.map(item => ({
      type: item.endorsement || item.licenseKind,
      description: item[descField] || '---',
      dueDate: item.dueDate || '---'
    }));
  }

  sendDnqCommunication() {
    const dnqText = this.adddecisionForm.get('dnq-description')?.value;

    console.log("Editor Content:", dnqText);
  }

  appstatusOnChange(value: any) {
    this.applicationStatusData.map((item: any) => {
      if (value == null) {
        this.statusval = '';
        this.showAppstatuserrmsg = true;
      }
      // else if (item.key == value) {
      //   this.statusval = item.value;
      //   this.showAppstatuserrmsg = false;
      //   if (item.value === 'Deficiency') {
      //     this.previewDefComments()
      //   }
      // }
      else if (item.key == value) {
        if (item.value === 'Intake') {
          const applicationStatus = this.sessionStorage.getItem('applicationStatus')?.replace(/"/g, '').replace(/\s+/g, ' ').trim();
          const allowedStatuses = [
            'Analyst Pending + BG Pending', 'Analyst Pending + BG Denied' ,'Analyst Pending + BG Approved', 'Partially Approved + BG Pending',
            'Partially Approved + BG Approved', 'Partially Approved + BG Denied',
            'Analyst Denied + BG Pending', 'Analyst Denied + BG Approved',
            'Analyst Denied + BG Denied', 'Analyst Approved + BG Pending', 'Analyst Approved + BG Approved',
            'Analyst Approved + BG Denied', 'Deficiency Pending + BG Approved', 'Deficiency Pending + BG Denied' ,
            'Deficiency Pending + BG Pending'
          ];
          const isAnalyst = this.roleId == 452 || this.roleId == 453 || this.roleId == 457;
          const isAnalystOrAdmin = isAnalyst || this.roleId == 2;
          const isAllowedStatus = allowedStatuses.includes(applicationStatus);

          if (isAnalystOrAdmin && isAllowedStatus) {
            this.statusval = item.value;
            this.showAppstatuserrmsg = false;
          } else if (!isAnalystOrAdmin) {
            this.alertService.error('You do not have permission to select Intake status.');
            this.adddecisionForm.controls['applicationStatus'].setValue('');
            this.statusval = '';
            return;
          } else if (!isAllowedStatus) {
            this.alertService.error('Intake status is not applicable for the current application status.');
            this.adddecisionForm.controls['applicationStatus'].setValue('');
            this.statusval = '';
            return;
          }
        } else {
          this.statusval = item.value;
          this.showAppstatuserrmsg = false;
        }
      }

    })
  }

  RequirementsName(value: any): string {
    if (value == null) {
      return '';
    }

    const status = this.licrequirementsData.find(
      (item: any) => item.key === value
    );

    return status ? status.value : '';
  }

  Requirementskey(value: any): string {
    if (value == null) {
      return '';
    }

    const status = this.licrequirementsData.find(
      (item: any) => item.value === value
    );

    return status ? status.key : '';
  }

  provisionsName(value: any): string {
    if (value == null) {
      return '';
    }

    const status = this.licenseProvisionsData.find(
      (item: any) => item.key === value
    );

    return status ? status.value : '';
  }

  provisionsKey(value: any): string {
    if (value == null) {
      return '';
    }

    const status = this.licenseProvisionsData.find(
      (item: any) => item.value === value
    );

    return status ? status.key : '';
  }

  licensekindName(value: any): string {
    if (value == null) {
      return '';
    }

    const status = this.licenseKindData.find(
      (item: any) => item.key === value
    );

    return status ? status.value : '';
  }

  licensekindKey(value: any): string {
    if (value == null) {
      return '';
    }

    const status = this.licenseKindData.find(
      (item: any) => item.value === value
    );

    return status ? status.key : '';
  }

  licenseEndoName(value: any): string {
    if (value == null) {
      return '';
    }

    const status = this.endorsementData.find(
      (item: any) => item.key === value
    );

    return status ? status.value : '';
  }

  licenseTypeName(value: any): string {
    if (value == null) {
      return '';
    }
    const status = this.licenseTypesData.find(
      (item: any) => item.key === value
    );

    return status ? status.value : '';
  }

  licenseendoKey(value: any): string {
    if (value == null) {
      return '';
    }

    const status = this.licenseKindData.find(
      (item: any) => item.value === value
    );
    // const status = this.endorsementData.find(
    //   (item: any) => item.value === value
    // );

    return status ? status.key : '';
  }

  licenseKindProvName(value: any): string {
    if (value == null) {
      return '';
    }

    const status = this.lickindProvTypedataCopy.find(
      (item: any) => item.key === value
    );

    return status ? status.value : '';
  }

  licenseEndoProvName(value: any): string {
    if (value == null) {
      return '';
    }

    const status = this.licendoProvTypedataCopy.find(
      (item: any) => item.key === value
    );

    return status ? status.value : '';
  }

  licenseKindProvKey(value: any): string {
    if (value == null) {
      return '';
    }

    const status = this.lickindProvTypedataCopy.find(
      (item: any) => item.value === value
    );

    return status ? status.key : '';
  }

  licenseEndoProvKey(value: any): string {
    if (value == null) {
      return '';
    }

    const status = this.licendoProvTypedataCopy.find(
      (item: any) => item.value === value
    );

    return status ? status.key : '';
  }

  sourceProvKey(value: any): string {
    if (value == null) {
      return '';
    }

    const status = this.editSourceOptions.find(
      (item: any) => item.value === value
    );

    return status ? status.key : '';
  }

  sourceProvKeyName(value: any): string {
    if (value == null) {
      return '';
    }

    const status = this.licendoProvTypedata.find(
      (item: any) => item.key === value
    );

    return status ? status.value : '';
  }

  resetLicenseKindProvision() {
    console.log(this.editId);
    console.log(this.licKindProvisionRows);
    this.licKindProvisionRows.map((item: any) => {
      if (item.lickind_id == this.editId) {

        this.editprolickindForm.controls['provdueDate'].patchValue(moment(item.dueDate).format('MM/DD/YYYY'));
        this.editprolickindForm.controls['provlickindaddText'].patchValue(item.additionalText);
        this.editprolickindForm.controls['provlickind'].patchValue(item.provlicenseKindId?.map(String) ?? []);
        this.editprolickindForm.controls['lickindprovision'].patchValue(this.licenseKindProvKey(item.provision));
        this.editprolickindForm.controls['lickindprovisiontype'].patchValue("1");
        this.provtypeOnChange("1");
      }
    });


  }

  resetLicenseEndoProvision() {
    console.log(this.editId);
    console.log(this.licEndoProvisionRows);
    this.licEndoProvisionRows.map((item: any) => {
      if (item.lickind_id == this.editId) {

        this.editprolicendoForm.controls['endodueDate'].patchValue(moment(item.dueDate).format('MM/DD/YYYY'));
        this.editprolicendoForm.controls['endoadditionalText'].patchValue(item.additionalText);
        this.editprolicendoForm.controls['provendorsement'].patchValue(item.provendoId?.map(String) ?? []);
        this.editprolicendoForm.controls['endoprovision'].patchValue(this.licenseEndoProvKey(item.provision));
        this.editprolicendoForm.controls['lickindprovisiontype'].patchValue("2");
        this.provtypeOnChange("2");
      }
    });

  }

  resetLicenseRequirementsPopup() {
    console.log(this.editId);
    console.log(this.licenseRequirementRows);
    this.licenseRequirementRows.map((item: any) => {
      if (item.lickind_id == this.editId) {
        this.editprolicreqForm.controls['type'].patchValue(item.type);
        // this.editprolicreqForm.controls['source'].patchValue(item.source);
        this.editprolicreqForm.controls['source'].patchValue(item.reqsourceId?.map(String) ?? []);
        this.editprolicreqForm.controls['reqdueDate'].patchValue(moment(item.reqdueDate).format('MM/DD/YYYY'));
        this.editprolicreqForm.controls['licrequirement'].patchValue(this.Requirementskey(item.requirement));

      }
    });

  }

  modalStatusClose() {
    this.modalService.dismissAll();
  }

  actionColumnWidth: number = 120;

  setActionColumnWidth(e) {
    const rows = e.component.getDataSource().items();

    let maxWidth = 120;
    const hasResolutionRows = rows.some(r => r?.resolution_requested === true);
    if (hasResolutionRows) {
      maxWidth = 200;
    }

    this.actionColumnWidth = maxWidth;
     e.component.updateDimensions();
  }

  sortedLicenseKindData: any[] = [];
  sortedendorsementData: any[] = [];

  buildSortedLicenseKindData(): void {
    const selected = this.editprolickindForm.get('provlickind')?.value ?? [];
    const data = this.lickindProvisionData.map((opt: any) => ({ ...opt, key: opt.key.toString() }));
    this.sortedLicenseKindData = [
      ...data.filter(opt => selected.includes(opt.key)),
      ...data.filter(opt => !selected.includes(opt.key))
    ];
  }

  buildSortedEndorsementData(): void {
    const selected = this.editprolicendoForm.get('provendorsement')?.value ?? [];
    const data = this.endorsementData.map((opt: any) => ({ ...opt, key: opt.key.toString() }));
    this.sortedendorsementData = [
      ...data.filter(opt => selected.includes(opt.key)),
      ...data.filter(opt => !selected.includes(opt.key))
    ];
  }

  onLicKindProvisionEdit(value: any, editModel: any) {

    // this.provlickindeditbtn = true;
    console.log('Selected IDs:', value?.data.provlicenseKindId);
    console.log('Option key type:', typeof this.licenseKindData[0].key);
    // console.log(typeof this.licensekindData[0].key);
    this.editprolickindForm.controls['lickindprovisiontype'].patchValue(value?.data.lickindprovisiontype);
    this.editprolickindForm.controls['provdueDate'].patchValue(moment(value?.data.dueDate).format('MM/DD/YYYY'));
    this.editprolickindForm.controls['provlickindaddText'].patchValue(value?.data.additionalText);
    this.editprolickindForm.controls['provlickind'].patchValue(value?.data?.provlicenseKindId?.map(id => id.toString()) ?? []);
    // this.editprolickindForm.controls['provlickind'].patchValue(value?.data.provlicenseKindId?.map(String) ?? []);
    this.editprolickindForm.controls['lickindprovision'].patchValue(this.licenseKindProvKey(value?.data.provision));
    this.editprolickindForm.controls['lickindprovisiontype'].patchValue("1");
    this.provtypeOnChange("1");
    this.editprolickindForm.controls['lickindprovision'].disable()
    this.buildSortedLicenseKindData();


    this.editId = value?.data.lickind_id;

    this.modalref = this.modalService.open(editModel, {
      size: 'md',
      backdrop: 'static',
      windowClass: 'add-appointment-details decision-edit-modal'
    });
  }

  onLicKindProvisionDelete(value: any, deleteModel: any) {
    this.editId = value?.data.lickind_id;
    this.showdeleteModal = true;
    this.modalref = this.modalService.open(deleteModel, {
      size: 'md',
      backdrop: 'static',
      windowClass: 'add-appointment-details decision-delete-modal'
    });

  }

  deleteRow(): Promise<void> {
    return new Promise((resolve, reject) => {
      const userFromSession = JSON.parse(this.sessionStorage.getItem('user'));
      const application_id = JSON.parse(this.sessionStorage.getItem('applicationID'));
      let obj = {
        "license_end_provision_id": this.editId,
        "application_id": application_id,
        "updated_by": userFromSession?.id
      };

      this.decisionService.deleteLicKindProvisions(obj).subscribe({
        next: (data) => {
          resolve();
          this.alertService.success("Deleted successfully.");
          this.getLicKindDeletedProvisions();
          this.getLicEndoDeletedProvisions();
          this.editId = '';
          this.modalStatusClose();
        },
        error: (error) => {
          console.error('Error getting person data:', error);
          reject(error);
        }
      });
    });
  }

  onLicEndoProvisionEdit(value: any, editModel1: any) {

    //this.provlicendoeditbtn = true;
    console.log('value?.data', value?.data);
    this.editId = value?.data.lickind_id;

    this.editprolicendoForm.controls['endodueDate'].patchValue(moment(value?.data.dueDate).format('MM/DD/YYYY'));
    this.lastSystemEndoDueDate = moment(value?.data.dueDate).format('MM/DD/YYYY');
    this.editprolicendoForm.controls['endoadditionalText'].patchValue(value?.data.additionalText);
    this.editprolicendoForm.controls['provendorsement'].patchValue(value?.data.provendoId?.map(String) ?? []);
    this.editprolicendoForm.controls['endoprovision'].patchValue(this.licenseEndoProvKey(value?.data.provision));
    this.editprolicendoForm.controls['lickindprovisiontype'].patchValue("2");
    this.provtypeOnChange("2");
    this.editprolicendoForm.controls['endoprovision'].disable()
    this.buildSortedEndorsementData();

    this.modalref = this.modalService.open(editModel1, {
      size: 'md',
      backdrop: 'static',
      windowClass: 'add-appointment-details decision-edit-modal'
    });

  }

  onLicRequirementEdit(value: any, editModel2: any) {
    console.log(value?.data);
    const originalSourceIds = value?.data?.reqsourceId?.map((id: any) => id.toString()) ?? [];
    const originalDueDate = value?.data?.reqdueDate
      ? moment(value.data.reqdueDate).format('MM/DD/YYYY')
      : '';

    this.originalEditRequirementSourceIds = originalSourceIds;
    this.originalEditRequirementDueDate = originalDueDate;
    this.editprolicreqForm.controls['type'].patchValue(value?.data.type);
    this.editprolicreqForm.controls['source'].patchValue(originalSourceIds);
    this.editprolicreqForm.controls['reqdueDate'].patchValue(originalDueDate);
    this.editprolicreqForm.controls['licrequirement'].patchValue(this.Requirementskey(value?.data.requirement));
    this.editId = value?.data.lickind_id;
    this.modalref = this.modalService.open(editModel2, {
      size: 'md',
      backdrop: 'static',
      windowClass: 'add-appointment-details decision-edit-modal'
    });
    this.handleEditTypeChange(value?.data.type);
  }

  handleEditTypeChange(selectedType: string) {

    if (selectedType === 'License Kind') {
      this.editSourceOptions = [...this.sortedLicenseKindData];
    }
    else if (selectedType === 'Endorsement') {
      this.editSourceOptions = [...this.endorsementProvisionData];
    }
  }
  onLicRequirementDeletePopup(value: any, deleteModel: any) {
    this.editId = value?.data.lickind_id;
    this.showdeleteModal = true;
    this.modalref = this.modalService.open(deleteModel, {
      size: 'md',
      backdrop: 'static',
      windowClass: 'add-appointment-details decision-delete-modal'
    });

  }

  onLicRequirementDelete(value: any): Promise<void> {

    return new Promise((resolve, reject) => {
      const userFromSession = JSON.parse(this.sessionStorage.getItem('user'));
      const application_id = JSON.parse(this.sessionStorage.getItem('applicationID'));
      let obj = {
        "application_license_requirement_id": this.editId,
        "application_id": application_id,
        "updated_by": userFromSession?.id
      };

      this.decisionService.deleteLicRequirements(obj).subscribe({
        next: (data) => {
          resolve();
          this.alertService.success("Deleted successfully.");
          this.getLicenseRequirements();
          this.editId = '';
          this.modalStatusClose();
        },
        error: (error) => {
          console.error('Error getting person data:', error);
          reject(error);
        }
      });
    });
  }

  loadLastSequenceNumber(): Promise<void> {
    return new Promise((resolve, reject) => {

      this.decisionService.getLastLicensenumber().subscribe({
        next: (data) => {
          resolve();
          this.license_number = parseInt(data?.data[0]?.license_number) + 1;

        },
        error: (error) => {
          console.error('Error getting person data:', error);
          reject(error);
        }
      });
    });
  }

  buildRequestPayload(
    formValue: any,
    application_id: number,
    person_id: number
  ) {
    const dnqContentHtml = this.getDnqContentHtml(formValue?.dnqdescription);
    const dnqDueDate = this.resolveDnqDueDate();
    const dnqCommunicationHtml = dnqContentHtml
      ? this.buildDnqCommunicationHtml(dnqContentHtml, dnqDueDate)
      : null;

    const sanitizedDnqDueDate = this.toNullableUsDateString(dnqDueDate);

    return {
      application_id,
      person_id,
      created_by: person_id,
      license_number: this.license_number,
      dnq_communication: this.licenseForm.controls['dnqdescription'].value ?? dnqCommunicationHtml,
      dnq_due_date: dnqCommunicationHtml ? sanitizedDnqDueDate : null,
      user_id: this.userSessionData?.id,
      dnq_publish_date: moment().format('MM/DD/YYYY'),
      licenses: formValue.licenses.map((license: any) => {
        const licenseKindId = this.toNullableValue(this.licensekindKey(license.licenseKind));

        return {
          licenseType: this.toNullableValue(license.licenseType),
          effectiveDate: this.toNullableUsDateString(license.effectiveDate),
          expirationDate: this.toNullableUsDateString(license.expirationDate),
          endorsements: license.endorsements.map((e: any) => {
            const isDnqPathway = this.isDnqPathwayValue(e.pathway);
            return {
              endorsement: this.toNullableValue(e.endorsement),
              grade: this.toNullableValue(e.grade),
              pathway: this.toNullableValue(e.pathway),
              originalEffectiveDate: this.toNullableUsDateString(e.originalEffectiveDate),
              effectiveDate: this.toNullableUsDateString(e.effectiveDate),
              expirationDate: this.toNullableUsDateString(e.expirationDate),
              licenseKind: licenseKindId,
              dnq_communication: isDnqPathway ? (this.licenseForm.controls['dnqdescription'].value ?? dnqCommunicationHtml) : null,
              dnq_due_date: isDnqPathway ? sanitizedDnqDueDate : null
            };
          })
        };
      })
    };
  }

  validateLB(event: any): Promise<void> {

    if ( this.analystrole && this.hasUnresolvedRequests()) {
      event.stopPropagation();
      this.alertService.error(this.errorMessages['M0211'] || 'Please approve or deny all pending resolution requests before proceeding.');
      return Promise.resolve();
    }

    if (this.analystrole && this.licenseForm.invalid) {
      if (this.patchFromApi) {
        const licensesArray = this.licenseForm.get('licenses') as FormArray;

        licensesArray.controls.forEach((licenseGroup: AbstractControl) => {

          const control = licenseGroup.get('effectiveDate');

          if (!control?.errors) return;

          const errors = { ...control.errors };

          delete errors['pastDateNotAllowed'];

          control.setErrors(Object.keys(errors).length ? errors : null);
        });
      }
      else {
        event.stopPropagation();
        this.licenseForm.markAllAsTouched();
        this.alertService.error('Please fill all mandatory Endorsement fields.');
        return Promise.resolve();
      }


    }
  }


  addLicenseKindEndoDetails(): Promise<void> {

    if (this.showDnqCommunication && !this.hasDnqContent()) {
      this.showdnqerror = true;
      this.alertService.error(this.errorMessages['M0158'] || 'DNQ Communication is required to save.');
      return Promise.resolve();
    }

    const application_id = JSON.parse(this.sessionStorage.getItem('applicationID'));
    const userFromSession = JSON.parse(this.sessionStorage.getItem('personData'));
    const person_id = userFromSession?.person_id;
    const appTypeval = JSON.parse(this.sessionStorage.getItem('currApplicationType'));
    let payload;
    let endoResult;
    let result;

    if (appTypeval == 'Add Endorsement') {
      payload = this.buildRequestPayload(this.licenseForm.getRawValue(), application_id, person_id);
      console.log(JSON.stringify(payload));

      endoResult = this.licenseForm.getRawValue().licenses.filter(e1 => e1.endorsements === undefined && e1.endorsements === null);

      result = this.licenseForm.getRawValue().licenses
        .flatMap(l => l.endorsements)
        .filter(e => e.pathway === '7'); // or == 7 if backend sends number
      if (result.length == 0) {
        if (!this.validateDnqLicenseType()) {
          return;
        }
      }
    } else {
      payload = this.buildRequestPayload(this.licenseForm.getRawValue(), application_id, person_id);
      console.log(JSON.stringify(payload));

      endoResult = this.licenseForm.getRawValue().licenses.filter(e1 => e1.endorsements === undefined && e1.endorsements === null);

      result = this.licenseForm.getRawValue().licenses
        .flatMap(l => l.endorsements)
        .filter(e => e.pathway === '7'); // or == 7 if backend sends number
      if (result.length == 0) {
        if (!this.validateDnqLicenseType()) {
          return;
        }
      }

    }

    // if(endoResult.length == 0){
    //   this.alertService.success("Please select an endorsement.");
    //   return;
    // }
    return new Promise((resolve, reject) => {

      this.decisionService.addLicenseKindEndoDetails(payload).subscribe({
        next: (data) => {
          resolve();
          this.license_number = parseInt(data?.data?.license_number);
          this.alertService.success("Added successfully.");
          this.patchValuetoApplicationStatusandAPICall();
          this.saveResolutionDecisions();
        },
        error: (error) => {
          console.error('Error getting person data:', error);
          this.alertService.error(error);
          reject(error);
        }
      });
    });

  }

  ondefcmntEdit(value: any, dialogHeader: string) {
    console.log(value?.data);
    this.editId = value.data.note_id;
    this.type = value.data.type;
    this.rowdnqcomments = value?.data.note_text;
    this.showintcmtsEditPopup = true;
    this.dialogHeader = dialogHeader;
  }

  onnotesEdit(value: any, dialogHeader: string) {
    console.log(value?.data);
    this.type = null;
    this.editId = value.data.note_id;
    this.rowdnqcomments = value?.data.note_text;
    this.showintcmtsEditPopup = true;
    this.dialogHeader = dialogHeader;
  }


  modaldefcmntsClose() {
    this.showdefcmntsEditPopup = false;
    this.showintcmtsEditPopup = false;
  }

  onDialogShow() {
    // Assign AFTER dialog opens
    setTimeout(() => {
      const container = document.getElementById('defcomments');

      if (container) {
        const editor = container.querySelector('.ql-editor');

        if (editor) {
          const p = editor.querySelector('p');

          if (p) {
            p.textContent = this.rowdnqcomments;
          } else {
            editor.innerHTML = '<p>this is a text</p>';
          }
        }
      }
    }, 0);
  }

  sanitizeHtmlToText(html: string): string {
    // Create a temporary DOM element
    const temp = document.createElement('div');
    temp.innerHTML = html;

    // Extract text content (strips all tags)
    return temp.textContent || temp.innerText || '';
  }


  saveDefComments(): Promise<void> {
    this.deficiencyCommentSubmitted = true;
    if (!this.isDefCommentValid()) {
      return;
    }
    const application_id = JSON.parse(this.sessionStorage.getItem('applicationID'));
    const userFromSession = JSON.parse(this.sessionStorage.getItem('user'));
    const updatedBy = userFromSession.firstname+ ' '+userFromSession.lastname;
    const person_id = userFromSession?.id;

    const plainText = this.sanitizeHtmlToText(this.rowdnqcomments);

    let payload = {
      "note_id": this.editId,
      "note_text": plainText,
      "application_id": application_id,
      "person_id": person_id,
      "type": this.type
    }

    return new Promise((resolve, reject) => {

      this.decisionService.updateDefCommentsById(payload).subscribe({
        next: (data) => {
          resolve();
          const deficiencyIndex = this.deficiencyCommentsData.findIndex(
            (item: any) => item.note_id === this.editId
          );
          const internalIndex = this.internalCommentsData.findIndex(
            (item: any) => item.note_id === this.editId
          );
          if (deficiencyIndex !== -1) {
            this.deficiencyCommentsData[deficiencyIndex].note_text = plainText;
            this.deficiencyCommentsData[deficiencyIndex].created_date = new Date();
            this.deficiencyCommentsData[deficiencyIndex].created_by = updatedBy; 
          }
          if (internalIndex !== -1) {
            this.internalCommentsData[internalIndex].note_text = plainText;
            this.internalCommentsData[internalIndex].created_date = new Date();
            this.internalCommentsData[internalIndex].created_by = updatedBy;
          }
          this.deficiencyCommentsData = [...this.deficiencyCommentsData];
          this.internalCommentsData = [...this.internalCommentsData];
          this.alertService.success("Added successfully.");
          this.editId = '';
          this.showdefcmntsEditPopup = false;
          this.showintcmtsEditPopup = false;
        },
        error: (error) => {
          console.error('Error getting person data:', error);
          reject(error);
        }
      });
    });

  }

  // previewDefComments() {
  //   this.showdefNotesPreview = true;
  //   let output = '';
  //   const grouped = this.deficiencyCommentsData.reduce((acc, item) => {
  //     const key = item.tab_name || "No Tab Name";
  //     if (!acc[key]) acc[key] = [];
  //     acc[key].push(item);
  //     return acc;
  //   }, {});
  //   if (grouped) {
  //     Object.keys(grouped).forEach(tab => {
  //       //output += `${item.tab_name}\n\t${item.deficiency_type}\n\t${item.note_text}\n`;
  //       output += `${tab}\n`;
  //       grouped[tab].forEach(item => {
  //         output += `\t${item.deficiency_type}\n`;
  //         output += `\t\t${item.note_text}\n\n`;
  //       });
  //       output += '\n';
  //       this.defcmntpopupdata = output;
  //     });
  //   }
  // }

  previewDefComments() {
    const personData = JSON.parse(this.sessionStorage.getItem('personData'))
    this.firstName = personData.first_name;
    this.lastName = personData.last_name;
    this.currentDate = moment().format('MM/DD/YYYY')
    this.defHeaderContent = `
    <p>${this.currentDate}</p>
    <p>Dear ${this.firstName} ${this.lastName},</p>
    <p style="line-height:24px; font-size:16px;">
      We are in receipt of your application. The application submitted cannot move forward in the evaluation process until the below items have been received. Please note that all items other than transcripts should be uploaded in your application. Instructions for uploading documents and resolving deficiencies can be found
      <a href="${this.resolvingGuideUrl}" target="_blank" style="color:#005A9C; text-decoration:none;">here</a>.
      For information on submitting your official transcript(s), please visit our
      <a href="${this.transcriptInfoUrl}" target="_blank" style="color:#005A9C; text-decoration:none;">website</a>.
    </p>
  `;
    this.defFooterContent = `<p style="line-height:24px; font-size:16px;">Your application will remain valid for thirty (30) days from the date of the first notice of deficiency. If you do not provide the required information within the thirty (30) days, you will need to submit a new application. This will include a new set of fingerprints and new application fee if both were required for your application.</p>

<p class="footer-signature">Thank you,
<span class="footer-signature-role" style="margin-top:10px; display:block;margin-bottom:3px;" >Office of Educator Licensure </span>
Nevada Department of Education</p>
`;
    this.showdefNotesPreview = true;
    this.groupedPreviewData = this.getGroupedDeficiencyComments("preview");
    this.defcmntpopupdata = this.buildDeficiencyPreviewText(this.groupedPreviewData);
  }

  private getGroupedDeficiencyComments(action: any): any {
    //   const sectionMap: { [key: number]: string } = {
    //   3488: 'Education Information',
    //   3522: 'Work Experience',
    //   3563: 'License Details',
    //   3564: 'Personal Information',
    //   3738: 'Professional Development'
    // };
    let comments = [];
    let defNotesComments = Array.isArray(this.deficiencyCommentsData) ? this.deficiencyCommentsData : [];
    defNotesComments = defNotesComments.filter(comment => ['Pending Review', 'Deficient'].includes(comment?.review_status));
    defNotesComments = defNotesComments
      .map((comment: any) => ({
        tab_name: comment.tab_name || 'No Tab Name',
        deficiency_type: comment.deficiency_type,
        note_text: action === "preview" ? this.sanitized.bypassSecurityTrustHtml(comment.note_text || '') : comment.note_text,
        type: comment.type
      }));
    comments.push(...defNotesComments);

    // let docDeficiencyComments = Array.isArray(this.documentDeficiencyCommentsData) ? this.documentDeficiencyCommentsData : [];
    // docDeficiencyComments = docDeficiencyComments.filter(comment => ['Deficient'].includes(comment?.review_status));
    // docDeficiencyComments = docDeficiencyComments
    // .map((comment: any) => ({
    //   tab_name : comment.tab_name || 'No Tab Name',
    //   deficiency_type : comment.deficiency_type,
    //   note_text : comment.note_text,
    //   type : comment.type
    // }));
    // comments.push(...docDeficiencyComments);


    const deficiencyOrderByTab: { [tabName: string]: { [deficiencyType: string]: number } } = {
      'Education Information': {
        'Academic Background': 1,
        'Academic Background - Document': 2,
        'Nevada Testing': 3,
        'Nevada Testing - Document': 4,
        'Other Testing': 5,
        'Other Testing - Document': 6
      },

      'Work Experience': {
        'Verifiable Business and Industry Work Experience': 1,
        'Verifiable Business and Industry Work Experience - Document': 2,
        'Verifiable Teaching Experience': 3,
        'Verifiable Teaching Experience - Document': 4
      },

      'License Details': {
        'Provider': 1,
        'Provider - Document': 2,
        'Out of State Licensure': 3,
        'Out of State Licensure - Document': 4,
        'License & Endorsements': 5,
        'License & Endorsements - Document': 6,
        'New License Kinds / Endorsements': 7,
        'New License Kinds / Endorsements - Document': 8
      },

      'Personal Information': {
        'Identity and Contact Information': 1,
        'Identity and Contact Information - Document': 2,
        'Address Information': 3,
        'Address Information - Document': 4,
        'Demographics': 5,
        'Demographics - Document': 6,
        'Name History': 7,
        'Name History - Document': 8,
        'Veteran Status': 9,
        'Veteran Status - Document': 10
      },

      'Professional Development': {
        'College / University Coursework': 1,
        'College / University Coursework - Document': 2,
        'District / Charter Employment': 3,
        'District / Charter Employment - Document': 4,
        'Additional Professional Development': 5,
        'Additional Professional Development - Document': 6
      }
    };

    const groupedComments = comments.reduce((acc: any, item: any) => {
      const key = item.tab_name || 'No Tab Name';
      if (!acc[key]) {
        acc[key] = [];
      }
      acc[key].push(item);
      return acc;
    }, {});

    Object.keys(groupedComments).forEach(tabName => {
      const orderMap = deficiencyOrderByTab[tabName] || {};
      groupedComments[tabName].sort((a: any, b: any) => {
        const aOrder = orderMap[a.deficiency_type] ?? 999;
        const bOrder = orderMap[b.deficiency_type] ?? 999;
        return aOrder - bOrder;
      });
    });

    return groupedComments;
    // return comments.reduce((acc: any, item: any) => {
    //     const key = item.tab_name || 'No Tab Name';
    //     if (!acc[key]) acc[key] = [];
    //     acc[key].push(item);
    //     return acc;
    //   }, {});
  }

  removeHtmlTags(htmlString: any) {
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = htmlString;
    return tempDiv.textContent || tempDiv.innerText || "";
  }

  private buildDeficiencyPreviewText(groupedData: any): string {
    if (!groupedData || Object.keys(groupedData).length === 0) {
      return '';
    }

    let output = '';
    // Object.keys(groupedData).forEach(tab => {
    //   output += `${tab}\n`;
    //   groupedData[tab].forEach((item: any) => {
    //     output += `\t${item?.deficiency_type || ''}\n`;
    //     output += `\t\t${item?.note_text || ''}\n\n`;
    //   });
    //   output += '\n';
    // });
    this.tabNamesOrder.forEach(tab => {
      if (groupedData[tab]) {
        output += `${tab}\n`;
        groupedData[tab].forEach((item: any) => {
          output += `\t${item?.deficiency_type || ''}\n`;
          output += `\t\t${item?.note_text || ''}\n\n`;
        });
        output += '\n';
      }
    });

    return output;
  }

  downloadDeficiency(): Promise<void> {
    const application_id = JSON.parse(this.sessionStorage.getItem('applicationID'));
    const groupedData = this.getGroupedDeficiencyComments("download");
    const notesText = this.defcmntpopupdata || this.buildDeficiencyPreviewText(groupedData);

    if (!notesText.trim()) {
      this.alertService.error('No external deficiency comments available to publish.');
      return Promise.resolve();
    }
    const styledDeficiencyHtml = this.tabNamesOrder
      .filter(tab => groupedData[tab])
      .map(tab => `
        <div style="margin-bottom:16px;">
          <div style="font-weight:bold;font-size:15px;color:#1a3c6e;border-bottom:2px solid #005A9C;padding-bottom:4px;margin-bottom:10px;">${tab}</div>
          ${groupedData[tab].map((item: any) => `
            <div style="margin-bottom:10px;padding-left:12px;">
              <div style="font-weight:600;font-size:14px;color:#333;margin-bottom:4px;">${item.deficiency_type || ''}</div>
              <div style="font-size:14px;color:#333;padding-left:10px;">${item.note_text || ''}</div>
            </div>
          `).join('')}
        </div>
      `).join('');
    const formatedNotesText = notesText.replace(/\n/g, '<br>').replace(/\t/g, '&nbsp;&nbsp;');
    // const formatedEmailText = `<div style="padding:25px">
    // <div class="previewimageconatiner" style="text-align:center">
    //           <img class="previewimage" style="text-align:center" src="https://nevadadocs.blob.core.windows.net/customuserflow/edu-logo.svg" alt="Logo" />
    // </div>
    //                   ${this.defHeaderContent}
    //                   ${styledDeficiencyHtml}
    //                   ${this.defFooterContent}</div>`
    const formatedEmailText = `
  <html>
    <head>
      <style>
        @page {
          margin: 30px 25px;
        }
        body {
          margin: 0;
          padding: 10px 25px;
          font-family: Arial, sans-serif;
        }
      </style>
    </head>
    <body>
      <div>
        <div class="previewimageconatiner" style="text-align:center">
          <img class="previewimage" style="text-align:center" src="https://nevadadocs.blob.core.windows.net/customuserflow/edu-logo.svg" alt="Logo" />
        </div>
        ${this.defHeaderContent}
        ${styledDeficiencyHtml}
        ${this.defFooterContent}
      </div>
    </body>
  </html>`
    const postData = {
      applicationId: application_id, // sessionStorage.getItem('applicationID'),
      content: `${formatedEmailText}`,
      authToken: `Bearer ${sessionStorage.getItem('jwt-token')}`

    };
    const headers = {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: `Bearer ${sessionStorage.getItem("jwt-token")}`,
      // `Bearer ${sessionStorage.getItem("jwt-token")}`,
    };

    return new Promise((resolve, reject) => {

      this.decisionService.downloadDeficiency(postData).subscribe({
        next: (data) => {
          resolve();
          this.alertService.success("Status updated successfully.");
          this.editId = '';
          this.showdefNotesPreview = false;
        },
        error: (error) => {
          console.error('Error getting person data:', error);
          reject(error);
        }
      });
    });
  }

  provtypeOnChange(value: any): Promise<void> {
    return new Promise((resolve, reject) => {
      const application_id = JSON.parse(this.sessionStorage.getItem('applicationID'));
      this.decisionService.provtypechange(value).subscribe({
        next: (data) => {
          resolve();
          console.log(data.data);
          this.lickindProvTypedata = data?.data
            ?.filter((item: any) => item.lookupcategoryid == 414)
          this.licendoProvTypedata = data?.data
            ?.filter((item: any) => item.lookupcategoryid == 415)
          this.lickindProvTypedataCopy = data?.data
            ?.filter((item: any) => item.lookupcategoryid == 414)
          this.licendoProvTypedataCopy = data?.data
            ?.filter((item: any) => item.lookupcategoryid == 415)

          this.getLicKindProvisions();
          this.getLicenseRequirements();
          this.getLicEndoProvisions();

        },
        error: (error) => {
          console.error('Error getting person data:', error);
          reject(error);
        }
      });
    });
  }

  lickindprovisionOnChange(value: any) {
    if (this.prolickindForm.controls['lickindprovision'].value == 2) {
      const days = 120;
      const licenseExpiry = moment().add(days, 'd').format('MM/DD/YYYY');
      this.lastSystemProvDueDate = licenseExpiry;
      this.prolickindForm.controls['provdueDate'].setValue(licenseExpiry)
    }
    else if (this.prolickindForm.controls['lickindprovision'].value == 3 || this.prolickindForm.controls['lickindprovision'].value == 4
      || this.prolickindForm.controls['lickindprovision'].value == 5
    ) {
      const years = 3;
      const licenseExpiry = moment().add(years, 'y').format('MM/DD/YYYY');
      this.lastSystemProvDueDate = licenseExpiry;
      this.prolickindForm.controls['provdueDate'].setValue(licenseExpiry)
    }

  }

  editProlickindprovisionOnChange(value: any) {
    if (this.editprolickindForm.controls['lickindprovision'].value == 2) {
      const days = 120;
      const licenseExpiry = moment().add(days, 'd').format('MM/DD/YYYY');
      this.editprolickindForm.controls['provdueDate'].setValue(licenseExpiry)
    }
    else if (this.editprolickindForm.controls['lickindprovision'].value == 3 || this.editprolickindForm.controls['lickindprovision'].value == 4
      || this.editprolickindForm.controls['lickindprovision'].value == 5
    ) {
      const years = 3;
      const licenseExpiry = moment().add(years, 'y').format('MM/DD/YYYY');
      this.editprolickindForm.controls['provdueDate'].setValue(licenseExpiry)
    }

  }

  onlickindprovisionDropdownClear() {
    this.editprolickindForm.controls['provdueDate'].setValue(null)
  }

  formatDateInput(event: any, control?: AbstractControl | null) {
    const domEvent = event?.originalEvent || event;
    const target = domEvent?.target || event?.target;
    if (!target) {
      return;
    }

    const inputType = String(domEvent?.inputType || '');
    const isDeleteAction = inputType.startsWith('delete');
    const currentValue = String(target.value || '');

    let value = '';
    if (isDeleteAction) {
      // Keep user deletion as-is; do not re-insert "/" while backspacing.
      value = currentValue.replace(/[^\d/]/g, '').slice(0, 10);
    } else {
      const digitsOnly = currentValue.replace(/\D/g, '').slice(0, 8);
      if (digitsOnly.length <= 2) {
        value = digitsOnly;
      } else if (digitsOnly.length <= 4) {
        value = `${digitsOnly.substring(0, 2)}/${digitsOnly.substring(2)}`;
      } else {
        value = `${digitsOnly.substring(0, 2)}/${digitsOnly.substring(2, 4)}/${digitsOnly.substring(4)}`;
      }
    }

    target.value = value;
    if (control) {
      control.setValue(value, { emitEvent: false });
      control.updateValueAndValidity({ emitEvent: false });
    }
  }

  onDropdownClear(index: number) {
    const licenseGroup = this.licenses.at(index) as FormGroup;
    const ctrl = licenseGroup.value.endorsements[0].endorsement;
    ctrl?.setValue(null);
    ctrl?.markAsTouched();
    ctrl?.updateValueAndValidity();
    this.loadAllGrades();
  }

  OnChange(value: any) {
    this.loadAllGrades();
  }

  downloadDNQ() {
    const dnqContentHtml = this.getDnqContentHtml(this.licenseForm.controls['dnqdescription']?.value || this.dnqText);
    if (!dnqContentHtml) {
      this.showdnqerror = true;
      this.alertService.error(this.errorMessages['M0158'] || 'DNQ Communication is required to publish.');
      return;
    }

    this.dnqduedate = this.resolveDnqDueDate();
    this.persistDnqCommunicationFromPublish()
      .then(() => {
        const fullHtml = `<html>${this.buildDnqCommunicationHtml(dnqContentHtml, this.dnqduedate)}</html>`;
        this.decisionService.generatePdf(fullHtml).subscribe({
          next: (blob) => {
            this.triggerFileDownload(blob, `DNQ_${this.userSessionData.firstname}.pdf`);
            this.showDNQPopup = false;
          },
          error: (err) => console.error(err)
        });
      })
      .catch((error) => {
        console.error('DNQ save failed before publish:', error);
        this.alertService.error('Failed to save DNQ communication.');
      });
  }

  openDatePicker(event?: Event, license?: any, value?: any) {
    this.openDatePickerForControl(
      event,
      license?.get('effectiveDate'),
      value
    );
  }

  openDatePickerForControl(
    event?: Event,
    control?: AbstractControl | null,
    inputElementId?: string,
    maxDateIso?: string,
    dueDateContext?: 'prolickind' | 'editprolickind' | 'prolicendo' | 'editprolicendo' | 'prolicreq' | 'lickind' | null,
    index?: null
  ): void {
    if (event) {
      event.stopPropagation();
    }

    const anchorInput = inputElementId ? document.getElementById(inputElementId) : null;
    if (!anchorInput) return;

    const rect = anchorInput.getBoundingClientRect();

    const openModal = document.querySelector('ngb-modal-window .modal-dialog') as HTMLElement
      || document.querySelector('.modal.show .modal-dialog') as HTMLElement
      || document.querySelector('.modal-dialog') as HTMLElement;

    let modalRect = {
      left: 0,
      right: window.innerWidth,
      top: 0,
      bottom: window.innerHeight,
      width: window.innerWidth
    };

    if (openModal) {
      const mr = openModal.getBoundingClientRect();
      if (mr.width > 0 && mr.height > 0) {
        modalRect = {
          left: mr.left,
          right: mr.right,
          top: mr.top,
          bottom: mr.bottom,
          width: mr.width
        };
      }
    }

    const calendarHeight = 320;
    const calendarWidth = Math.min(280, modalRect.width - 20);

    const spaceBelow = window.innerHeight - rect.bottom;
    const spaceAbove = rect.top;

    let topPos: number;
    if (spaceBelow >= calendarHeight) {
      topPos = rect.bottom;
    } else if (spaceAbove >= calendarHeight) {
      topPos = rect.top - calendarHeight;
    } else {
      topPos = spaceBelow >= spaceAbove
        ? rect.bottom
        : rect.top - calendarHeight;
    }

    let leftPos = rect.left;
    if (leftPos + calendarWidth > modalRect.right - 5) {
      leftPos = modalRect.right - calendarWidth - 5;
    }
    if (leftPos < modalRect.left + 5) {
      leftPos = modalRect.left + 5;
    }

    const dateInput = document.createElement('input');
    dateInput.type = 'date';
    dateInput.style.cssText = `
    position: fixed;
    top: ${topPos}px;
    left: ${leftPos}px;
    width: ${rect.width}px;
    height: 1px;
    opacity: 0.01;
    border: none;
    padding: 0;
    margin: 0;
    z-index: 999999;
    pointer-events: auto;
    font-size: 16px;
  `;

    dateInput.min = new Date().toISOString().split('T')[0];
    if (maxDateIso) {
      dateInput.max = maxDateIso;
    }

    const currentValue = control?.value;
    if (typeof currentValue === 'string' && currentValue.includes('/')) {
      const parts = currentValue.split('/');
      if (parts.length === 3 && parts[2].length === 4) {
        dateInput.value = `${parts[2]}-${parts[0].padStart(2, '0')}-${parts[1].padStart(2, '0')}`;
      }
    }

    document.body.appendChild(dateInput);

    const cleanup = () => {
      if (document.body.contains(dateInput)) {
        dateInput.removeEventListener('change', changeHandler);
        dateInput.removeEventListener('blur', blurHandler);
        document.body.removeChild(dateInput);
      }
    };

    const changeHandler = (changeEvent: any) => {
      const selectedDate = changeEvent.target.value;
      if (selectedDate && control) {
        const [year, month, day] = selectedDate.split('-');
        const formattedDate = `${month}/${day}/${year}`;
        control.setValue(formattedDate);
        control.markAsTouched();
        control.updateValueAndValidity();
        if (dueDateContext) {
          this.onProvDueDateChange(formattedDate, index, dueDateContext);
        }
      }
      cleanup();
    };

    const blurHandler = () => setTimeout(cleanup, 150);

    dateInput.addEventListener('change', changeHandler);
    dateInput.addEventListener('blur', blurHandler);

    setTimeout(() => {
      dateInput.focus();
      try {
        const pickerFn = (dateInput as any).showPicker;
        if (typeof pickerFn === 'function') {
          pickerFn.call(dateInput);
        } else {
          (dateInput as HTMLInputElement).click();
        }
      } catch {
        (dateInput as HTMLInputElement).click();
      }
    }, 0);
  }

  isDefCommentValid(): boolean {
    if (!this.rowdnqcomments) {
      return false;
    }
    const text = this.rowdnqcomments.replace(/<[^>]*>/g, '').trim();
    return text.length > 0;
  }

  private isDnqPathwayValue(pathway: any): boolean {
    if (pathway === null || pathway === undefined || pathway === '') {
      return false;
    }
    if (this.dnqPathwayKey != null && String(pathway) === String(this.dnqPathwayKey)) {
      return true;
    }
    const normalized = String(pathway).trim().toLowerCase();
    return normalized === '7' || normalized === 'dnq';
  }

  private getDnqContentHtml(value: any): string {
    const rawHtml = value == null ? '' : String(value).trim();
    if (!rawHtml) {
      return '';
    }
    const textOnly = rawHtml.replace(/<[^>]*>/g, '').trim();
    return textOnly ? rawHtml : '';
  }

  private hasDnqContent(): boolean {
    return !!this.getDnqContentHtml(this.licenseForm.controls['dnqdescription']?.value);
  }

  private persistDnqCommunicationFromPublish(): Promise<void> {
    const application_id = JSON.parse(this.sessionStorage.getItem('applicationID'));
    const userFromSession = JSON.parse(this.sessionStorage.getItem('personData'));
    const person_id = userFromSession?.person_id;
    const payload = this.buildRequestPayload(this.licenseForm.getRawValue(), application_id, person_id);

    return new Promise((resolve, reject) => {
      this.decisionService.addLicenseKindEndoDetails(payload).subscribe({
        next: () => resolve(),
        error: (error) => reject(error)
      });
    });
  }

  private resolveDnqDueDate(): string {
    if (this.dnqduedate) {
      return this.dnqduedate;
    }
    return moment().add(45, 'days').format('MM/DD/YYYY');
  }

  private escapeHtml(value: any): string {
    const text = value == null ? '' : String(value);
    return text
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  private buildDnqCommunicationHtml(dnqContentHtml: string, dueDate: string): string {
    const safeEducatorName = this.escapeHtml(this.educatorName || '');
    const safeApplicationNumber = this.escapeHtml(this.applicationNumber || '');
    const safeDueDate = this.escapeHtml(dueDate || '');
    this.currentDate = moment().format('MM/DD/YYYY')

    return `
  <html>
  <head>
    <style>
      @page {
        margin: 50px 50px;
      }
      body {
        margin: 0;
        padding: 0;
      }
      p:has(> br:only-child) {
        line-height: 0 !important;
        margin: 0 !important;
        padding: 0 !important;
      }
    </style>
  </head>
  <body>
    <div style="font-family: Arial, sans-serif;  color: #333;">
        <div class="previewimageconatiner" style="text-align:center; margin-bottom:15px;">
          <img class="previewimage" style="text-align:center" src="https://nevadadocs.blob.core.windows.net/customuserflow/edu-logo.svg" alt="Logo" />
        </div>
      <p style="font-size: 18px; margin: 0 0 14px 0;">${this.currentDate}</p>
      <p style="font-size: 18px; margin: 0 0 14px 0;">Dear ${safeEducatorName},</p>
      <p style="line-height:24px; font-size:18px; margin-bottom: 0;">Your application has been evaluated and does not meet the requirements. You must meet the
            requirements below for your application to be approved. Please note that if any additional documents are required,
            they should be uploaded in your portal. For information on submitting official transcript(s), please visit our
      <a href="${this.transcriptInfoUrl}" target="_blank" style="color:#005A9C; text-decoration:none;">website</a>.
      </p>
         <h6 style="font-weight: 700 !important; margin-bottom: .5rem; font-size:18px; margin-top: .8rem; color:#1a3c6e;border-bottom:2px solid #005A9C;"> DNQ Communication - External </h6>
      <div style="font-size: 18px; line-height:26px; margin-bottom:0px;">${dnqContentHtml}</div>
      <p style="line-height:24px; font-size:18px;">
            Your application will remain valid for thirty (30) days from the date of the first notice of denial. If you do not
            provide the required information within the thirty (30) days, you will need to submit a new application. This will
            include a new set of fingerprints and new application fee if both were required for your application.
        </p>
        <p class="footer-signature">Thank you,
        <span class="footer-signature-role" style="margin-top:10px; display:block;margin-bottom:3px;" >
        ${this.analystName} </span>
        <span class="footer-signature-role" style="display:block;margin-bottom:3px;" >
        Office of Educator Licensure </span>
        Nevada Department of Education</p>
      </div>
  </body>
  </html>
`;
  }

  private loadDropdownData(): void {
    this.httpService.get('/domain/lookup?requestType=MESSAGES')
      .subscribe({
        next: (res: any) => {
          if (res?.data) {
            res.data.forEach((msg: any) => {
              this.errorMessages[msg.key] = msg.value;
            });
          }
        },
        error: (error) => {
          console.error('Error loading error messages:', error);
        }
      });
  }

  ShowDeficiencyBuilderTab(): Promise<boolean> {
    return new Promise((resolve) => {
      this.myAppService
        .getAppData(`appId=${JSON.parse(this.sessionStorage.getItem('applicationID'))}`)
        .pipe(take(1))
        .subscribe({
          next: (appResponse) => {
              this.unarchiveFromStatus = appResponse?.data?.data?.[0]?.unarchive_from_status ?? null;
            let targetApiKeys = [
              "license_endorsement_validation",
              "outofstate_validation",
              "provider_validation",
              "identity_contact_validation",
              "address_info_validation",
              // "demographics_validation",
              "name_history_validation",
              "veteran_status_validation",
              // "acknolegdement_validation",
              "academic_background_validation",
              "nevada_testing_validation",
              "out_of_state_testing_validation",
              "industry_experience_validation",
              "teaching_experience_validation",
              // "history_disclosure_validation",
              // "child_support_disclosure",
              // "oathof_office_validation",
              // "nb_license_validation",
            ];
            const appType = JSON.parse(sessionStorage.getItem('currApplicationType'));
            const isResolve = appType === 'Resolve';
            const eduationTab = ['Regular - Initial', 'ARL (Alternative Route to Licensure)'].includes(appType)
            const personalinfoTab = ['Name Change'].includes(appType)
            const personalinfoBgTab = ['Add Endorsement'].includes(appType)
            const licenseTab = ['Apprentice', 'ARL (Alternative Route to Licensure)'].includes(appType)
            const licenseTab2 = ['Regular - Initial'].includes(appType)
            const finalKeys = targetApiKeys.filter(key => {
              if (isResolve) {
                const allowedResolveKeys = [
                  "outofstate_validation",
                  "identity_contact_validation",
                  "address_info_validation",
                  "demographics_validation",
                  "name_history_validation",
                  "veteran_status_validation",
                  "academic_background_validation",
                  "nevada_testing_validation",
                  "out_of_state_testing_validation",
                  "industry_experience_validation",
                  "teaching_experience_validation"
                ];
                return allowedResolveKeys.includes(key);
              }
              if (["out_of_state_testing_validation", "nevada_testing_validation"].includes(key) && !eduationTab && !personalinfoBgTab) return false;
              if (["identity_contact_validation", "address_info_validation", "demographics_validation", "veteran_status_validation", 'license_endorsement_validation', 'academic_background_validation', 'history_disclosure_validation', 'child_support_disclosure'].includes(key) && personalinfoTab) return false;
              if (["acknolegdement_validation"].includes(key) && !personalinfoTab) return false;
              if (["provider_validation"].includes(key) && !licenseTab) return false;
              if (["identity_contact_validation", "address_info_validation", "demographics_validation", "veteran_status_validation", 'outofstate_validation', 'history_disclosure_validation', 'name_history_validation', 'child_support_disclosure', 'provider_validation'].includes(key) && personalinfoBgTab) return false;
              if (["outofstate_validation", "industry_experience_validation", "teaching_experience_validation"].includes(key) && !licenseTab2 && !personalinfoBgTab) return false;
              return true;
            });
            this.showDeficiencyTab = finalKeys.every(key => appResponse?.data?.data[0][key] === 'valid') || false;
            console.log('Deficiency Tab Visibility:', this.showDeficiencyTab);
            resolve(this.showDeficiencyTab);
          },
          error: (error) => {
            console.error('Error getting app data:', error);
            this.showDeficiencyTab = false;
            resolve(false);
          }
        });
    });
  }


  onNoteDelete(data: any, noteDeleteModel: any) {
    this.deleteId = data.data.note_id;
    this.modalref = this.modalService.open(noteDeleteModel, {
      size: 'md',
      backdrop: 'static',
      windowClass: 'add-appointment-details'
    });
  }

  onDeleteItem() {
    this.decisionService
      .deleteNote(this.deleteId)
      .pipe(filter((res: any) => res.status === 'success'))
      .subscribe(_ => {
        this.deficiencyCommentsData = this.deficiencyCommentsData.filter(
          (item: any) => item.note_id !== this.deleteId
        );
        this.internalCommentsData = this.internalCommentsData.filter(
          (item: any) => item.note_id !== this.deleteId
        );
        this.deficiencyCommentsData = [...this.deficiencyCommentsData];
        this.internalCommentsData = [...this.internalCommentsData];
        this.closePopup();
        this.alertService.success("Note Deleted Successfully.");
      });
  }

  closePopup() {
    this.modalService.dismissAll();
  }
  OnendPathwayChange(value: any) {
    void value;
    const licensesArray = this.licenseForm.get('licenses') as FormArray;

    licensesArray.controls.forEach((licenseGroup: AbstractControl) => {
      const lictype = licenseGroup.get('licenseType');
      const effectiveDate1 = licenseGroup.get('effectiveDate');
      const endorsementsArray = licenseGroup.get('endorsements') as FormArray;

      endorsementsArray.controls.forEach((endorsementGroup: AbstractControl) => {
        const pathwayValue = endorsementGroup.get('pathway')?.value;
        const isDnqPathway = this.isDnqPathwayValue(pathwayValue);

        const endorsement1 = endorsementGroup.get('endorsement');
        const grade = endorsementGroup.get('grade');
        const originalEffectiveDate = endorsementGroup.get('originalEffectiveDate');
        const effectiveDate = endorsementGroup.get('effectiveDate');
        const expirationDate = endorsementGroup.get('expirationDate');

        if (isDnqPathway) {
          lictype?.clearValidators();
          effectiveDate1?.clearValidators();
          endorsement1?.clearValidators();
          // grade?.clearValidators();
          originalEffectiveDate?.clearValidators();
          effectiveDate?.clearValidators();
          expirationDate?.clearValidators();
        } else {

          endorsement1?.setValidators(Validators.required);
          // grade?.setValidators(Validators.required);
          originalEffectiveDate?.setValidators(Validators.required);
          effectiveDate?.setValidators([
            Validators.required,
            this.strictUsDateValidator.bind(this)
          ]);
          expirationDate?.setValidators(Validators.required);
          this.licenseForm.get('dnqdescription')?.patchValue(null);
        }

        lictype?.updateValueAndValidity();
        effectiveDate1?.updateValueAndValidity();
        endorsement1?.updateValueAndValidity();
        grade?.updateValueAndValidity();
        originalEffectiveDate?.updateValueAndValidity();
        effectiveDate?.updateValueAndValidity();
        expirationDate?.updateValueAndValidity();
      });
    });
    this.updateDnqCommunicationVisibility();
    this.applyAdditionalPaymentPathwayLocks();
  }

  isPathwaySeven(licenseIndex: number, endorsementIndex: number): boolean {
    const endorsements = (this.licenseForm.get('licenses') as FormArray)
      .at(licenseIndex)
      .get('endorsements') as FormArray;

    const pathwayValue = endorsements?.at(endorsementIndex)?.get('pathway')?.value;
    return this.isDnqPathwayValue(pathwayValue);
  }

  bindAddTypeChange(): void {
    this.prolicreqForm.get('type')?.valueChanges.subscribe((selectedType: string) => {

      this.prolicreqForm.get('source')?.reset();

      if (selectedType === 'License Kind') {
        this.sortedLicenseKindData = this.lickindProvisionData.map((opt: any) => ({ ...opt, key: opt.key.toString() }));
        this.sourceOptions = this.sortedLicenseKindData;
      }
      else if (selectedType === 'Endorsement') {
        this.sourceOptions = this.endorsementProvisionData;
      }
      else {
        this.sourceOptions = [];
      }

    });
  }
  bindEditTypeChange(): void {
    this.editprolicreqForm.get('type')?.valueChanges.subscribe((selectedType: string) => {

      this.editprolicreqForm.get('source')?.setValue(null);
      this.editSourceOptions = [];

      if (selectedType === 'License Kind') {
        this.editSourceOptions = [...this.lickindProvisionData.map((opt: any) => ({ ...opt, key: opt.key.toString() }))];
      }
      else if (selectedType === 'Endorsement') {
        this.editSourceOptions = [...this.endorsementProvisionData];
      }

    });
  }

  bindProvisionCategoryChange(): void {
    this.prolickindForm.get('category')?.valueChanges.subscribe((selectedCategory: string) => {
      if (selectedCategory === 'License Kind') {
        this.provisionSourceOptions = this.lickindProvisionData;
      } else if (selectedCategory === 'Endorsement') {
        this.provisionSourceOptions = this.endorsementProvisionData;
      } else {
        this.provisionSourceOptions = [];
      }
    });
  }

  private getMinimumRequirementDueDate(selectedSourceIds: any[], type?: any, existingDueDate?: any): string {
    const normalizedSourceIds = (selectedSourceIds ?? []).map((id: any) => id?.toString());
    if ((type?.value ?? type) == 'License Kind') {
      const matchingLicenses = this.licenseForm.value.licenses.filter((license: any) =>
        normalizedSourceIds.includes(this.licensekindKey(license.licenseKind)?.toString())
      );

      const validExpirationDates = matchingLicenses
        .map((license: any) => license?.expirationDate)
        .filter((date: any) => date && moment(date).isValid())
        .map((date: any) => moment(date));

      if (existingDueDate && moment(existingDueDate, 'MM/DD/YYYY', true).isValid()) {
        validExpirationDates.push(moment(existingDueDate, 'MM/DD/YYYY', true));
      }

      const earliestExpirationDate = validExpirationDates.length
        ? moment.min(validExpirationDates)
        : null;

      return earliestExpirationDate?.isValid()
        ? earliestExpirationDate.format('MM/DD/YYYY')
        : '';
    }
    else {
      let validExpirationDates: any[] = [];
      validExpirationDates = this.licenseForm.value.licenses
        .flatMap((license: any) =>
          (license.endorsements || [])
            .filter((endo: any) =>
              normalizedSourceIds.includes(endo.endorsement)
            )
            .map((endo: any) => endo?.expirationDate)
        )
        .filter((date: any) =>
          date && moment(date, 'MM/DD/YYYY', true).isValid()
        )
        .map((date: any) => moment(date, 'MM/DD/YYYY', true));

      if (existingDueDate && moment(existingDueDate, 'MM/DD/YYYY', true).isValid()) {
        validExpirationDates.push(moment(existingDueDate, 'MM/DD/YYYY', true));
      }

      const earliestExpirationDate = validExpirationDates.length
        ? moment.min(validExpirationDates)
        : null;

      return earliestExpirationDate?.isValid()
        ? earliestExpirationDate.format('MM/DD/YYYY')
        : '';


    }
  }

  onSourceChange(event: any, type: any) {
    console.log(type);
    if (event?.value?.length > 0) {
      const formattedDate = this.getMinimumRequirementDueDate(event.value, type.value);
      this.lastSystemReqDueDate = formattedDate;
      this.prolicreqForm.controls['reqdueDate'].patchValue(formattedDate);
    }
    else {
      this.lastSystemReqDueDate = '';
      this.prolicreqForm.controls['reqdueDate'].patchValue('');
    }
  }

  onEditSourceChange(event: any): void {
    const selectedSourceIds = (event?.value ?? []).map((id: any) => id?.toString());
    const selectedType = this.editprolicreqForm.get('type')?.value;
    const shouldIncludeOriginalDueDate = selectedSourceIds.some((id: string) =>
      this.originalEditRequirementSourceIds.includes(id)
    );
    const formattedDate = this.getMinimumRequirementDueDate(
      selectedSourceIds,
      selectedType,
      shouldIncludeOriginalDueDate ? this.originalEditRequirementDueDate : null
    );
    this.editprolicreqForm.controls['reqdueDate'].patchValue(formattedDate);
  }


  checkReadOnlyModeToHidePreviousNextButton() {
    let appMode = JSON.parse(this.sessionStorage.getItem('applicationmode'));
    let appStatus = JSON.parse(this.sessionStorage.getItem('applicationStatus'));
    let currApplicationType = JSON.parse(this.sessionStorage.getItem('currApplicationType'));
    const userRoleIdRaw = this.sessionStorage.getItem('role_id'); // string from storage
    const userRoleId = Number(userRoleIdRaw); // normalize to number
    let isReadOnlyMode = false;
    if (appMode === 'view') {
      isReadOnlyMode = true;

    } else if (currApplicationType === 'License Extension') {
      isReadOnlyMode = true;
    } else {
      const allowedStatuses = [
        'In Progress, Not Submitted',
        'DEFICIENT',
        'Deficiency',
        'Deficiency + BG Denied',
        'Deficiency Pending + BG Pending',
        'Deficiency Pending + BG Approved',
        'Deficiency Pending'
      ];
      const appStatusTrimmed = appStatus ? appStatus.trim() : '';
      if (appStatusTrimmed && !allowedStatuses.includes(appStatusTrimmed) && userRoleId === 405) {
        isReadOnlyMode = true;
      } else {
        isReadOnlyMode = false;
      }
    }
    if (isReadOnlyMode) {
      this.hidePreviousNextButtons = true;
    }
  }

  getLicKindDeletedProvisions(): Promise<void> {
    return new Promise((resolve, reject) => {
      const application_id = JSON.parse(this.sessionStorage.getItem('applicationID'));
      this.decisionService.getLicKindProvisions(application_id).subscribe({
        next: (data) => {
          resolve();
          console.log(data.data);
          this.licKindProvisionRows = data?.data?.data
            ?.filter((item: any) => item.cd_license_kind != null)
            .map((item: any) => ({
              provlicenseKindId: item.cd_license_kind,
              provlicenseKind: item.cd_license_kind
                ?.map((id: number) => this.licensekindName(id.toString()))
                .join(', '),
              provision: this.licenseKindProvName(item.cd_license_provision.toString()),
              dueDate: item?.license_due_date ? new Date(item.license_due_date) : null,
              additionalText: item.license_additional_text,
              lickind_id: item.license_end_provision_id,
              resolvedDate: item?.resolved_date ? new Date(item.resolved_date) : null,
              resolutionNotes: item?.resolution_notes || '',
              cd_satus: item?.cd_satus || '',
              provision_status: item?.provision_status || '',
              resolution_requested: !!item?.resolution_requested,
              mark_resolved_flag: item?.mark_resolved_flag ?? null,
              _original_mark_resolved_flag: item?.mark_resolved_flag ?? null,
               updatedBy: item?.name || ''
            }))
          if (this.licKindProvisionRows?.length > 0) {
            const provisionSet = new Set(
              this.licKindProvisionRows.map(a2 => a2.provision)
            );

            this.lickindProvTypedata = this.lickindProvTypedataCopy.filter(a1 =>
              !provisionSet.has(a1.value)
            );
            // const matchedArray = this.lickindProvTypedata.filter(a1 =>
            //   this.licKindProvisionRows?.some(a2 => this.licenseKindProvKey(a2.provision) != a1.key)
            // );
            // this.lickindProvTypedata = matchedArray;
          }
          else {
            this.lickindProvTypedata = this.lickindProvTypedataCopy;
          }
          this.updateCombinedProvisionRows();

        },
        error: (error) => {
          console.error('Error getting person data:', error);
          reject(error);
        }
      });
    });
  }
  getLicEndoDeletedProvisions(): Promise<void> {
    return new Promise((resolve, reject) => {
      const application_id = JSON.parse(this.sessionStorage.getItem('applicationID'));
      this.decisionService.getLicEndoProvisions(application_id).subscribe({
        next: (data) => {
          resolve();
          console.log(data.data);
          this.licEndoProvisionRows = data?.data?.data
            ?.filter((item: any) => item.cd_endoresement != null)
            .map((item: any) => ({
              provendoId: item.cd_endoresement,
              provendorsement: item.cd_endoresement
                ?.map((id: number) => this.licenseEndoName(id.toString()))
                .join(', '),
              provision: this.licenseEndoProvName(item?.cd_endor_provision.toString()),
              dueDate: item?.endorsement_due_date ? new Date(item.endorsement_due_date) : null,
              additionalText: item.endorsement_additional_text,
              lickind_id: item.license_end_provision_id,
              resolvedDate: item?.resolved_date ? new Date(item.resolved_date) : null,
              resolutionNotes: item?.resolution_notes || '',
              cd_satus: item?.cd_satus || '',
              provision_status: item?.provision_status || '',
              resolution_requested: !!item?.resolution_requested,
              mark_resolved_flag: item?.mark_resolved_flag ?? null,
              _original_mark_resolved_flag: item?.mark_resolved_flag ?? null,
                updatedBy: item?.name || ''
            }))

          if (this.licEndoProvisionRows?.length > 0) {
            const provisionSet = new Set(
              this.licEndoProvisionRows.map(a2 => a2.provision)
            );

            this.licendoProvTypedata = this.licendoProvTypedataCopy.filter(a1 =>
              !provisionSet.has(a1.value)
            );

          }
          else {
            this.licendoProvTypedata = this.licendoProvTypedataCopy;
          }
          this.updateCombinedProvisionRows();

        },
        error: (error) => {
          console.error('Error getting person data:', error);
          reject(error);
        }
      });
    });
  }

  loadLicenseDatesByPersonId(): Promise<void> {
    const persondata = JSON.parse(this.sessionStorage.getItem('personData'));
    return new Promise((resolve, reject) => {
      this.decisionService.getLicenseDatesByPersonId(persondata?.person_id).subscribe({
        next: (data) => {
          resolve();
          console.log(data.data);
          // this.licenses.value[0].endorsements[0].originalEffectiveDate = '05/22/2026'; // data.data.data[0].issue_date ;
          //  if (data?.data?.data?.length === this.licenses?.value?.length) {
          const apiList = data?.data?.data || [];
          this.licenses.controls.forEach((control) => {
            const licenseGroup = control as FormGroup;
            const endorsementsArray = licenseGroup.get('endorsements') as FormArray;
            endorsementsArray.controls.forEach((endorsementControl) => {
              const endorsementGroup = endorsementControl as FormGroup;
              const formEndorsement = endorsementGroup.get('endorsement')?.value;
              const matched = apiList.find(
                (item: any) => item.cd_endorsement === formEndorsement
              );
              const formattedIssueDate = this.formatToMMDDYYYY(matched?.end_original_issue_date);
              if (matched && formattedIssueDate) {
                endorsementGroup.get('originalEffectiveDate')
                  ?.patchValue(formattedIssueDate);
              }
            });
          });
          // }

        },
        error: (error) => {
          console.error('Error getting person data:', error);
          reject(error);
        }
      });
    });
  }

  formatToMMDDYYYY(dateStr: string | null | undefined): string | null {
    if (!dateStr) return null;
    const cleanDate = dateStr.includes('T') ? dateStr.split('T')[0] : dateStr;
    const [year, month, day] = cleanDate.split('-');
    return `${month}/${day}/${year}`;
  }

  onEditordnqdescriptionInit(event: any) {
    const quill = event.editor;
    const value = this.licenseForm.get('dnqdescription')?.value;
    if (value) {
      quill.root.innerHTML = value;
    }
  }

  endroseflowgetlicenseFormValues(): Promise<void> {
    const persondataval = JSON.parse(this.sessionStorage.getItem('personData'));
    return new Promise((resolve, reject) => {
      this.decisionService.getLicenseByPersonId(persondataval.person_id).subscribe({
        next: (res) => {
          resolve();
          const licenses = res?.data?.data || [];
          this.patchmergeLicenses(licenses);
        },
        error: (error) => {
          console.error('Error getting license data:', error);
          reject(error);
        }
      });
    });
  }

  getlicenseFormValues(): Promise<void> {
    const application_id = JSON.parse(this.sessionStorage.getItem('applicationID'));
    return new Promise((resolve, reject) => {
      this.decisionService.getLicenseByApplicationId(application_id).subscribe({
        next: (res) => {
          resolve();
          const licenses = res?.data?.data || [];
          const LicensePathName = JSON.parse(this.sessionStorage.getItem('navigationData')).bannerheader['License Path'];
          if (LicensePathName != 'Initial') {
            this.getFilteredLicenseKindProvision1(licenses)
          }
          this.patchLicenses(licenses);
          this.loadLicenseDatesByPersonId();

        },
        error: (error) => {
          console.error('Error getting license data:', error);
          reject(error);
        }
      });
    });
  }

  // Resolve flow: prefill from the person's existing license (like Add Endorsement),
  // but only make Original Effective Date read-only.
  resolveFlowGetLicenseFormValues(): Promise<void> {
    const persondataval = JSON.parse(this.sessionStorage.getItem('personData'));
    return new Promise((resolve, reject) => {
      this.decisionService.getLicenseByPersonId(persondataval.person_id).subscribe({
        next: (res) => {
          resolve();
          const licenses = res?.data?.data || [];
          this.patchmergeLicensesForResolve(licenses);
        },
        error: (error) => {
          console.error('Error getting license data:', error);
          reject(error);
        }
      });
    });
  }

  // Same merging logic as patchmergeLicenses but only disables originalEffectiveDate
  // instead of the full set of date/type/pathway controls.
  patchmergeLicensesForResolve(data: any[]) {
    const formArray = this.licenses;
    formArray.clear();

    const mergedLicenses = this.mergeLicenseSources(data || []);
    mergedLicenses.forEach((item, index) => {
      formArray.push(this.createLicenseGroupNew(item));
      this.loadEndorsementsForRow(index, item.cd_license_kind);
    });

    this.disableOriginalEffectiveDateForAllEndorsements();

    if (this.isViewMode) {
      this.disableAllForms();
    }
    this.applyAdditionalPaymentPathwayLocks();
  }


  createLicenseGroupNew(data?: any): FormGroup {
    return this.fb.group({
      licenseKind: [this.licensekindName(data?.cd_license_kind?.toString()) || null],
      licenseType: [data?.cd_license_type || null, Validators.required],
      effectiveDate: [
        data.issue_date ? moment(data.issue_date).format('MM/DD/YYYY') : moment(this.today).format('MM/DD/YYYY'),
        [Validators.required, this.strictUsDateValidator.bind(this)]
      ],
      expirationDate:
        [
          data.expiry_date ? moment(data.expiry_date).format('MM/DD/YYYY') : '',
          [Validators.required, this.strictUsDateValidator.bind(this)]
        ],
      endorsements: this.fb.array(
        (data ? [this.createEndorsementGroupNew(data)] : [])
      )
    });
  }

  createEndorsementGroupNew(data?: any): FormGroup {
    return this.fb.group({
      endorsement: [data?.cd_endorsement || null, Validators.required],
      pathway: [data?.endorsement_pathway || null, Validators.required],
      is_new: [this.resolveIsNewFlag(data)],
      originalEffectiveDate: [
        data?.originalEffectiveDate ? moment(data?.originalEffectiveDate).format('MM/DD/YYYY') : moment(this.today).format('MM/DD/YYYY'),
        [Validators.required, this.strictUsDateValidator.bind(this)]
      ],
      effectiveDate:
        [
          data.end_issue_date ? moment(data.end_issue_date).format('MM/DD/YYYY') : moment(this.today).format('MM/DD/YYYY'),
          [Validators.required, this.strictUsDateValidator.bind(this)]
        ],
      expirationDate:
        [
          data.end_expiry_date ? moment(data.end_expiry_date).format('MM/DD/YYYY') : '',
          [Validators.required, this.strictUsDateValidator.bind(this)]
        ],
    });
  }


  private getResponseLicenses(): any[] {
    return Array.isArray(this.responsevalue?.license) ? this.responsevalue.license : [];
  }

  private mergeLicenseSources(apiLicenses: any[] = []): any[] {
    const responseLicenses = this.getResponseLicenses();
    const mergedByKey = new Map<string, any>();

    const latestApi = apiLicenses.reduce((latest, curr) => {
      if (!curr?.license_generated_date) return latest;

      return (!latest || new Date(curr.license_generated_date) > new Date(latest.license_generated_date))
        ? curr
        : latest;
    }, null);

    responseLicenses.forEach((item: any) => {
      if (!item) return;
      const key = `${item.cd_license_kind ?? ''}_${item.cd_endorsement ?? ''}`;
      const existing = mergedByKey.get(key) || {};
      mergedByKey.set(key, {
        ...existing,
        ...item,
        _fromApi: false
      });
    });

    apiLicenses.forEach((item: any) => {
      if (!item) return;
      const key = `${item.cd_license_kind ?? ''}_${item.cd_endorsement ?? ''}`;
      const existing = mergedByKey.get(key) || {};
      mergedByKey.set(key, { ...existing, ...item, _fromApi: true });
    });

    return Array.from(mergedByKey.values());
  }


  patchmergeLicenses(data: any[]) {
    const formArray = this.licenses;
    formArray.clear();

    const mergedLicenses = this.mergeLicenseSources(data || []);
    mergedLicenses.forEach((item, index) => {
      formArray.push(this.createLicenseGroupNew(item));
      if (item._fromApi) {
        this.disableDateColumnsForLicense(index);
      }
      this.loadEndorsementsForRow(index, item.cd_license_kind);
    });
    if (this.isViewMode) {
      this.disableAllForms();
    }
    this.applyAdditionalPaymentPathwayLocks();
  }

  /**
   * Disable date controls (originalEffectiveDate, effectiveDate, expirationDate) for all endorsements in a license
   * Prefill originalEffectiveDate with license's effectiveDate
   * This makes them read-only while displaying prefilled values
   */
  private disableDateColumnsForLicense(licenseIndex: number): void {
    const licensesArray = this.licenseForm.get('licenses') as FormArray;
    const licenseGroup = licensesArray.at(licenseIndex) as FormGroup;

    // Get license-level date controls
    const licenseEffectiveDateControl = licenseGroup.get('effectiveDate');
    const licenseExpirationDateControl = licenseGroup.get('expirationDate');
    const licensetypeControl = licenseGroup.get('licenseType');

    // Disable license-level date controls to make them read-only
    if (licenseEffectiveDateControl) {
      licenseEffectiveDateControl.disable({ emitEvent: false });
    }
    if (licenseExpirationDateControl) {
      licenseExpirationDateControl.disable({ emitEvent: false });
    }
    if (licensetypeControl) {
      licensetypeControl.disable({ emitEvent: false });
    }

    const endorsementsArray = licenseGroup.get('endorsements') as FormArray;

    if (!endorsementsArray) {
      return;
    }

    // Get the license effective date to prefill endorsement original effective date
    const licenseEffectiveDate = licenseEffectiveDateControl?.value;

    endorsementsArray.controls.forEach((endorsementControl: AbstractControl) => {
      const endorsementGroup = endorsementControl as FormGroup;
      const endorsementValueControl = endorsementGroup.get('endorsement');
      const pathwayControl = endorsementGroup.get('pathway');
      const originalEffectiveDateControl = endorsementGroup.get('originalEffectiveDate');
      const effectiveDateControl = endorsementGroup.get('effectiveDate');
      const expirationDateControl = endorsementGroup.get('expirationDate');

      // Prefill originalEffectiveDate with license effective date
      if (originalEffectiveDateControl && licenseEffectiveDate) {
        originalEffectiveDateControl.patchValue(licenseEffectiveDate, { emitEvent: false });
      }

      // Disable endorsement selectors for merged API licenses.
      if (endorsementValueControl) {
        endorsementValueControl.disable({ emitEvent: false });
      }
      if (pathwayControl) {
        pathwayControl.disable({ emitEvent: false });
      }

      // Disable all endorsement date controls to make them read-only
      if (originalEffectiveDateControl) {
        originalEffectiveDateControl.disable({ emitEvent: false });
      }
      if (effectiveDateControl) {
        effectiveDateControl.disable({ emitEvent: false });
      }
      if (expirationDateControl) {
        expirationDateControl.disable({ emitEvent: false });
      }
    });
  }

  patchLicenses(data: any[]) {
    const formArray = this.licenses;
    formArray.clear();
    data?.forEach((item, index) => {
      formArray.push(this.createLicenseGroupNew(item));
      this.loadEndorsementsForRow(index, item.cd_license_kind);
    });

    // For Resolve app type, make originalEffectiveDate read-only
    if (this.application_type === 'Resolve') {
      this.disableOriginalEffectiveDateForAllEndorsements();
    }

    if (this.isViewMode) {
      this.disableAllForms();
    }
    this.applyAdditionalPaymentPathwayLocks();
  }

  /**
   * Disable originalEffectiveDate for all endorsements (used for Resolve app type)
   */
  private disableOriginalEffectiveDateForAllEndorsements(): void {
    const licensesArray = this.licenseForm.get('licenses') as FormArray;
    if (!licensesArray) return;

    licensesArray.controls.forEach((licenseControl: AbstractControl) => {
      const licenseGroup = licenseControl as FormGroup;
      const endorsementsArray = licenseGroup.get('endorsements') as FormArray;

      if (!endorsementsArray) return;

      endorsementsArray.controls.forEach((endorsementControl: AbstractControl) => {
        const endorsementGroup = endorsementControl as FormGroup;
        const originalEffectiveDateControl = endorsementGroup.get('originalEffectiveDate');

        if (originalEffectiveDateControl) {
          originalEffectiveDateControl.disable({ emitEvent: false });
        }
      });
    });
  }

  private isApprovedOrPartiallyApprovedSelected(): boolean {
    const selectedStatusLabel = this.getSelectedStatusLabelLowerCase();
    return (
      selectedStatusLabel === 'approved' ||
      selectedStatusLabel === 'partially approved'
    );
  }



  async patchValuetoApplicationStatusandAPICall() {
    const dnqDesc = this.licenseForm?.get('dnqdescription')?.value;
    // if (this.licenses?.length === 1 && this.licensePathName === 'Initial' && this.showDnqCommunication && dnqDesc?.toString().trim().length > 0) {
    const endorsements = (this.licenseForm?.getRawValue()?.licenses || [])
      .flatMap((l: any) => l.endorsements || []);
    const allDNQ = endorsements.every((e: any) => String(e.pathway) === '7');
    const allNonDNQ = endorsements.every((e: any) => String(e.pathway) !== '7');
    const anyDNQ = endorsements.some((e: any) => String(e.pathway) === '7');
    //  Analyst Denied patch to application status
    if (allDNQ) {
      await this.adddecisionForm.patchValue(
        { applicationStatus: '21' },
        { emitEvent: false }
      );

      const selectedStatus = this.applicationStatusData.find(
        (item: any) => String(item?.key) === '21'
      );

      this.statusval = selectedStatus?.value;
      await this.modalStatusConfirm('confirm');
    }
    // More than one endorsement with at least one DNQ pathway (== 7), but not all -> partial status
    else if (endorsements.length > 1 && anyDNQ) {
      await this.adddecisionForm.patchValue(
        { applicationStatus: '40' },
        { emitEvent: false }
      );

      const selectedStatus = this.applicationStatusData.find(
        (item: any) => String(item?.key) === '40'
      );

      this.statusval = selectedStatus?.value;
      //await this.modalStatusConfirm('confirm');
    }
    else if (allNonDNQ) {
      await this.adddecisionForm.patchValue(
        { applicationStatus: '9' },
        { emitEvent: false }
      );

      const selectedStatus = this.applicationStatusData.find(
        (item: any) => String(item?.key) === '9'
      );

      this.statusval = selectedStatus?.value;
      //await this.modalStatusConfirm('confirm');
    }
    else {
      await this.adddecisionForm.patchValue(
        { applicationStatus: '' },
        { emitEvent: false }
      );
      this.statusval = ''
    }
  }

  getSelectLabel(key: any, options: any[]): string {
    if (!key) return '';

    const found = options?.find(o => o.key === key);
    if (!found?.value) return '';

    const trimmedLabel = found.value.trim();
    const wordCount = trimmedLabel.split(/\s+/).length;
    const charCount = trimmedLabel.length;

    return (charCount > 45) ? found.value : '';
  }

  async updateIsPublishedLicense(): Promise<void> {
    const application_id = JSON.parse(this.sessionStorage.getItem('applicationID'));
    return new Promise((resolve, reject) => {
      this.decisionService.updatePublishLicenseByAppId(application_id).subscribe({
        next: (res) => {
          resolve();
          // const licenses = res?.data?.data || [];
          // this.patchLicenses(licenses);
          //this.loadLicenseDatesByPersonId();

        },
        error: (error) => {
          console.error('Error getting license data:', error);
          reject(error);
        }
      });
    });
  }

  getProvisionLabel(): string {
    const key = this.editprolicendoForm.get('endoprovision')?.value;
    const match = this.licendoProvTypedataCopy?.find(item => item.key === key);
    return match?.value ?? '';
  }

  getLickindProvisionLabel(): string {
    const key = this.editprolickindForm.get('lickindprovision')?.value;
    const match = this.lickindProvTypedataCopy?.find(item => item.key === key);
    return match?.value ?? '';
  }


  hasAnyEndorsementExpirationDate(i: number): boolean {
    return this.endorsements(i).controls.some(e => !!e.get('expirationDate')?.value);
  }

  async checkValidationStatusForDeficiency(appType?: string): Promise<any> {

    const application_id = JSON.parse(this.sessionStorage.getItem('applicationID'));

    const payload = {
      application_id,
      appType
    };
    return new Promise((resolve, reject) => {

      this.decisionService.getValidationStatusForDeficicency(payload).subscribe({
        next: async (res) => {
          if (res && res.data && res.data.success) {
            if (res.data.isValidated) {
              await this.adddecisionForm.patchValue(
                { applicationStatus: '19'},
                { emitEvent: false }
              );
              // this.alertService.error(
              //   'Status cannot be updated to Deficiency. There are no unresolved deficiencies.'
              // );
            } else {
              this.showStatusModal = true;
            }
          }
          resolve(res);
        },
        error: (err) => {
          console.error(err);
          reject(err);
        }
      });
    });
  }

  private removeRegisteredApprenticeEndorsement(options: any[] = []): any[] {
    return (options || []).filter((option: any) => {
      const id = option?.id;
      return id !== 3149;
    });
  }

  disableAllForms(): void {
    this.prolickindForm.disable();
    this.prolicendoForm.disable();
    this.editprolickindForm.disable();
    this.editprolicendoForm.disable();
    this.prolicreqForm.disable();
    this.editprolicreqForm.disable();
    this.adddecisionForm.disable();
    this.licenseForm.disable();
  }
  private sendInAppNotification(
    userId: number,
    provision: string,
  ): void {
    const payload = {
      priority: 'High',
      message: `We have received new test records. The following provision(s) have been automatically resolved ${provision}.`,
      actionurl: '',
      userid: userId,
      roleid: '',
      customformid: 1,
      isnew: true,
      isactive: true
    };

    this.decisionService
      .notifiction(payload)
      .pipe(take(1), takeUntil(this.destroy$))
      .subscribe({
        next: (res: any) => {
          if (!res.data.success) {
            console.error(
              `Error while sending notification for user ${userId}`
            );
          }
        },
        error: (err) => {
          console.error(
            `Error sending notification for user ${userId}:`,
            err
          );
        }
      });
  }

  private sendLicenseUpdateNotification(): void {
    const persondata = JSON.parse(this.sessionStorage.getItem('personData'));
    const userId = persondata?.person_id;
    if (!userId) return;

    const payload = {
      priority: 'High',
      message: 'License Update. Your license has been updated. View the updated details on your Dashboard.',
      actionurl: '',
      userid: userId,
      roleid: '',
      customformid: 1,
      isnew: true,
      isactive: true
    };

    this.decisionService
      .notifiction(payload)
      .pipe(take(1), takeUntil(this.destroy$))
      .subscribe({
        next: (res: any) => {
          if (!res.data.success) {
            console.error(`Error while sending license update notification for user ${userId}`);
          }
        },
        error: (err) => {
          console.error(`Error sending license update notification for user ${userId}:`, err);
        }
      });
  }

  loadDeficicencyDocuments(): Promise<void> {
    return new Promise((resolve, reject) => {
      const application_id = JSON.parse(this.sessionStorage.getItem('applicationID'));
      this.decisionService.getDeficicencyDocuments(application_id).subscribe({
        next: (data) => {
          const sectionMap: { [key: number]: string } = {
            3488: 'Education Information',
            3522: 'Work Experience',
            3563: 'License Details',
            3564: 'Personal Information',
            3738: 'Professional Development'
          };
          const rows = Array.isArray(data?.data?.document) ? data.data.document : [];
          this.documentDeficiencyCommentsData = rows.filter((item: any) => item.document_notes).map((item: any) => ({
            deficiency_type: (item.section_name + ' - Document') || '',
            created_by: item?.created_by_name || '',
            created_date: item?.created_date ? new Date(item.created_date) : null,
            note_text: item.document_notes,
            review_status: item.status || '-',
            applicationId: item?.application_id,
            note_id: item.document_id,
            tab_name: sectionMap[item.formid],
            type: 'Document Deficiency'
          }));
          this.deficiencyCommentsData.push(...this.documentDeficiencyCommentsData);
          this.deficiencyCommentsData = this.deficiencyCommentsData.sort((a, b) => (b.created_date?.getTime() || 0) - (a.created_date?.getTime() || 0));
          resolve();
        },
        error: (error) => {
          console.error('Error getting person data:', error);
          reject(error);
        }
      });
    });
  }

  getFilteredRequirementOptions(selectedType: string, excludeId?: any): any[] {
    if (!selectedType) {
      return this.licrequirementsData;
    }

    const usedKeys = new Set(
      (this.licenseRequirementRows || [])
        .filter((row: any) => row.type === selectedType && row.lickind_id !== excludeId)
        .map((row: any) => this.Requirementskey(row.requirement)?.toString())
    );

    return this.licrequirementsData.filter(
      (item: any) => !usedKeys.has(item.key?.toString())
    );
  }

  onEndoExpdateGet(value: any, val: any) {
    const selectedEndorsements = Array.isArray(value?.value)
      ? value.value
      : [value?.value];

    const matchedRecords = this.licenseForm
      .getRawValue()
      .licenses
      ?.flatMap(l => l.endorsements || [])
      ?.filter(e => selectedEndorsements.includes(e.endorsement));

    if (matchedRecords.length) {
      const minExpirationDate = matchedRecords.reduce((min, current) => {
        return new Date(current.expirationDate) < new Date(min.expirationDate)
          ? current
          : min;
      });

      this.prolicendoForm.controls['endodueDate'].patchValue(
        moment(minExpirationDate.expirationDate).format('MM/DD/YYYY')
      );
    } else {
      this.prolicendoForm.controls['endodueDate'].setValue(null);
    }
  }

  onEditEndoExpdateGet(value: any, val: any) {
    const selectedEndorsements = Array.isArray(value?.value)
      ? value.value
      : [value?.value];

    const matchedRecords = this.licenseForm
      .getRawValue()
      .licenses
      ?.flatMap(l => l.endorsements || [])
      ?.filter(e => selectedEndorsements.includes(e.endorsement));

    if (matchedRecords.length) {
      const minExpirationDate = matchedRecords.reduce((min, current) => {
        return new Date(current.expirationDate) < new Date(min.expirationDate)
          ? current
          : min;
      });

      const formattedDate = moment(minExpirationDate.expirationDate).format('MM/DD/YYYY');
      this.lastSystemEndoDueDate = formattedDate;
      this.editprolicendoForm.controls['endodueDate'].patchValue(formattedDate);
    } else {
      this.lastSystemEndoDueDate = null;
      this.editprolicendoForm.controls['endodueDate'].setValue(null);
    }
  }

  // ==================== Resolve Provisions (Approve/Deny) ====================

  shouldShowApproveResolution(gridItem: any): boolean {
    return gridItem?.resolution_requested === true && gridItem?.mark_resolved_flag !== true;
  }

  shouldShowDenyResolution(gridItem: any): boolean {
    return gridItem?.resolution_requested === true && gridItem?.mark_resolved_flag !== false;
  }

  shouldShowViewResolutionNotes(gridItem: any): boolean {
    const notes = gridItem?.resolutionNotes;
    return !!notes && String(notes).trim().length > 0;
  }

  hasUnresolvedRequests(): boolean {
    const provUnresolved = this.combinedProvisionRows?.some(item =>
      item?.resolution_requested === true && item?.mark_resolved_flag === null
    ) || false;
    const reqUnresolved = this.licenseRequirementRows?.some(item =>
      item?.resolution_requested === true && item?.mark_resolved_flag === null
    ) || false;
    return provUnresolved || reqUnresolved;
  }

  onApproveResolution(data: any, approveResolutionModel: any) {
    const rowData = data.data;
    this.resolutionRowData = rowData;
    this.resolutionEditId = rowData.lickind_id;
    this.resolutionProvisionValue = rowData.provision || '';
    this.modalref = this.modalService.open(approveResolutionModel, {
      size: 'md',
      centered: true,
      backdrop: 'static',
      windowClass: 'add-appointment-details'
    });
  }

  onConfirmApproveResolution() {
    const row = this.combinedProvisionRows.find(r => r.lickind_id === this.resolutionEditId);
    if (row) {
      row.mark_resolved_flag = true;
    }
    this.modalStatusClose();
    this.alertService.success('Resolution approved.');
  }

  onDenyResolution(data: any, denyResolutionModel: any) {
    const rowData = data.data;
    this.resolutionRowData = rowData;
    this.resolutionEditId = rowData.lickind_id;
    this.resolutionProvisionValue = rowData.provision || '';
    this.modalref = this.modalService.open(denyResolutionModel, {
      size: 'md',
      centered: true,
      backdrop: 'static',
      windowClass: 'add-appointment-details'
    });
  }

  onConfirmDenyResolution() {
    const row = this.combinedProvisionRows.find(r => r.lickind_id === this.resolutionEditId);
    if (row) {
      row.mark_resolved_flag = false;
    }
    this.modalStatusClose();
    this.alertService.success('Resolution denied.');
  }

  onViewResolutionNotes(data: any, viewResolutionNotesModel: any) {
    const rowData = data.data;
    this.viewResolutionNotesText = rowData.resolutionNotes || '';
    this.resolutionProvisionValue = rowData.provision || '';
    this.modalref = this.modalService.open(viewResolutionNotesModel, {
      size: 'md',
      centered: true,
      backdrop: 'static',
      windowClass: 'add-appointment-details'
    });
  }

  async saveResolutionDecisions(): Promise<void> {
    const userFromSession = JSON.parse(this.sessionStorage.getItem('user'));
    const application_id = JSON.parse(this.sessionStorage.getItem('applicationID'));
    const promises: Promise<any>[] = [];

    const changedProvRows = this.combinedProvisionRows.filter(r =>
      r.resolution_requested === true && r.mark_resolved_flag !== null && r.mark_resolved_flag !== r._original_mark_resolved_flag
    );
    for (const row of changedProvRows) {
      const obj: any = {
        license_end_provision_id: row.lickind_id,
        mark_resolved_flag: row.mark_resolved_flag,
        updated_by: userFromSession?.id,
        application_id: application_id
      };
      promises.push(this.decisionService.updateLicKindProvisions(obj).toPromise());
    }

    const changedReqRows = (this.licenseRequirementRows || []).filter(r =>
      r.resolution_requested === true && r.mark_resolved_flag !== null && r.mark_resolved_flag !== r._original_mark_resolved_flag
    );
    for (const row of changedReqRows) {
      const obj: any = {
        application_license_requirement_id: row.lickind_id,
        mark_resolved_flag: row.mark_resolved_flag,
        updated_by: userFromSession?.id,
        application_id: application_id
      };
      promises.push(this.decisionService.updateLicenseRequirements(obj).toPromise());
    }

    if (promises.length > 0) {
      await Promise.all(promises);
      // Sync originals so subsequent saves only fire on further changes
      for (const row of changedProvRows) {
        row._original_mark_resolved_flag = row.mark_resolved_flag;
      }
      for (const row of changedReqRows) {
        row._original_mark_resolved_flag = row.mark_resolved_flag;
      }
    }
  }

  updateProvisionStatusOnApproval(application_id: any): void {
    // Only process approved rows (mark_resolved_flag === true)
    // Denied rows (mark_resolved_flag === false) should remain unchanged
    const resolvedProvRows = this.combinedProvisionRows.filter(r =>
      r.resolution_requested === true && r.mark_resolved_flag === true
    );
    for (const row of resolvedProvRows) {
      const obj: any = {
        license_end_provision_id: row.lickind_id,
        resolution_requested: false,
        updated_by: this.userSessionData?.id,
        application_id: application_id,
        resolved_date: new Date().toISOString(),
        cd_satus: 'Resolved',
        provision_status: 'Resolved'
      };
      this.decisionService.updateLicKindProvisions(obj).subscribe();
    }

    const resolvedReqRows = (this.licenseRequirementRows || []).filter(r =>
      r.resolution_requested === true && r.mark_resolved_flag === true
    );
    for (const row of resolvedReqRows) {
      const obj: any = {
        application_license_requirement_id: row.lickind_id,
        resolution_requested: false,
        updated_by: this.userSessionData?.id,
        application_id: application_id,
        resolved_date: new Date().toISOString(),
        cd_status: 'Resolved',
        requirement_status: 'Resolved'
      };
      this.decisionService.updateLicenseRequirements(obj).subscribe();
    }
  }

  // ==================== License Requirements Resolution Handlers ====================

  onApproveResolutionReq(data: any, approveResolutionModel: any) {
    const rowData = data.data;
    this.resolutionRowData = rowData;
    this.resolutionEditId = rowData.lickind_id;
    this.resolutionProvisionValue = rowData.requirement || '';
    this.modalref = this.modalService.open(approveResolutionModel, {
      size: 'md',
      centered: true,
      backdrop: 'static',
      windowClass: 'add-appointment-details'
    });
  }

  onConfirmApproveResolutionReq() {
    const row = this.licenseRequirementRows.find(r => r.lickind_id === this.resolutionEditId);
    if (row) {
      row.mark_resolved_flag = true;
    }
    this.modalStatusClose();
    this.alertService.success('Resolution approved.');
  }

  onDenyResolutionReq(data: any, denyResolutionModel: any) {
    const rowData = data.data;
    this.resolutionRowData = rowData;
    this.resolutionEditId = rowData.lickind_id;
    this.resolutionProvisionValue = rowData.requirement || '';
    this.modalref = this.modalService.open(denyResolutionModel, {
      size: 'md',
      centered: true,
      backdrop: 'static',
      windowClass: 'add-appointment-details'
    });
  }

  onConfirmDenyResolutionReq() {
    const row = this.licenseRequirementRows.find(r => r.lickind_id === this.resolutionEditId);
    if (row) {
      row.mark_resolved_flag = false;
    }
    this.modalStatusClose();
    this.alertService.success('Resolution denied.');
  }

  onViewResolutionNotesReq(data: any, viewResolutionNotesModel: any) {
    const rowData = data.data;
    this.viewResolutionNotesText = rowData.resolutionNotes || '';
    this.resolutionProvisionValue = rowData.requirement || '';
    this.modalref = this.modalService.open(viewResolutionNotesModel, {
      size: 'md',
      centered: true,
      backdrop: 'static',
      windowClass: 'add-appointment-details'
    });
  }
  // proceedIntakePendingStatus(): void {
  //   const application_id = JSON.parse(this.sessionStorage.getItem('applicationID'));

  //   this.decisionService.updateEndorsementStatusChange(application_id).subscribe({
  //     next: () => {
  //       this.showIntakePendingModal = false;
  //       this.alertService.success('Status updated successfully.');
  //     },
  //     error: (error) => {
  //       console.error('Error updating endorsement status change:', error);
  //       this.alertService.error('Failed to update endorsement status.');
  //     }
  //   });
  // }

proceedIntakePendingStatus(): void {
  const applicationId = JSON.parse(this.sessionStorage.getItem('applicationID'));

  const fromStatus = this.sessionStorage.getItem('applicationStatus')
    ?.replace(/"/g, '')
    .replace(/\s+/g, ' ')
    .trim();

  const payload = {
    applicationId,
    fromStatus,
    toStatus: this.adddecisionForm.get('applicationStatus')?.value
  };

  this.decisionService.updateEndorsementStatusChange(payload).subscribe({
    next: () => {
      this.showIntakePendingModal = false;
      this.alertService.success('Status updated successfully.');
    },
    error: (error) => {
      console.error('Error updating endorsement status change:', error);
      this.alertService.error('Failed to update endorsement status.');
    }
  });
}

  cancelIntakePendingStatus(): void {
    this.showIntakePendingModal = false;
  }

  getMultiSelectLabel(keys: any[], options: any[]): string {
    if (!keys?.length) return '';

    const labels = keys
      .map(k => options?.find(o => o.key === k)?.value)
      .filter(v => !!v);

    if (!labels.length) return '';

    const joined = labels.join(', ');
    return (joined.length > 45) ? joined : '';
  }

@HostListener('window:resize')
onResize() {
  this.isWordWrapEnabled = window.innerWidth >= 945;
}

}
